(function(angular, schoolwork12) {

    'use strict';
    var angApp = angular.module(schoolwork12.app.student.name)
        .controller(
            schoolwork12.app.student.controllers.studentSearch, [
                '$rootScope',
                '$scope',
                '$http',
                'uiGridConstants',
                '$window',
                '$interval',
                '$uibModal',
                '$filter',
                '$timeout',
                schoolwork12.app.auth.services.authentication,
                schoolwork12.app.common.services.eventNotification,
                schoolwork12.app.student.services.studentAddClassroom,
                schoolwork12.app.student.services.studentAdjustAttendance,
                schoolwork12.app.student.services.studentAssignGradPlan,
                schoolwork12.app.student.services.manageStudentDataSvc,
                schoolwork12.app.student.services.studentLockCurriculum,
                schoolwork12.app.student.services.studentUnlockCurriculum,
                schoolwork12.app.student.services.studentAddPersonalGroup,
                schoolwork12.app.student.services.studentCreatePersonalGroup,
                schoolwork12.app.student.services.studentRemovePersonalGroup,
                schoolwork12.app.student.services.graduationPlanReqNameSvc,
                schoolwork12.app.student.services.manageSchoolDataSvc,
                schoolwork12.app.student.services.personalGroupSvc,
                schoolwork12.app.student.services.studentSaveSearch,
                function($rootScope, $scope, $http,
                    uiGridConstants, $window, $interval, $uibModal,
                    $filter, $timeout, authentication, eventNotification,
                    studentAddClassroom, studentAdjustAttendance, studentAssignGradPlan, manageStudentDataSvc,
                    studentLockCurriculum, studentUnlockCurriculum, studentAddPersonalGroup,
                    studentCreatePersonalGroup, studentRemovePersonalGroup, graduationPlanReqNameSvc,
                    manageSchoolDataSvc, personalGroupSvc, studentSaveSearch) {
                    console.info("In Student Search controller..");
                    eventNotification
                        .subscribe(
                            schoolwork12.app.auth.events.userLoggedIn,
                            function(event,
                                authenticatedUser) {
                                console.info('StudentSearch: Subscribe On UserLogin Event: '
                                    .concat(angular.toJson(authenticatedUser)));
                                $scope.schoollist = authenticatedUser.schools;
                                $scope.isAdmin = authentication.hasAdministratorRole();
                                $scope.isTeacher = authentication.hasTeacherRole();
                                $scope.isEnrollAdvisor = authentication.hasEnrollmentAdvisorRole();
                                // student graduation plan search access based on roles   
                                $scope.stuPlanViewRole = authentication.hasStudentGradPlanViewRole();
                                $scope.stuPlanEditRole = authentication.hasStudentGradPlanEditRole();
                                $scope.hasStudentGradPlanAccess = ($scope.stuPlanViewRole || $scope.stuPlanEditRole) ? true : false;
                                // fetch additional reqs based on grad plan role access
                                $scope.requirementNames = $scope.hasStudentGradPlanAccess ? getGradPlanRequirementNames() : '';
                                // fetch CRE fileds: part programs, current and future cte programs
                                $scope.partPrograms = getPartPrograms();
                                $scope.ctePrograms = getCurrentCtePrograms();
                                $scope.cteFuturePrograms = getFutureCtePrograms();
                                // fetch grad plan school access 
                                $scope.hasGradPlanSchoolAccess = getGradPlanSchoolAccess($scope.schoollist);
                                // fetch cre on school access 
                                $scope.hasCRETrackingSchoolAccess = getCRETrackingSchoolAccess($scope.schoollist);
                                // fetch attendance school access 
                                $scope.hasAttendanceSchoolAccess = getAttendanceSchoolAccess($scope.schoollist);
                                // fetch attendance adjuster role
                                $scope.hasAttendanceAdjusterRole = authentication.hasAttendanceAdjusterRole();
                                // data fields by Schools
                                $scope.getDataFieldsbySchools = getDataFieldsbySchools();
                                //fetch participant prog role
                                $scope.hasProgParticipantMgrRole = authentication.hasProgParticipantMgrRole(); 
                                // saved search by person ID
                                $scope.personId = authentication.getCurrentUser().personId; 
                                $scope.savedSearchbyPersonList = getSavedSearchbyPerson();
                            });


                    String.prototype.format = function(str) {
    					var args = arguments;
    					return this.replace(/{(\d+)}/g, function(match, number) { 
    					return typeof args[number] != 'undefined'
    						? args[number]
    						: match
    					;
    					});
    				};
                        
                    $scope.MessagedFieldsFilter = function (item) { 
                         return item.value==true && (item.subtype == 1 || item.subtype == 2 ||item.subtype == 3 ||item.subtype == 4 ||item.subtype == 5 ||item.subtype == 6 || item.subtype == 7); 
                    };    
                    // Get list of funding Model types
                    var getFundingModelTypes = function() {
                        manageStudentDataSvc.getFundingModelTypes(authentication.getCurrentUser().keycode)
                            .then(function(data, status, headers, config) {
                                    var typesList = data.fundingModelTypesList;
                                    if (typesList.length <= 0) {
                                        typesList = [{
                                            "name": "Oops, nothing found! "
                                        }];
                                    }
                                    $scope.fundingModelTypesList = typesList;
                                },
                                function(data, status, headers, config) {
                                    console.error("ERROR OCCURRED");
                                });
                    }

                    // Get list of saved searches by Person ID
                    var getSavedSearchbyPerson = function() {
                        manageStudentDataSvc.getSavedSearchbyPerson(authentication.getCurrentUser().keycode, $scope.personId)
                            .then(function(data, status, headers, config) {
                                    $scope.savedSearchbyPersonList = data.savedSearchOwnList;
                                    $scope.sharedSearchbyPersonList = data.savedSearchAssignedList;

                                    $scope.items = $scope.savedSearchbyPersonList;
                                    $scope.sharedItems = $scope.sharedSearchbyPersonList;

                                    //toggle state based on saved search list available 
                                    $scope.savedSearch = (($scope.savedSearchbyPersonList.length > 0) || ($scope.sharedSearchbyPersonList.length > 0)) ? "enabled" : "disabled";
                                },
                                function(data, status, headers, config) {
                                    console.error("ERROR OCCURRED");
                                });
                    }
                    
                    var getMTSSLevels = function()
                    {
                    	$http({
                            method: "GET",
                            url: schoolwork12.app.student.endpoints.getMtssLevels,
                            cache: true,
                            headers: {
                                'X-API-TOKEN': authentication
                                    .getCurrentUser().keycode,
                            }
                        })
                        .then(
                            function(response) {
                                if (response.data.length > 0) {
                                	if(!($scope.student.mtsslvls &&  
	                                    ($scope.student.mtsslvls.ELALevel || $scope.student.mtsslvls.MathLevel || $scope.student.mtsslvls.ScienceLevel ||
	                                     $scope.student.mtsslvls.HistoryLevel)))
                                     {
                                		$scope.student.mtsslvls = response.data;
                                    }
                                	
                                	$scope.student.mtsslvlsAll = response.data;
                                	console.info('mtssLvls'.concat($scope.student.mtsslvls));
                                 } 
                               }
                           , function(error) {
                            console.info('Error in getting the MTSS Levels....'.concat(angular.toJson(error)));
                            $scope.editErrorOccurred = true;
                            $scope.editErrorMesg = "";
                            if (error.status == 400) {
                                for (var j = 0; j < error.data._errors.length; j++) {
                                    $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                            }

                        });
                    }

                    var getAvailableGroups = function() {
                        personalGroupSvc.getAvailableGroups(authentication.getCurrentUser().keycode, 
                                                            authentication.getCurrentUser().identityid)
                            .then(function(data) {
                                if (data) {
                                    $scope.userPersonalGroups = $filter('orderBy')(data, 'name');
                                }                                
                            }, function(error) {
                                console.info('Error when getting available groups...'.concat(angular.toJson(error)));
                                $scope.editErrorOccurred = true;
                                $scope.editErrorMsgOccurred = true;
                                if (error.status == 400) {
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                            });
                    };
              
                    var dataFieldIdList = [];
                    $scope.hasDataFieldShown = false;
                    // Get list of dynamic data fields
                    var getDataFieldsbySchools = function() {
                    	manageSchoolDataSvc.getDataFieldsbySchools(authentication.getCurrentUser().keycode, authentication.getSchools())
                            .then(function(data, status, headers, config) {
                                    var dataFieldsList = data.dataFieldList;
                                    $scope.dataFieldListbySchools = dataFieldsList;
                                    //check if any of data fields are displayed
                                    dataFieldIdList = [];
                                    if(data.dataFieldList){
                                        for(var i = 0;  i < dataFieldsList.length; i++){
                                            if (dataFieldsList[i].value == true){
                                                $scope.hasDataFieldShown = true;
                                                dataFieldIdList.push(dataFieldsList[i].id);
                                                $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                                // console.log("check datafield list", dataFieldsList[i]);
                                            }
                                        }
                                    }
                                 //   if($scope.student.isReRegistrationChecked)  $scope.gridColumnVisibility();
                                },
                                function(data, status, headers, config) {
                                    console.error("ERROR OCCURRED");
                                });
                    }

                    var getGradPlanRequirementNames = function(){
                        var getRequirementNamePromise = null;
                        var getRequirementNameSvc = function(){
                            getRequirementNamePromise =  graduationPlanReqNameSvc.getGradPlanReqNames(authentication.getCurrentUser().keycode);
                            getRequirementNamePromise.then(function (data) {    
                                console.info("Providing list of requirement names");                                
                                $scope.requirementNames = data; 
                                $scope.requirementNames.push({name: "Any"});                              
                            }, function (error) {
                                console.info('Error in getting requirement names....'.concat(angular.toJson(error)));   
                                $scope.searchErrorOccurred = true;
                                if (error.status == 400) {
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.searchErrorMesg = $scope.searchErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                            });
                        };

                        if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
                            console.info('Keycode found. Making a call to service');
                            getRequirementNameSvc();
                        } else {
                            console.info('Key code not found. Using time out function to make a call');
                            $timeout(function () {
                            getRequirementNameSvc();
                            }, 500);
                        };

                    }

                    var getPartPrograms = function(){
                        var getPartProgramsPromise = null;
                        var getPartProgramsSvc =function(){

                            getPartProgramsPromise= graduationPlanReqNameSvc.getPartPrograms(authentication.getCurrentUser().keycode, authentication.getSchools());
                            getPartProgramsPromise.then(function(data){
                                    console.info("Providing list of participant programs");                                
                                     $scope.partPrograms = data; 
                                     $scope.partPrograms.push( {displayName: "No Participating Programs", id: "no participant programs", xschPartProgId: "no participant programs"});                    

                                }, function(error){
                                     console.info('Error in getting participant programs....'.concat(angular.toJson(error)));   
                                    $scope.searchErrorOccurred = true;
                                    if (error.status == 400) {
                                        for (var j = 0; j < error.data._errors.length; j++) {
                                            $scope.searchErrorMesg = $scope.searchErrorMesg + error.data._errors[j] + "\n";
                                        }
                                    } else if (error.status == 401 || error.status == 403) {
                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                    } else {
                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                    }
                                }
                            );
                        };
                        if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
                            console.info('Keycode found. Making a call to service');
                            getPartProgramsSvc();
                        } else {
                            console.info('Key code not found. Using time out function to make a call');
                            $timeout(function () {
                            getPartProgramsSvc();
                            }, 500);
                        };
                    }

                    var getCurrentCtePrograms = function(){
                        var getCurrentCteProgramsPromise = null;
                        var getCurrentCteProgramsSvc =function(){

                            getCurrentCteProgramsPromise= graduationPlanReqNameSvc.getCurrentCtePrograms(authentication.getCurrentUser().keycode, authentication.getSchools());
                            getCurrentCteProgramsPromise.then(function(data){
                                    console.info("Providing list of cte programs");                                
                                     $scope.ctePrograms = data; 
                                     $scope.ctePrograms.push( {displayName: "No CTE Pathway", cteId: "no cte pathway", xschcteid: "no cte pathway"});                    

                                }, function(error){
                                     console.info('Error in getting current cte programs....'.concat(angular.toJson(error)));   
                                    $scope.searchErrorOccurred = true;
                                    if (error.status == 400) {
                                        for (var j = 0; j < error.data._errors.length; j++) {
                                            $scope.searchErrorMesg = $scope.searchErrorMesg + error.data._errors[j] + "\n";
                                        }
                                    } else if (error.status == 401 || error.status == 403) {
                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                    } else {
                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                    }
                                }
                            );
                        };
                        if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
                            console.info('Keycode found. Making a call to service');
                            getCurrentCteProgramsSvc();
                        } else {
                            console.info('Key code not found. Using time out function to make a call');
                            $timeout(function () {
                            getCurrentCteProgramsSvc();
                            }, 500);
                        };
                    }

                    var getFutureCtePrograms = function(){
                        var getFutureCteProgramsPromise = null;
                        var getFutureCteProgramsSvc =function(){

                            getFutureCteProgramsPromise= graduationPlanReqNameSvc.getFutureCtePrograms(authentication.getCurrentUser().keycode, authentication.getSchools());
                            getFutureCteProgramsPromise.then(function(data){
                                    console.info("Providing list of future cte programs");                                
                                     $scope.cteFuturePrograms = data; 
                                     $scope.cteFuturePrograms.push( {displayName: "No Future CTE Pathway", cteId: "no future cte pathway", xschcteid: "no future cte pathway"});                    

                                }, function(error){
                                     console.info('Error in getting future cte programs....'.concat(angular.toJson(error)));   
                                    $scope.searchErrorOccurred = true;
                                    if (error.status == 400) {
                                        for (var j = 0; j < error.data._errors.length; j++) {
                                            $scope.searchErrorMesg = $scope.searchErrorMesg + error.data._errors[j] + "\n";
                                        }
                                    } else if (error.status == 401 || error.status == 403) {
                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                    } else {
                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                    }
                                }
                            );
                        };
                        if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
                            console.info('Keycode found. Making a call to service');
                            getFutureCteProgramsSvc();
                        } else {
                            console.info('Key code not found. Using time out function to make a call');
                            $timeout(function () {
                            getFutureCteProgramsSvc();
                            }, 500);
                        };
                    }
                    
                    var getAttendanceSchoolAccess = function(schoollist){
                        //check attendance service is turned ON
                        var hasAttendanceSchoolAccess = false;
                        for(var att = 0;  att < schoollist.length; att++){
                            if (schoollist[att].isAttendanceOn == true){
                                hasAttendanceSchoolAccess = true;
                            }
                        }
                        return hasAttendanceSchoolAccess;
                    }
                    
                     var getGradPlanSchoolAccess = function(schoollist){
                        //check grad plan service is turned ON
                        var hasGradPlanSchoolAccess = false;
                        for(var gp = 0;  gp < schoollist.length; gp++){
                            if (schoollist[gp].isGradPlanOn == true){
                                hasGradPlanSchoolAccess = true;
                            }
                        }
                        return hasGradPlanSchoolAccess;
                    }

                    var getCRETrackingSchoolAccess = function(schoollist){
                        //check cre tracking service is turned ON
                        var hasCRETrackingSchoolAccess = false;
                        for(var gp = 0;  gp < schoollist.length; gp++){
                            if (schoollist[gp].isCRETrackingOn == true){
                                hasCRETrackingSchoolAccess = true;
                            }
                        }
                        return hasCRETrackingSchoolAccess;
                    }
                    
                    if (authentication.isAuthenticated()) {
                        // school list
                        $scope.schoollist = authentication.getSchools();
                        // funding model list
                        $scope.fundingModelTypesList = getFundingModelTypes();
                        // get person Id
                        $scope.personId = authentication.getCurrentUser().personId; 
                        // saved search by person ID
                        $scope.savedSearchbyPersonList = getSavedSearchbyPerson();
                        // available personal groups for current user
                        getAvailableGroups();
                        getMTSSLevels();
                        // teacher, admin, EA roles
                        $scope.isAdmin = authentication.hasAdministratorRole();
                        $scope.isTeacher = authentication.hasTeacherRole();
                        $scope.isEnrollAdvisor = authentication.hasEnrollmentAdvisorRole();
                        // student graduation plan search access based on roles                        
                        $scope.stuPlanViewRole = authentication.hasStudentGradPlanViewRole();
                        $scope.stuPlanEditRole = authentication.hasStudentGradPlanEditRole();
                        $scope.hasStudentGradPlanAccess = ($scope.stuPlanViewRole || $scope.stuPlanEditRole) ? true : false;
                        // fetch additional reqs based on grad plan role access
                        $scope.requirementNames = $scope.hasStudentGradPlanAccess ? getGradPlanRequirementNames() : '';
                        // fetch CRE fileds: part programs, current and future cte programs
                        $scope.partPrograms = getPartPrograms();
                        $scope.ctePrograms = getCurrentCtePrograms();
                        $scope.cteFuturePrograms = getFutureCtePrograms();

                        // fetch grad plan school access 
                        $scope.hasGradPlanSchoolAccess = getGradPlanSchoolAccess($scope.schoollist);
                        // fetch cre on school access 
                        $scope.hasCRETrackingSchoolAccess = getCRETrackingSchoolAccess($scope.schoollist);
                        // fetch attendance school access 
                        $scope.hasAttendanceSchoolAccess = getAttendanceSchoolAccess($scope.schoollist);
                        // fetch attendance adjuster role
                        $scope.hasAttendanceAdjusterRole = authentication.hasAttendanceAdjusterRole();
                        // Changed it for SIS-704
                        $scope.getDataFieldsbySchools = getDataFieldsbySchools();
                    }

                    // Initialize student. Default the status to ACTIVE
                    // TODO- Check for undefined parent categories and remove this snippet
                    $scope.student = {
                        "status": "1",
                        "instrLevels": {},
                        "mtsslvls": {},
                        "mtsslvlsAll": {},
                        "demoData": {},
                        "attendance": {},
                        "gradPlan": {},
                        "strongStart": {},
                        "engagement": {},
                        "fast": {},
                        "actionNeeded": {},
                        "reReData": {},
                        "pulseCheck":{},
                        "messaged":{}
                    };

                    var studentCopy = angular.copy($scope.student);
                    $scope.gradPlanState = false;
                    $scope.savedSearchClicked = false;
                    $scope.sharedSearchSelected = false;
                    $scope.saveOrUpdateModal = false;
                    $scope.saveClicked = false;
                    $scope.selectedSearchItem = {};
        
                    // Reset flags to reset any success message that was shown before
                    $rootScope.actionCompletedSuccessfully = false;
                    $rootScope.actionCompletedSuccessfullyMessage = '';
                    $rootScope.invalidFieldsWarning = false;
                    $rootScope.invalidFieldsWarningMessage = '';

                    // Determines the Search datepickers opening and closing
                    $scope.datePickers = {
                        enrollmentDate: false,
                        schoolWithdrawalDate: false,
                        enrollmentReceivedDate: false,
                        enrollmentApprovedDate: false,
                        lastLesson: false,
                        fastRunningNoteDate: false,
                        teacherCompliancyNoteDate: false,
                        followUpActionDate: false,
                        pulseCheckDate: false,
                        lastStudentLoginDate: false,
                        lastLCLoginDate: false,
                        lastContactDate: false,
                        attendance1stDay: false,
                        attendanceLastDay: false,
                        truancyDate: false,
                        firstDayAttModified: false,
                        firstAccDate: false,
                        lastAccDate: false,
                        admicIntConDate: false,
                        gradTrackDate:false,
                        lowProgrDate:false,
                        retentConDate:false,
                        daysAbs10plusDate:false,
                        daysAbs1Date:false,
                        daysAbs2Date:false,
                        daysAbs3Date:false,
                        daysAbs4Date:false,
                        daysAbs5Date:false,
                        daysAbs6Date:false,
                        daysAbs7Date:false,
                        daysAbs8Date:false,
                        daysAbs9Date:false,
                        daysAbs10Date:false,
                        daysAbs11Date:false,
                        daysAbs12Date:false,
                        daysAbs13Date:false,
                        daysAbs14Date:false,
                        daysAbs15Date:false,
                        daysAbs16Date:false,
                        daysAbs17Date:false,
                        daysAbs18Date:false,
                        daysAbs19Date:false,
                        daysAbs20Date:false,
                        actNoAttDate:false,
                        behindHrsDate:false,
                        excAbbNotDate:false,
                        missMoreAttNotDate:false,
                        nonEmailContDate:false,
                        compDocNeedDate:false,
                        compuAppDate:false,
                        famIncFormDate:false,
                        phoneNumUpdateDate:false,
                        behaviorConDate:false,
                        couLockCommuDate:false,
                        limitedActDate:false,
                        lowCCAttDate:false,
                        noLoginDate:false,
                        winbackCallDate:false,
                        engPlanCallDate:false,
                        meeting504Date:false,
                        iEPMeetingDate:false,
                        iripDate:false,
                        tieredInstDate:false,
                        missStuConnDate:false,
                        orientationDate:false,
                        onboardingDate:false,
                        stateTestAssignDate:false,
                        stateTestAssignDate:false

                    };
                    $scope.openEnrollmentDate = function() {
                        $scope.datePickers.enrollmentDate = true;
                    };
                    $scope.openSchoolWithdrawalDate = function() {
                        $scope.datePickers.schoolWithdrawalDate = true;
                    };
                    $scope.openEnrollmentReceivedDate = function() {
                        $scope.datePickers.enrollmentReceivedDate = true;
                    };
                    $scope.openEnrollmentApprovedDate = function() {
                        $scope.datePickers.enrollmentApprovedDate = true;
                    };
                    $scope.openEnduringConnectnCall = function() {
                        $scope.datePickers.enduringConnectnCall = true;
                    };
                    $scope.openFastRunningNoteDate = function() {
                        $scope.datePickers.fastRunningNoteDate = true;
                    };
                    $scope.openTeacherCompliancyNoteDate = function() {
                        $scope.datePickers.teacherCompliancyNoteDate = true;
                    };
                    $scope.openFollowUpActionDate = function() {
                        $scope.datePickers.followUpActionDate = true;
                    };
                    $scope.openPulseCheckDate = function() {
                        $scope.datePickers.pulseCheckDate = true;
                    };
                    $scope.openEngagementDates = function(path) {
                        $scope.datePickers[path] = true;
                    }
                    $scope.openGradPlanDates = function(path) {
                        $scope.datePickers[path] = true;
                    }
                    $scope.openAttendanceDates = function(path) {
                        $scope.datePickers[path] = true;
                    }
                    $scope.openReRegLastModDate = function() {
                        $scope.datePickers.reRegLastModDate = true;
                    };
                     $scope.openReRegApprLastModDate = function() {
                        $scope.datePickers.reRegApprLastModDate = true;
                    };
                     $scope.openFirstAccDate = function() {
                        $scope.datePickers.firstAccDate = true;
                    };
                     $scope.openLastAccDate = function() {
                        $scope.datePickers.lastAccDate = true;
                    };          

                    $scope.openMessagedDates = function(path) {
                        $scope.datePickers[path] = true;
                    }
                     // Controls cog spinning when search is in progress
                    $scope.isSearchBusy = false;
                    // Search button enabling or disabling
                    $scope.isSearchDisabled = false;

                    $scope.isSaveSearchDisabled = false;
                    $scope.isSaveSearchBusy = false;

                    // Custom Sorting for dates
                    var sortDateFn = function(a, b) {
                        var nulls = handleNulls(a, b);
                        if (nulls !== null) {
                            return nulls;
                        } else {
                            var aDate = moment(a, "MM DD YYYY");
                            var bDate = moment(b, "MM DD YYYY");
                            if (aDate > bDate) {
                                return 1;
                            } else if (bDate > aDate) {
                                return -1;
                            } else {
                                return 0;
                            }
                        }
                    };

                    // Sorts nulls and undefined to the bottom (top when descending).  
                    // @returns null if there were no nulls/undefined, otherwise returns
                    // a sort value that should be passed back from the sort function
                    var handleNulls = function(a, b) {
                        // We want to allow zero values and false values to be evaluated in the sort function
                        if ((!a && a !== 0 && a !== false) || (!b && b !== 0 && b !== false)) {
                            // We want to force nulls and such to the bottom when we sort... which effectively is "greater than"
                            if ((!a && a !== 0 && a !== false) && (!b && b !== 0 && b !== false)) {
                                return 0;
                            } else if (!a && a !== 0 && a !== false) {
                                return 1;
                            } else if (!b && b !== 0 && b !== false) {
                                return -1;
                            }
                        }
                        return null;
                    };


                    // Custom Sorting for grades
                   var sortGradeFn = function(a, b) {
                        var gradeOrder, aStr, bStr;
                        gradeOrder = ['TK', 'UNDEFINED', 'K', '1', '2', '3', '4', '5', '6', '7',
                            '8', '9', '10', '11', '12', 'AL', 'OTHER'
                        ];

                        aStr = a.toUpperCase();
                        bStr = b.toUpperCase();

                        if (gradeOrder.indexOf(aStr) > gradeOrder.indexOf(bStr)) {
                            return 1;
                        } else if (gradeOrder.indexOf(aStr) < gradeOrder.indexOf(bStr)) {
                            return -1;
                        } else {
                            return 0;
                        }
                    };

                    // Cohort years: Current Calendar Year-4 to Current Calendar Year+4
                    var getCohortYears = function(offset, range) {
                        var currentYear = new Date().getFullYear();
                        var years = [];
                        for (var i = 0; i < range; i++) {
                            years.push(currentYear + offset + i);
                        }
                        return years;
                    };

                    // Populate grad plan and school's cohort years
                    // Cohort years: offset: -4, range: 9
                    $scope.cohortYearsList = getCohortYears(-4, 9);

                    // Invoke Edit Student Details Modal
                    $rootScope.assignedDiplomaSuccessfully = false;
                    $scope.editStudentModal = function(grid, row, size) {
                        resetErrorFlags();
                        var currentPageNumber = $scope.gridApi.pagination.getPage();
                        $scope.studentResultsGridObject = {
                            searchResults: $scope.gridOptions.data,
                            currentPage: $scope.paginationChanged ? $scope.currentPageSelection : currentPageNumber,
                            gridPageSize: $scope.paginationChanged ? $scope.currentPageSize : 25,
                            grid: $scope.gridApi,
                            row: row
                        }
                    }

                    // Initialize Grid options.
                    var rowtpl = '<div ng-class="grid.options.rowStyle(row)"><div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell></div></div>';

                    $scope.gridOptions = {
                        enableFiltering: true,
                        enableGridMenu: true,
                        exporterMenuPdf: false,
                        paginationPageSizes: [25, 50, 75],
                        paginationPageSize: 25,
                        rowHeight: 50,
                        enableRowSelection: true,
                        enableRowHeaderSelection: true,
                        showGridFooter: false,
                        rowStyle: function(row) {
                            if (row.isSelected) {
                                return 'ui-grid-selected-row';
                            }
                        },
                        rowTemplate: rowtpl,                        
                        gridMenuCustomItems: [{
                                shown: function() {
                                    // ACTIVE students, admin
                                    // role and atleast one row
                                    // is selected.
                                    return this.grid.api.selection &&
                                        this.grid.api.selection
                                        .getSelectedRows().length > 0 &&
                                        this.grid.api.selection
                                        .getSelectedRows()[0].status
                                        .toUpperCase() == 'ACTIVE' &&
                                        authentication
                                        .hasAdministratorRole();
                                },
                                title: 'Add to existing classroom',
                                action: function($event) {
                                    resetErrorFlags();
                                    //get studentid/s for selected students from search results
                                    var selectedRowsList = this.grid.api.selection.getSelectedRows();
                                    var selectedStudents = [];
                                    var selectedStudentsCount = selectedRowsList.length;
                                    for (var i = 0; i < selectedRowsList.length; i++) {
                                        selectedStudents.push(selectedRowsList[i].studentId);
                                    };
                                    if (selectedStudentsCount > 200) {
                                        //show error if selected students exceeded max limit of 200
                                        $scope.searchErrorOccurred = true;
                                        $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.maxStudentsSelectedForClassroom;

                                    } else {
                                        //invoke studentAddClassroom service
                                        studentAddClassroom.service(selectedStudents, selectedStudentsCount);
                                    }
                                },
                                order: 210
                            },
                            {
                                shown: function() {
                                    // ACTIVE students, user with attendance adjuster
                                    // role and atleast one row
                                    // is selected.
                                    return this.grid.api.selection &&
                                        this.grid.api.selection
                                        .getSelectedRows().length > 0 &&
                                        this.grid.api.selection
                                        .getSelectedRows()[0].status.toUpperCase() == 'ACTIVE' &&
                                        authentication.hasAttendanceAdjusterRole();
                                },
                                title: 'Adjust Attendance',
                                order: 211,
                                action: function($event) {
                                    resetErrorFlags();
                                    //get studentid/s for selected students from search results
                                    var selectedRowsList = this.grid.api.selection.getSelectedRows();
                                    var selectedStudents = [];
                                    var selectedStudentsCount = selectedRowsList.length;
                                    for (var i = 0; i < selectedRowsList.length; i++) {
                                        if (selectedRowsList[i] != null) {
                                            selectedStudents[i] = {
                                                studentId: selectedRowsList[i].studentId,
                                                schoolId: selectedRowsList[i].schoolId,
                                                schoolStartDate: selectedRowsList[i].schoolStartDate,
                                                schoolEndDate: selectedRowsList[i].schoolEndDate,
                                            };
                                        }
                                    };
                                    //invoke studentAdjustAttendance service
                                    studentAdjustAttendance.service(selectedStudents, selectedStudentsCount);

                                },
                            },
                            {
                                shown: function() {
                                    // TEACHER role, ACTIVE students and at least ONE row is selected.
                                    return this.grid.api.selection &&
                                        this.grid.api.selection
                                        .getSelectedRows().length > 0 &&
                                        this.grid.api.selection
                                        .getSelectedRows()[0].status
                                        .toUpperCase() == 'ACTIVE' &&
                                        (authentication.hasTeacherRole() || authentication
											.hasAdministratorRole());
                                },
                                title: 'Add students to a new Class Connect session',
                                order: 212,
                                action: function($event) {
                                    resetErrorFlags();
                                    var currentSelection = $scope.gridApi.selection
                                        .getSelectedRows();
                                    var selectedStudentsCount = currentSelection.length;
                                    var csvSelIdtIds = [];
                                    var sessionType = 'new';
                                    for (var i = 0; i < currentSelection.length; i++) {
                                        if (currentSelection[i] != null) {
                                            console.log("identityId=" + currentSelection[i].identityId + " schoolAbbr=" + currentSelection[i].schoolAbbr);
                                            csvSelIdtIds[i] = {
                                                idnId: currentSelection[i].identityId,
                                                schAbr: currentSelection[i].schoolAbbr
                                            };
                                        }
                                    }
                                    console.log("(New Class Connect session) Selected a list of " + csvSelIdtIds.length + " Identity IDs.");
                                    if (selectedStudentsCount > 1000) {
                                        //show error if selected students exceeded max limit of 1000
                                        $scope.searchErrorOccurred = true;
                                        $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.maxStudentsSelectedForClassConnect;
                                    } else if (csvSelIdtIds.length > 0) {
                                        $http({
                                                method: "POST",
                                                url: schoolwork12.app.student.endpoints.classConnectUrlSearch,
                                                data: {
                                                    "idntSchInfo": csvSelIdtIds,
                                                    "sessionType": sessionType,
                                                    "senderAccountId": authentication.getCurrentUser().accountid
                                                },
                                                headers: {
                                                    'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                                }
                                            })
                                            .then(
                                                function(response) {
                                                    if (response.data.length > 0) {
                                                        console.info("Retrieved URL: " + response.data);
                                                        window.open(response.data);
                                                    } else {
                                                        $scope.searchErrorOccurred = true;
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                                    }
                                                },
                                                function(error) {
                                                    $scope.searchErrorOccurred = true;
                                                    if (error.status == 400) {
                                                        for (var j = 0; j < error.data._errors.length; j++) {
                                                            $scope.searchErrorMesg = $scope.searchErrorMesg + error.data._errors[j] + "\n";
                                                        }
                                                    } else if (error.status == 401 || error.status == 403) {
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                                    } else {
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                                    }
                                                });
                                    }

                                }
                            },
                            {
                                shown: function() {
                                    // TEACHER role, ACTIVE students and at least ONE row is selected.
                                    return this.grid.api.selection &&
                                        this.grid.api.selection
                                        .getSelectedRows().length > 0 &&
                                        this.grid.api.selection
                                        .getSelectedRows()[0].status
                                        .toUpperCase() == 'ACTIVE' &&
                                        (authentication.hasTeacherRole() || authentication
											.hasAdministratorRole());
                                },
                                title: 'Add students to an existing Class Connect session',
                                order: 213,
                                action: function() {
                                    resetErrorFlags();
                                    var currentSelection = $scope.gridApi.selection
                                        .getSelectedRows();
                                    var selectedStudentsCount = currentSelection.length;
                                    var csvSelIdtIds = [];
                                    var sessionType = 'existing';
                                    for (var i = 0; i < currentSelection.length; i++) {
                                        if (currentSelection[i] != null) {
                                            csvSelIdtIds[i] = {
                                                idnId: currentSelection[i].identityId,
                                                schAbr: currentSelection[i].schoolAbbr
                                            };
                                        }
                                    }
                                    console.log("(Existing Class Connect session) Selected a list of " + csvSelIdtIds.length + " Identity IDs.");
                                    if (selectedStudentsCount > 1000) {
                                        //show error if selected students exceeded max limit of 1000
                                        $scope.searchErrorOccurred = true;
                                        $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.maxStudentsSelectedForClassConnect;
                                    } else if (csvSelIdtIds.length > 0) {
                                        $http({
                                                method: "POST",
                                                url: schoolwork12.app.student.endpoints.classConnectUrlSearch,
                                                data: {
                                                    "idntSchInfo": csvSelIdtIds,
                                                    "sessionType": sessionType,
                                                    "senderAccountId": authentication.getCurrentUser().accountid
                                                },
                                                headers: {
                                                    'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                                }
                                            })
                                            .then(
                                                function(response) {
                                                    if (response.data.length > 0) {
                                                        console.info("Retrieved URL: " + response.data);
                                                        window.open(response.data);
                                                    } else {
                                                        $scope.searchErrorOccurred = true;
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                                    }
                                                },
                                                function(error) {
                                                    $scope.searchErrorOccurred = true;
                                                    if (error.status == 400) {
                                                        for (var j = 0; j < error.data._errors.length; j++) {
                                                            $scope.searchErrorMesg = $scope.searchErrorMesg + error.data._errors[j] + "\n";
                                                        }
                                                    } else if (error.status == 401 || error.status == 403) {
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                                    } else {
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                                    }
                                                });
                                    }

                                }
                            },
                            {
                                shown: function() {
                                    // ACTIVE students, teacher role
                                    // and at least one row
                                    // is selected.
                                    return this.grid.api.selection &&
                                        this.grid.api.selection
                                        .getSelectedRows().length > 0 &&
                                        this.grid.api.selection
                                        .getSelectedRows()[0].status
                                        .toUpperCase() == 'ACTIVE' &&
                                        authentication.hasTeacherRole();
                                },
                                title: 'Add students to a new Personal Group',
                                order: 214,
                                action: function($event) {
                                    resetErrorFlags();
                                    //get studentid/s for selected students from search results
                                    var selectedRowsList = this.grid.api.selection.getSelectedRows();
                                    var selectedStudents = [];
                                    var selectedStudentsCount = selectedRowsList.length;
                                    for (var i = 0; i < selectedRowsList.length; i++) {
                                        if (selectedRowsList[i] != null) {
                                            selectedStudents[i] = {
                                                idnId: selectedRowsList[i].identityId,
                                                schAbr: selectedRowsList[i].schoolAbbr
                                            }
                                        }
                                    };
                                    //invoke studentCreatePersonalGroup service
                                    studentCreatePersonalGroup.service(selectedStudents, selectedStudentsCount);
                                },
                            },
                            {
                                shown: function() {
                                    // ACTIVE students, teacher
                                    // role and at least one row
                                    // is selected.
                                    return this.grid.api.selection &&
                                        this.grid.api.selection
                                        .getSelectedRows().length > 0 &&
                                        this.grid.api.selection
                                        .getSelectedRows()[0].status
                                        .toUpperCase() == 'ACTIVE' &&
                                        authentication
                                        .hasTeacherRole();
                                },
                                title: 'Add students to an existing Personal Group',
                                action: function($event) {
                                    resetErrorFlags();
                                    //get identityId/s for selected students from search results
                                    var selectedRowsList = this.grid.api.selection.getSelectedRows();
                                    var selectedStudents = [];
                                    var selectedStudentsCount = selectedRowsList.length;

                                    for (var i = 0; i < selectedRowsList.length; i++) {
                                        if (selectedRowsList[i] != null) {
                                            selectedStudents[i] = {
                                                idnId: selectedRowsList[i].identityId,
                                                schAbr: selectedRowsList[i].schoolAbbr
                                            };
                                        }
                                    };
                                    //invoke studentAddPersonalGroup service
                                    studentAddPersonalGroup.service(selectedStudents, selectedStudentsCount);
                                },
                                order: 215
                            },
                            {
                                shown: function() {
                                    // ACTIVE students, teacher
                                    // role and at least one row
                                    // is selected.
                                    return this.grid.api.selection &&
                                        this.grid.api.selection
                                        .getSelectedRows().length > 0 &&
                                        this.grid.api.selection
                                        .getSelectedRows()[0].status
                                        .toUpperCase() == 'ACTIVE' &&
                                        authentication
                                        .hasTeacherRole();
                                },
                                title: 'Remove students from a Personal Group',
                                action: function($event) {
                                    resetErrorFlags();
                                    //get identityId/s for selected students from search results
                                    var selectedRowsList = this.grid.api.selection.getSelectedRows();
                                    var selectedStudents = [];
                                    var selectedStudentsCount = selectedRowsList.length;

                                    for (var i = 0; i < selectedRowsList.length; i++) {
                                        if (selectedRowsList[i] != null) {
                                            selectedStudents[i] = {
                                                idnId: selectedRowsList[i].identityId,
                                                schAbr: selectedRowsList[i].schoolAbbr
                                            };
                                        }
                                    };
                                    //invoke studentRemovePersonalGroup service
                                    studentRemovePersonalGroup.service(selectedStudents, selectedStudentsCount);
                                },
                                order: 216
                            },
                            {
                                shown: function() {
                                    // ACTIVE students, admin or teacher with counselor
                                    // role and atleast one row
                                    // is selected.
                                    return this.grid.api.selection &&
                                        this.grid.api.selection
                                        .getSelectedRows().length > 0 &&
                                        this.grid.api.selection
                                        .getSelectedRows()[0].status
                                        .toUpperCase() == 'ACTIVE' &&
                                        (authentication.hasAdministratorRole() ||
                                           // authentication.hasTeacherRole() ||
                                                authentication.hasCounselorStaffRole());
                                },
                                title: 'Lock Curriculum',
                                order: 217,
                                action: function($event) {
                                    resetErrorFlags();
                                    //get studentid/s for selected students from search results
                                    var selectedRowsList = this.grid.api.selection.getSelectedRows();
                                    var selectedStudents = [];
                                    var studentIds = [];
                                    var selectedStudentsCount = selectedRowsList.length;
                                    for (var i = 0; i < selectedRowsList.length; i++) {
                                        if (selectedRowsList[i] != null) {
                                            selectedStudents[i] = {
                                                studentId: selectedRowsList[i].studentId,
                                                schoolId: selectedRowsList[i].schoolId,
                                            };
                                            studentIds[i] = selectedRowsList[i].studentId;
                                        }
                                    };
                                    console.log("Selected a list of " + selectedStudents.length + " Student IDs.");
                                    if (selectedStudents.length > 0) {
                                    	if(authentication.hasTeacherRole() && !authentication.hasCounselorStaffRole()){
                                    		$scope.isActionSpinnerActive = true;
                                            $http({
                                                    method: "POST",
                                                    url: schoolwork12.app.student.endpoints.classroomHomeroomSearch,
                                                    data: {
                                                        "studentIds": studentIds
                                                    },
                                                    headers: {
                                                        'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                                    }
                                                })
                                                .then(
                                                    function(response) {
                                                    	$scope.isActionSpinnerActive = false;
                                                    	if(response.data._errors){
                                                    		$scope.actionErrorOccurred = true;
                                                    		$scope.actionErrorMesg = schoolwork12.app.student.errorMessages.lockCurriculumHomeroomSearchError.format(response.data.total);;
                                                    		$scope.actionErrorObjects = response.data.studentIds;
                                                    	}else{
                                                    		//invoke studentLockCurriculum service
                                                    		studentLockCurriculum.service(selectedStudents, selectedStudentsCount);
                                                    	}
                                                        
                                                    },
                                                    function(error) {
                                                        $scope.isActionSpinnerActive = false;
                                                        if (error.status == 400) {
                                                        	for (var j = 0; j < error.data._errors.length; j++) {
                                                                $scope.searchErrorMesg = $scope.searchErrorMesg + error.data._errors[j] + "\n";
                                                            }
                                                        } else if (error.status == 401 || error.status == 403) {
                                                            $scope.searchErrorOccurred = true;
                                                            $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                                        } else {
                                                            $scope.searchErrorOccurred = true;
                                                            $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                                        }
                                                    });
                                    	}else{
                                    		//invoke studentLockCurriculum service
                                    		studentLockCurriculum.service(selectedStudents, selectedStudentsCount);
                                    	}
                                        
                                    }
                                },
                            },
                            {
                                shown: function() {
                                    // ACTIVE students, admin or teacher with counselor
                                    // role and atleast one row
                                    // is selected.
                                    return this.grid.api.selection &&
                                        this.grid.api.selection
                                        .getSelectedRows().length > 0 &&
                                        this.grid.api.selection
                                        .getSelectedRows()[0].status
                                        .toUpperCase() == 'ACTIVE' &&
                                        (authentication.hasAdministratorRole() ||
                                            //authentication.hasTeacherRole() ||
                                                authentication.hasCounselorStaffRole());
                                },
                                title: 'Unlock Curriculum',
                                order: 218,
                                action: function($event) {
                                    resetErrorFlags();
                                    //get studentid/s for selected students from search results
                                    var selectedRowsList = this.grid.api.selection.getSelectedRows();
                                    var selectedStudents = [];
                                    var studentIds = [];
                                    var selectedStudentsCount = selectedRowsList.length;
                                    for (var i = 0; i < selectedRowsList.length; i++) {
                                        if (selectedRowsList[i] != null) {
                                            selectedStudents[i] = {
                                                studentId: selectedRowsList[i].studentId,
                                                schoolId: selectedRowsList[i].schoolId,
                                            };
                                            studentIds[i] = selectedRowsList[i].studentId;
                                        }
                                    };
                                    console.log("Selected a list of " + selectedStudents.length + " Student IDs.");
                                    if (selectedStudents.length > 0) {
                                    	if(authentication.hasTeacherRole() && !authentication.hasCounselorStaffRole()){
                                    		$scope.isActionSpinnerActive = true;
                                            $http({
                                                    method: "POST",
                                                    url: schoolwork12.app.student.endpoints.classroomHomeroomSearch,
                                                    data: {
                                                        "studentIds": studentIds
                                                    },
                                                    headers: {
                                                        'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                                    }
                                                })
                                                .then(
                                                    function(response) {
                                                    	$scope.isActionSpinnerActive = false;
                                                    	if(response.data._errors){
                                                    		$scope.actionErrorOccurred = true;
                                                    		$scope.actionErrorMesg = schoolwork12.app.student.errorMessages.unlockCurriculumHomeroomSearchError.format(response.data.total);
                                                    		$scope.actionErrorObjects = response.data.studentIds;
                                                    	}else{
                                                    		//invoke studentUnlockCurriculum service
                                                            studentUnlockCurriculum.service(selectedStudents, selectedStudentsCount);
                                                    	}
                                                        
                                                    },
                                                    function(error) {
                                                        $scope.isActionSpinnerActive = false;
                                                        if (error.status == 400) {
                                                        	for (var j = 0; j < error.data._errors.length; j++) {
                                                                $scope.searchErrorMesg = $scope.searchErrorMesg + error.data._errors[j] + "\n";
                                                            }
                                                        } else if (error.status == 401 || error.status == 403) {
                                                            $scope.searchErrorOccurred = true;
                                                            $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                                        } else {
                                                            $scope.searchErrorOccurred = true;
                                                            $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                                        }
                                                    });
                                    	}else{
                                    		//invoke studentUnlockCurriculum service
                                            studentUnlockCurriculum.service(selectedStudents, selectedStudentsCount);
                                    	}
                                        
                                    }
                                },
                            },
                            {
                                shown: function() {
                                    // ACTIVE students, admin
                                    // role and atleast one row
                                    // is selected.
                                    return this.grid.api.selection &&
                                        this.grid.api.selection
                                        .getSelectedRows().length > 0 &&
                                        this.grid.api.selection
                                        .getSelectedRows()[0].status
                                        .toUpperCase() == 'ACTIVE' &&
                                        (authentication.hasAdministratorRole() ||
                                            authentication.hasTeacherRole());
                                },
                                title: 'Send New Mail',
                                order: 219,
                                action: function() {
                                    resetErrorFlags();
                                    var currentSelection = $scope.gridApi.selection
                                        .getSelectedRows();
                                    var csvSelIdtIds = [];
                                    for (var i = 0; i < currentSelection.length; i++) {
                                        if (currentSelection[i] != null) {
                                            csvSelIdtIds[i] = {
                                                idnId: currentSelection[i].identityId,
                                                schAbr: currentSelection[i].schoolAbbr
                                            };
                                        }
                                    }
                                    console
                                        .log("Selected a list of " +
                                            csvSelIdtIds.length +
                                            " Identity IDs.");
                                    if (csvSelIdtIds.length > 0) {
                                        $http({
                                                method: "POST",
                                                url: schoolwork12.app.student.endpoints.mailUrlSearch,
                                                data: {
                                                    "idntSchInfo": csvSelIdtIds,
                                                    "isLcOnly": false,
                                                    "senderAccountId": authentication.getCurrentUser().accountid
                                                },
                                                headers: {
                                                    'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                                }
                                            })
                                            .then(
                                                function(response) {
                                                    if (response.data.length > 0) {
                                                        console.info("Retrieved URL: " + response.data);
                                                        window.open(response.data);
                                                    } else {
                                                        $scope.searchErrorOccurred = true;
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                                    }
                                                },
                                                function(error) {
                                                    $scope.searchErrorOccurred = true;
                                                    if (error.status == 400) {
                                                        for (var j = 0; j < error.data._errors.length; j++) {
                                                            $scope.searchErrorMesg = $scope.searchErrorMesg + error.data._errors[j] + "\n";
                                                        }
                                                    } else if (error.status == 401 || error.status == 403) {
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                                    } else {
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                                    }
                                                });
                                    }

                                }
                            },
                            {
                                shown: function() {
                                    // ACTIVE students, Admin Role, Teacher Role or Enrollment Advisor Role
                                    // role and atleast one row
                                    // is selected.
                                    return this.grid.api.selection &&
                                        this.grid.api.selection
                                        .getSelectedRows().length > 0 &&
                                        this.grid.api.selection
                                        .getSelectedRows()[0].status
                                        .toUpperCase() == 'ACTIVE' && (
                                            authentication.hasTeacherRole() ||
                                            authentication.hasAdministratorRole());
                                },
                                title: 'Send New Mail to LC Only',
                                order: 220,
                                action: function() {
                                    resetErrorFlags();
                                    var currentSelection = $scope.gridApi.selection.getSelectedRows();
                                    var selectedStds = [];
                                    for (var i = 0; i < currentSelection.length; i++) {
                                        if (currentSelection[i] != null) {
                                            selectedStds[i] = {
                                                idnId: currentSelection[i].identityId,
                                                schAbr: currentSelection[i].schoolAbbr
                                            };
                                        }
                                    }


                                    console.log("Selected a list of " + selectedStds.length + " Student IDs.");
                                    if (selectedStds.length > 0) {
                                        $http({
                                                method: "POST",
                                                url: schoolwork12.app.student.endpoints.mailUrlSearch,
                                                data: {
                                                    "idntSchInfo": selectedStds,
                                                    "isLcOnly": true,
                                                    "senderAccountId": authentication.getCurrentUser().accountid
                                                },
                                                headers: {
                                                    'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                                }
                                            })
                                            .then(
                                                function(response) {
                                                    if (response.data.length > 0) {
                                                        console.info("Retrieved URL: " + response.data);
                                                        window.open(response.data);
                                                    } else {
                                                        $scope.searchErrorOccurred = true;
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                                    }
                                                },
                                                function(error) {
                                                    $scope.searchErrorOccurred = true;
                                                    if (error.status == 400) {
                                                        for (var j = 0; j < error.data._errors.length; j++) {
                                                            $scope.searchErrorMesg = $scope.searchErrorMesg + error.data._errors[j] + "\n";
                                                        }
                                                    } else if (error.status == 401 || error.status == 403) {
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                                    } else {
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                                    }
                                                });
                                    }

                                }
                            },
                            {
                                shown: function() {
                                    // ACTIVE students, admin
                                    // role and atleast one row
                                    // is selected.
                                    return this.grid.api.selection &&
                                        this.grid.api.selection
                                        .getSelectedRows().length > 0;
                                },
                                title: 'Save New Note',
                                order: 221,
                                action: function() {
                                    resetErrorFlags();
                                    var currentSelection = $scope.gridApi.selection
                                        .getSelectedRows();
                                    var csvSelIdtIds = [];
                                    for (var i = 0; i < currentSelection.length; i++) {
                                        if (currentSelection[i] != null) {
                                            csvSelIdtIds[i] = {
                                                idnId: currentSelection[i].identityId,
                                                schAbr: currentSelection[i].schoolAbbr
                                            };
                                        }
                                    }
                                    console
                                        .log("Selected a list of " +
                                            csvSelIdtIds.length +
                                            " Identity IDs.");
                                    if (csvSelIdtIds.length >= 500) {
                                        $scope.searchErrorOccurred = true;
                                        $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.sendNoteExceeds500;

                                    } else if (csvSelIdtIds.length > 0) {
                                        $http({
                                                method: "POST",
                                                url: schoolwork12.app.student.endpoints.accountIdsSearch,
                                                data: {
                                                    "idntSchInfo": csvSelIdtIds
                                                },
                                                headers: {
                                                    'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                                }

                                            })
                                            .then(
                                                function(response) {
                                                    console.info(response.data);
                                                    var sendNoteUrl = schoolwork12.app.student.endpoints.sendNote
                                                    var gmtOffsetMinutes = new Date().getTimezoneOffset();
                                                    var formPostString = '<form id="sendNoteForm" method="post" action="' +
                                                        sendNoteUrl +
                                                        '" target="_blank"><input type="hidden" name="senderKeycode" value="' +
                                                        authentication.getCurrentUser().keycode +
                                                        '"><input type="hidden" name="noteType" value="0"><input type="hidden" name="gmtOffsetMinutes" value="' +
                                                        gmtOffsetMinutes +
                                                        '"><input type="hidden" name="aboutAccountIDs" value="' +
                                                        response.data.toString() +
                                                        '"></form>'
                                                    $(formPostString).appendTo('body').submit();
                                                    $('#sendNoteForm').remove();
                                                },
                                                function(
                                                    error) {
                                                    $scope.searchErrorOccurred = true;
                                                    if (error.status == 400) {
                                                        for (var j = 0; j < error.data._errors.length; j++) {
                                                            $scope.searchErrorMesg = $scope.searchErrorMesg + error.data._errors[j] + "\n";
                                                        }
                                                    } else if (error.status == 401 || error.status == 403) {
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                                    } else {
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                                    }
                                                });
                                    }
                                }
                            },
                            {
                                shown: function() {
                                    // ACTIVE students, GradPlan Manager Role, StudentGradPlanEdit Role
                                    // role and atleast one row
                                    // is selected.
                                    return this.grid.api.selection &&
                                        this.grid.api.selection
                                        .getSelectedRows().length > 0 &&
                                        this.grid.api.selection
                                        .getSelectedRows()[0].status
                                        .toUpperCase() == 'ACTIVE' &&
                                        authentication.isGradPlanOn() &&
                                        (authentication.hasGradPlanManagerRole() || authentication.hasStudentGradPlanEditRole());
                                },
                                title: 'Assign Graduation Plan',
                                order: 222,
                                action: function() {
                                    resetErrorFlags();
                                    var currentSelection = $scope.gridApi.selection.getSelectedRows();
                                    var selectedStds = [];
                                    for (var i = 0; i < currentSelection.length; i++) {
                                        if (currentSelection[i] != null) {
                                            selectedStds[i] = {
                                                studenId: currentSelection[i].studentId,
                                                schoolId: currentSelection[i].schoolId,
                                                schoolAbbr: currentSelection[i].schoolAbbr
                                            };
                                        }
                                    }

                                    console.log("Selected a list of " + selectedStds.length + " Student IDs.");
                                    if (selectedStds.length > 0) {
                                        $scope.isActionSpinnerActive = true;
                                        
                                        $http({
                                            method: "POST",
                                            url: schoolwork12.app.student.endpoints.studentsCountWithPriorDiploma,
                                            data: {
                                                "studentSchoolList": selectedStds
                                            },
                                            headers: {
                                                'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                            }
                                        })
                                        .then(
                                                function(response) {
                                                    console.info("Number of students with Prior diploma: " + response.data.numStudentsWithPriorDiploma + " diplomas");
                                                    
                                                    if(response.data.numStudentsWithPriorDiploma>0)
                                                		{
                                                		$scope.isActionSpinnerActive = false;
                                                        //prompt before switching to next student
                                                        $scope.option2 = false;
                                                        $scope.modalInstance2 = null;
                                                        $uibModal.open({
                                                                animation: $scope.animationsEnabled,
                                                                templateUrl: 'commonDialog.html',
                                                                windowClass: 'alert-Modal',
                                                                keyboard: false,
                                                                backdrop: 'static',
                                                                controller: ['$scope', '$uibModalInstance',
                                                                    function($scope, $uibModalInstance) {
                                                                        if(response.data.numStudentsWithPriorDiploma==1)
                                                                        {
                                                                        	if(selectedStds.length==1)
                                                                        		{
                                                                        			$scope.dialogMsg = 'The student you selected already has a graduation plan assigned. Proceeding will change the current plan assignment and you will lose any current customizations. Are you sure you want to proceed?';
                                                                        		}
                                                                        		else
                                                                        		{
                                                                        			$scope.dialogMsg = response.data.numStudentsWithPriorDiploma +' of the selected students already has a graduation plan assigned.  Proceeding will change the current plan assignment and you will lose any current customizations. Are you sure you want to proceed?';
                                                                        		}
              		
                                                                        }
                                                                        else 
                                                                        {
                                                                        	$scope.dialogMsg = response.data.numStudentsWithPriorDiploma +' of the selected students already have a graduation plan assigned.  Proceeding will change the current plan assignment and you will lose any current customizations.  Are you sure you want to proceed?';
                                                                        	}
	                                                                        $scope.cancel = function() {
	                                                                            $uibModalInstance.close(false);
	                                                                        };
	                                                                        $scope.ok = function() {
	                                                                            $uibModalInstance.close(true);
	                                                                            diplomaSearch(selectedStds);
	                                                                        };
                                                                    }
                                                                ],

                                                            });
                                                       }
                                                	else {
                                                		diplomaSearch(selectedStds);
                                                	}
                                                },
                                                function(error) {
                                                    $scope.isActionSpinnerActive = false;
                                                    console.log('assignedDiplomaSuccessfully', error)
                                                    if (error.status == 400) {
                                                        $scope.actionErrorOccurred = true;
                                                        for (var j = 0; j < error.data._errors.length; j++) {
                                                            $scope.actionErrorMesg = $scope.actionErrorMesg + error.data._errors[j] + "\n";
                                                        }
                                                        if (angular.isDefined(error.data.errObjects) && error.data.errObjects != null) {
                                                            var errObjs = "";
                                                            for (var k = 0; k < error.data.errObjects.length; k++) {
                                                                if (errObjs.length != 0) {
                                                                    errObjs = errObjs + ", ";
                                                                }
                                                                errObjs = errObjs + error.data.errObjects[k];
                                                            }
                                                            $scope.actionErrorObjects = errObjs;
                                                        }
                                                    } else if (error.status == 401 || error.status == 403) {
                                                        $scope.searchErrorOccurred = true;
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                                    } else {
                                                        $scope.searchErrorOccurred = true;
                                                        $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                                    }
                                                })
                                    }

                                }
                            }
                            
                        ],

                        onRegisterApi: function(gridApi) {
                            $scope.gridApi = gridApi;
                            $scope.selectedRowsList = $scope.gridApi.selection.getSelectedRows();

                            $scope.gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                                $scope.selectedRowsCount = $scope.gridApi.selection.getSelectedRows().length;
                            });

                            $scope.gridApi.selection.on.rowSelectionChangedBatch($scope, function(rows) {
                                $scope.selectedRowsCount = $scope.gridApi.selection.getSelectedRows().length;
                            });

                            $scope.resizeGrid = {
                                'width': 'auto',
                                'margin-left': '300px'
                            };

                            $scope.paginationChanged = false;
                            $scope.currentPageSize = $scope.currentPageSize ? $scope.currentPageSize : 25;
                            var pageNumber, pageSize;
                            $scope.gridApi.pagination.on.paginationChanged($scope, function(pageNumber, pageSize) {
                                $scope.paginationChanged = true;
                                $scope.currentPageSelection = pageNumber;
                                $scope.currentPageSize = pageSize;
                            });

                        },
                        columnDefs: [{
                            field: 'studentId',
                            minWidth: 100,
                            cellTemplate: '<div title="Edit Student details" class="ui-grid-cell-contents studentEdit" >' + '<span ui-sref="studentsearch.student({studentID: row.entity.studentId})" ng-click="grid.appScope.editStudentModal(grid, row, size)">{{row.entity[col.field]}}</span>' + '</div>',
                        }, {
                            field: 'firstName',
                            minWidth: 120,
                        }, {
                            field: 'lastName',
                            minWidth: 120,
                        }, {
                            field: 'identityId',
                            minWidth: 100,
                        }, {
                            field: 'gradeLevel',
                            sortingAlgorithm: sortGradeFn,
                            minWidth: 120,
                        }, {
                            field: 'schoolAbbr',
                            displayName: 'School',
                            minWidth: 100,
                        }, {
                            field: 'status',
                            enableFiltering: false,
                            enableSorting: false,
                            minWidth: 100,
                        }, {
                            field: 'withdrawDate',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'homePhone',
                            displayName: 'Home Phone',
                            minWidth: 140,
                        }, {
                            field: 'specialPrograms',
                            displayName: 'Special Programs',
                            minWidth: 120,
                        }, {
                            field: 'hrTeacher',
                            displayName: 'HR Teacher',
                            minWidth: 120,
                        }, {
                            field: 'counselor',
                            displayName: 'Counselor',
                            minWidth: 120
                        }, {
                            field: 'familyId',
                            displayName: 'Family Id',
                            minWidth: 120,
                        }, {
                            field: 'enrollReceivedDate',
                            sortingAlgorithm: sortDateFn,
                            displayName: 'Enrollment Received Date',
                            minWidth: 120,
                        }, {
                            field: 'enrollApprovedDate',
                            sortingAlgorithm: sortDateFn,
                            displayName: 'Enrollment Approved Date',
                            minWidth: 120,
                        }, {
                            field: 'schoolEnrollDate',
                            sortingAlgorithm: sortDateFn,
                            displayName: 'School Enrollment Date',
                            minWidth: 120,
                        }, {
                            field: 'schoolWithdrawDate',
                            sortingAlgorithm: sortDateFn,
                            displayName: 'School Withdrawal Date',
                            minWidth: 120,
                        }, {
                            field: 'fullTime',
                            displayName: 'FT/PT',
                            minWidth: 120,
                        }, {
                            field: 'fundingModel',
                            displayName: 'Funding Model',
                            minWidth: 120,
                        }, {
                            field: 'fte',
                            displayName: 'FTE',
                            minWidth: 120,
                        }, {
                            field: 'participantPrograms',
                            displayName: 'Participating Programs',
                            minWidth: 120,
                            // cellTemplate:'<div class="class="ui-grid-cell-contents ui-grid-cell-contents-break"> {{row.entity[col.field]}} </div>'
                        }, {
                            field: 'ctePathway',
                            displayName: 'CTE Pathway',
                            minWidth: 120,
                        }, {
                            field: 'futureCtePathway',
                            displayName: 'Future CTE Pathway',
                            minWidth: 120,
                        }, {
                            field: 'futureStartDate',
                            displayName: 'Future CTE Pathway Start Date',
                            minWidth: 120,
                         }, {
                            field: 'attendance1stDay',
                            id: 11,
                            sortingAlgorithm: sortDateFn,
                            displayName: '1st Day',
                            minWidth: 120,
                        }, {
                            field: 'attendanceLastDay',
                            id: 12,
                            sortingAlgorithm: sortDateFn,
                            displayName: 'Last Day of Att',
                            minWidth: 120
                        }, {
                            field: 'consecutiveDaysAbsent',
                            id: 1,
                            displayName: 'Consecutive Days Absent',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'truancyDate',
                            id: 25,
                            sortingAlgorithm: sortDateFn,
                            displayName: 'Truancy W/D Date',
                            minWidth: 120
                        }, {
                            field: 'percentAttended',
                            id: 13,
                            displayName: '% Attended',
                            minWidth: 120,
                            type: 'number',
                            cellFilter: 'percentage'
                        }, {
                            field: 'totalDaysEnrolled',
                            id: 20,
                            displayName: 'Total Days Enrolled',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'daysPresent',
                            id: 16,
                            displayName: 'Days Present',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'daysAbsent',
                            id: 4,
                            displayName: 'Days Absent',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'totalHrs',
                            id: 17,
                            displayName: 'Total Hours',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'lastAttemptedLesson',
                            id: 26,
                            displayName: 'Last Attempted Lesson',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'missingHrs',
                            id: 8,
                            displayName: 'Missing Hours',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'attHrs4Week',
                            id: 18,
                            displayName: 'Att Hrs for Week',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'attHrsMissing4Week',
                            id: 9,
                            displayName: 'Att Hrs Missing for Week',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'attLast7Days',
                            id: 19,
                            displayName: 'Att Last 7 Days',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'attMissingLast7Days',
                            id: 7,
                            displayName: 'Att Missing Last 7 Days',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'att4Week',
                            id: 15,
                            displayName: 'Att for Week',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'attMissing4Week',
                            id: 6,
                            displayName: 'Att Missing for Week',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'totalOnlineTime',
                            id: 24,
                            displayName: 'Total Online Time',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'totalOfflinetime',
                            id: 23,
                            displayName: 'Total Offline Time',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'missingOverHrs',
                            id: 22,
                            displayName: 'Missing/Over Hours',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'absentSchoolDays',
                            id: 2,
                            displayName: 'Absent School Days',
                            minWidth: 120
                        }, {
                            field: 'makeupDays',
                            id: 21,
                            displayName: 'Makeup Days',
                            minWidth: 120
                        }, {
                            field: 'excusedAbsences',
                            id: 3,
                            displayName: 'Excused Absences',
                            minWidth: 120
                        }, {
                            field: 'att4Sem',
                            id: 14,
                            displayName: 'Att for Sem',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'missing4Sem',
                            id: 5,
                            displayName: 'Missing for Sem',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'firstDayAttModified',
                            id: 10,
                            sortingAlgorithm: sortDateFn,
                            displayName: '1st Day of Att Modified',
                            minWidth: 120
                        }, {
                            field: 'nonConfirmedAbsences',
                            id: 39,
                            displayName: 'Non-Confirmed Absences',
                            minWidth: 120,
                        }, {
                            field: 'lcOnlyDays',
                            id: 40,
                            displayName: 'LC-Only Days',
                            minWidth: 120,
                        }, {
                            field: 'unexcusedAbsenceDays',
                            id: 41,
                            displayName: 'Unexcused Absence Days',
                            minWidth: 120,
                        }, {
                            field: 'unexcusedAbsences',
                            id: 42,
                            displayName: 'Unexcused Absences',
                            minWidth: 120,
                        }, {
                            field: 'excusedHrs',
                            id: 43,
                            displayName: 'Excused Hours',
                            minWidth: 120,
                        }, {
                            field: 'unexcusedHrs',
                            id: 44,
                            displayName: 'Unexcused Hours',
                            minWidth: 120,
                        }, {
                            field: 'numberOfExcusedAbsences',
                            id: 95,
                            displayName: 'Number Of Excused Absences',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'attLast14Days',
                            id: 96,
                            displayName: 'Att Last 14Days',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'attForTerm',
                            id: 97,
                            displayName: 'Att For Term',
                            minWidth: 120,
                            type: 'number'
                        }, {
                            field: 'missingHoursLastMonth',
                            id: 98,
                            displayName: 'Missing Hours Last Month',
                            minWidth: 120,
                        }, {
                            field: 'missingHoursCurrentMonth',
                            id: 99,
                            displayName: 'Missing Hours Current Month',
                            minWidth: 120,
                        }, 
                      
                        
                        
                        
                        {
                            field: 'elaInstrLvl',
                            displayName: 'ELA Instructional Level',
                            minWidth: 120,
                        }, {
                            field: 'mathInstrLvl',
                            displayName: 'Math Instructional Level',
                            minWidth: 120,
                        }, {
                            field: 'scienceInstrLvl',
                            displayName: 'Science Instructional Level',
                            minWidth: 120,
                        }, {
                            field: 'ssHistoryInstrLvl',
                            displayName: 'SS/History Instructional Level',
                            minWidth: 120,
                        }, {
                            field: 'writingInstrLvl',
                            displayName: 'Writing Instructional Level',
                            minWidth: 120,
                        }, {
                            field: 'elaMtssLvlId',
                            displayName: 'ELA MTSS Level',
                            minWidth: 120,
                        },{
                            field: 'elaMtssLvlModifyDate',
                            displayName: 'ELA MTSS Level Modified Date',
                            minWidth: 120,
                        }, {
                            field: 'mathMtssLvlId',
                            displayName: 'Math MTSS Level',
                            minWidth: 120,
                        }, {
                            field: 'mathMtssLvlModifyDate',
                            displayName: 'Math MTSS Level Modified Date',
                            minWidth: 120,
                        },{
                            field: 'scienceMtssLvlId',
                            displayName: 'Science MTSS Level',
                            minWidth: 120,
                        },
                        {
                            field: 'scienceMtssLvlModifyDate',
                            displayName: 'Science MTSS Level Modified Date',
                            minWidth: 120,
                        },
                        {
                            field: 'ssHistoryMtssLvlId',
                            displayName: 'SS/History MTSS Level',
                            minWidth: 120,
                        },
                        {
                            field: 'ssHistoryMtssLvlModifyDate',
                            displayName: 'SS/History MTSS Level Modified Date',
                            minWidth: 120,
                        },
                        {
                            field: 'diplomaName',
                            displayName: 'Diploma Assigned',
                            minWidth: 100,
                        }, {
                            field: 'gradPlanCohortYear',
                            displayName: 'Grad Plan Cohort Year',
                            minWidth: 100,
                        }, {
                            field: 'cohortYear',
                            displayName: 'Cohort Year',
                            minWidth: 100,
                        }, {
                            field: 'creditsRequired',
                            displayName: 'Credits Required',
                            minWidth: 100,
                        }, {
                            field: 'creditsEarned',
                            displayName: 'Credits Earned',
                            minWidth: 100,
                        }, {
                            field: 'creditsNeededGrad',
                            displayName: 'Credits Needed To Graduate',
                            minWidth: 100,
                        }, {
                            field: 'creditsInProgress',
                            displayName: 'Credits in Progress',
                            minWidth: 100,
                        }, {
                            field: 'creditsNeeded',
                            displayName: 'Credits Needed on Plan',
                            minWidth: 100,
                        }, {
                            field: 'planLastModifiedDate',
                            displayName: 'Plan Last Modified Date',
                            minWidth: 100,
                        },  {
                            field: 'readyStuView',
                            displayName: 'Ready for Student View',
                            minWidth: 100,
                        }, {
                            field: 'firstAccDate',
                            displayName: 'First Accessed Date',
                            minWidth: 100,
                        }, {
                            field: 'lastAccDate',
                            displayName: 'Last Accessed Date',
                            minWidth: 100,
                        }, {
                            field: 'timesViewed',
                            displayName: 'Times Viewed',
                            minWidth: 80,
                        }, {
                            field: 'dsp',
                            displayName: 'DSP',
                            minWidth: 100,
                        }, {
                            field: 'walkToClassAttempt',
                            displayName: 'Walk to Class Attempt',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'walkToClassResult',
                            displayName: 'Walk to Class Result',
                            minWidth: 120,
                        }, {
                            field: 'walkToClassFlwUp',
                            displayName: 'Walk to Class Follow Up',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'welcomeNote',
                            displayName: 'Student Connection Call',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'fastConnectionCall',
                            displayName: 'FAST Connection Call',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'orientatnSesnAtndnce',
                            displayName: 'Orientation Session Attendance',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'ollCmplt',
                            displayName: 'OLL/ORN Complete',
                            minWidth: 120,
                        }, {
                            field: 'fstNbrdngClsrmTchr',
                            displayName: 'FAST Onboarding Classroom TE',
                            minWidth: 120,
                        }, {
                            field: 'stdntLastLogin',
                            displayName: 'Last Student Login',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'LCLastLogin',
                            displayName: 'Last LC Login',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'stdntLst7DaysActvty',
                            displayName: 'ST Activity in the Last 7 Days',
                            minWidth: 120,
                        }, {
                            field: 'CCSesnsAtndLast30Days',
                            displayName: 'CC Sessions Attended Last 30 Days',
                            minWidth: 120,
                        }, {
                            field: 'CCAtndnceThisYr',
                            displayName: 'CC Attendance This Year',
                            minWidth: 120,
                        }, {
                            field: 'BOTCCSesnsAttndedYr',
                            displayName: 'BOT CC Sessions Attended This Year',
                            minWidth: 120,
                        }, {
                            field: 'BOTCCAtndnceThisYr',
                            displayName: 'BOT CC Attendance This Year',
                            minWidth: 120,
                        }, {
                            field: 'lastContact',
                            displayName: 'Last Contact',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'enduringConnectnCall',
                            displayName: 'Enduring Connection Call',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        },{
                            field: 'fastRunningNoteLstMdfdDt',
                            displayName: 'FAST Running Note',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'fastReferralClassroomTeacher',
                            displayName: 'FAST Referral Classroom TE',
                            minWidth: 120,
                        }, {
                            field: 'tchrCompliancyNoteMdfdDt',
                            displayName: 'Teacher Compliancy Note',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'mostRecentPulseChk',
                            displayName: 'Most Recent Pulse Check',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'surveyNumber',
                            displayName: 'Survey Number',
                            minWidth: 120,
                        }, {
                            field: 'pulseChkStsfctnRtng',
                            displayName: 'Pulse Check Satisfaction Rating',
                            minWidth: 120,
                        }, {
                            field: 'pulseChkPrprtnRtng',
                            displayName: 'Pulse Check Preparation Rating',
                            minWidth: 120,
                        }, {
                            field: 'pulseChkKeepUp',
                            displayName: 'Pulse Check Keeping Up Rating',
                            minWidth: 120,
                        }, {
                            field: 'plsCheckStuSucRat',
                            displayName: 'Pulse Check Student Success Rating',
                            minWidth: 120,
                        }, {
                            field: 'pulseChkReRegRtng',
                            displayName: 'Pulse Check Re-Reg Likelihood Rating',
                            minWidth: 120,
                        },  {
                            field: 'pulseChkReasonReReg',
                            displayName: 'Re-Reg Influence',
                            minWidth: 120,
                        },{
                            field: 'rqstedContact',
                            displayName: 'Requested Contact',
                            minWidth: 120,
                        }, {
                            field: 'areasOfIssue',
                            displayName: 'Area(s) of Issue',
                            minWidth: 120,
                        }, {
                            field: 'openEndComments',
                            displayName: 'Open-End Comments',
                            minWidth: 120,
                        }, {
                            field: 'pulseChkFlwUpNeeded',
                            displayName: 'Pulse Check Follow Up Needed',
                            minWidth: 120,
                        }, {
                            field: 'pulseChkFlwUp',
                            displayName: 'Pulse Check Follow Up',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        },{
                            field: 'reReStatus',
                            id: 27,
                            displayName: 'Re-Reg Status',
                            minWidth: 120,
                        },{
                            field: 'reRegLastModDate',
                            id: 28,
                            displayName: 'Re-Reg Last Mod Date',
                            minWidth: 120,
                        },{
                            field: 'reRegAprovalStatus',
                            id: 29,
                            displayName: 'Re-Reg Approval Status',
                            minWidth: 120,
                        },{
                            field: 'reRegApprLastModDate',
                            id: 30,
                            displayName: 'Re-Reg Approval Last Mod Date',
                            minWidth: 120,
                        },{
                            field: 'reRegLastMailTemplate',
                            id: 33,
                            displayName: 'Last Re-Reg Mail Template Used',
                            minWidth: 120,
                        },{
                            field: 'reRegLastNoteTemplate',
                            id: 34,
                            displayName: 'Last Re-Reg Note Template Used',
                            minWidth: 120,
                        },{
                            field: 'reRegInfoSession',
                            id: 31,
                            displayName: 'Parent Re-Reg Info Session CC Att',
                            minWidth: 120,
                        },{
                            field: 'reRegIOLCC',
                            id: 32,
                            displayName: 'IOL Course Completion',
                            minWidth: 120,
                        }, {
                            field: 'followupAssigned',
                            displayName: 'Follow Up Assigned',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'followupItem',
                            displayName: 'Follow Up Item',
                            minWidth: 120,
                        }, {
                            field: 'followupAction',
                            displayName: 'Follow Up Action',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120,
                        }, {
                            field: 'admicIntCon',
                            id:45,
                            displayName: 'Academic Integrity Concern',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'gradTrack',
                            id:46,
                            displayName: 'Graduation Track',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'lowProgr',
                            id:47,
                            displayName: 'Low Progress',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'retentCon',
                            id:48,
                            displayName: 'Retention Concern',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs10plus',
                            id:49,
                            displayName: '10+ Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs1',
                            id:50,
                            displayName: '1 Day Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs2',
                            id:51,
                            displayName: '2 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs3',
                            id:52,
                            displayName: '3 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs4',
                            id:53,
                            displayName: '4 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs5',
                            id:54,
                            displayName: '5 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs6',
                            id:55,
                            displayName: '6 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs7',
                            id:56,
                            displayName: '7 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs8',
                            id:57,
                            displayName: '8 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs9',
                            id:58,
                            displayName: '9 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs10',
                            id:59,
                            displayName: '10 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs11',
                            id:60,
                            displayName: '11 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs12',
                            id:61,
                            displayName: '12 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs13',
                            id:62,
                            displayName: '13 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs14',
                            id:63,
                            displayName: '14 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs15',
                            id:64,
                            displayName: '15 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs16',
                            id:65,
                            displayName: '16 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs17',
                            id:66,
                            displayName: '17 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs18',
                            id:67,
                            displayName: '18 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs19',
                            id:68,
                            displayName: '19 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'daysAbs20',
                            id:69,
                            displayName: '20 Days Absent',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'actNoAtt',
                            id:70,
                            displayName: 'Activity with No Attendance Logged',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'behindHrs',
                            id:71,
                            displayName: 'Behind in Hours',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'excAbbNot',
                            id:72,
                            displayName: 'Excessive Absentee W/D Notification',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'goodAtt',
                            id:73,
                            displayName: 'Good Attendance',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'missMoreAttNot',
                            id:74,
                            displayName: 'Missing 10% or More Attendance Notice',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'nonEmailCont',
                            id:75,
                            displayName: 'Non-Email Contact',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'compDocNeed',
                            id:76,
                            displayName: 'Compliance Document Needed',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'compuApp',
                            id:77,
                            displayName: 'Computer Approval',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'famIncForm',
                            id:78,
                            displayName: 'Family Income Form',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'phoneNumUpdate',
                            id:79,
                            displayName: 'Phone Number Update',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'behaviorCon',
                            id:80,
                            displayName: 'Behavior Concern',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'couLockCommu',
                            id:81,
                            displayName: 'Course Lock Communication',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'limitedAct',
                            id:82,
                            displayName: 'Limited Activity',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'lowCCAtt',
                            id:83,
                            displayName: 'Low Class Connect Attendance',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'noLogin',
                            id:84,
                            displayName: 'No Login',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'winbackCall',
                            id:85,
                            displayName: 'Winback Call',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'engPlanCall',
                            id:86,
                            displayName: 'Engagement Plan Call',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'meeting504',
                            id:87,
                            displayName: '504 Meeting',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'iEPMeeting',
                            id:88,
                            displayName: 'IEP Meeting',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'irip',
                            id:89,
                            displayName: 'IRIP',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'tieredInst',
                            id:90,
                            displayName: 'Tiered Instruction',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'missStuConn',
                            id:91,
                            displayName: 'Missed Student Connection Calling',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'orientation',
                            id:92,
                            displayName: 'Orientation',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'onboarding',
                            id:93,
                            displayName: 'Onboarding',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'stateTestAssign',
                            id:94,
                            displayName: 'State Testing Assignment',
                            sortingAlgorithm: sortDateFn,
                            minWidth: 120
                        }, {
                            field: 'familyLanguage',
                            displayName: 'Family Language',
                            minWidth: 120
                        }, {
                            field: 'studentLanguage',
                            displayName: 'Student Language',
                            minWidth: 120
                        }],

                    };


                    // default checkbox selection to false
                    function resetCategoriesFlags() {
                        $scope.student.isDemoDataChecked = false;
                        $scope.student.isAttendanceChecked = false;
                        $scope.student.isInstrLevelsChecked = false;
                        $scope.student.isMTSSLevelsChecked = false;
                        $scope.student.isGradPlanChecked = false;
                        $scope.student.isStrongStartChecked = false;
                        $scope.student.isEngagementChecked = false;
                        $scope.student.isFASTChecked = false;
                        $scope.student.isPulseCheckChecked = false;
                        $scope.student.isActionNeededChecked = false;
                        $scope.student.isReRegistrationChecked =false;
                        $scope.student.isMessagedChecked =false;
                        $scope.student.isMessagedAcademicsChecked=false;
                        $scope.student.isMessagedAttendanceChecked=false;
                        $scope.student.isMessagedComplianceChecked=false;
                        $scope.student.isMessagedEngagementChecked=false;
                        $scope.student.isMessagedSpeProgramChecked=false;
                        $scope.student.isMessagedStStartChecked=false;
                        $scope.student.isMessagedTestChecked=false;

                    }

                    // initialize Search Categories Accordions
                    resetCategoriesFlags();
                    $scope.searchAccordion = {
                        demographicsToggle: true,
                        attendanceToggle: true,
                        instrLevelToggle: true,
                        mtssLevelToggle: true,
                        gradPlanToggle: true,
                        strongStartToggle: true,
                        engagementToggle: true,
                        fastToggle: true,
                        pulseToggle: true,
                        actionToggle: true,
                        messagedToggle: true,
                        messaged_AcademicsToggle:true,
                        messaged_AttendanceToggle:true,
                        messaged_ComplianceToggle:true,
                        messaged_EngagementToggle:true,
                        messaged_SpeProgramToggle:true,
                        messaged_TestToggle:true,
                        opened: true,
                        gradPlanToggle: true
                    };

                
                    //TODO: Make generic resetCategory function
                    $scope.resetInstrLevels = function() {
                        if (!$scope.student.isInstrLevelsChecked) {
                            $scope.student.instrLevels = {};
                        }
                    } 
                    
                    $scope.resetMtssLevels = function() {
                        if (!$scope.student.isMTSSLevelsChecked) {
                            $scope.student.mtsslvls = {};
                        }
                    }
                   
                    $scope.resetDemoData = function() {
                        if (!$scope.student.isDemoDataChecked) {
                            $scope.student.demoData = {};
                        } else {
                            $scope.student.demoData.studentType = 'All';
                        }
                    }

                    $scope.resetAttendance = function() {
                        if (!$scope.student.isAttendanceChecked) {
                            $scope.student.attendance = {};
                        }else{
                        	$scope.student.attendance.excludeStFromAtt = 'All';
                        }
                    }

                    $scope.resetGradPlan = function() {
                        if (!$scope.student.isGradPlanChecked) {
                            $scope.student.gradPlan = {};
                        }else{
                              $scope.student.gradPlan.readyStuView = 'All';
                        }
                    }

                    $scope.resetStrongStart = function() {
                        if (!$scope.student.isStrongStartChecked) {
                            $scope.student.strongStart = {};
                        }
                    }

                    $scope.resetEngagement = function() {
                        if (!$scope.student.isEngagementChecked) {
                            $scope.student.engagement = {};
                        }
                    }

                    $scope.resetActionNeededData = function() {
                        if (!$scope.student.isActionNeededChecked) {
                            $scope.student.actionNeeded = {};
                        }
                    }

                    $scope.resetReRegistrationData = function() {

                        if (!$scope.student.isReRegistrationChecked) {
                            $scope.student.reReData = {};
                        }else{
                            $scope.student.reReData.reRegInfoSession = 'All';
                            $scope.student.reReData.reRegIOLCC = 'All';
                        }
                    }

                    $scope.resetPulseCheck = function() {
                        if (!$scope.student.isPulseCheckChecked) {
                            $scope.student.pulseCheck = {};
                        }
                    }

                    $scope.resetFastData = function() {
                        if (!$scope.student.isFASTChecked) {
                            $scope.student.fast.enduringConnectnCallQualifier='';
                            $scope.student.fast.enduringConnectnCall='';
                            $scope.student.fast.fastRunningNoteQualifier='';
                            $scope.student.fast.fastRunningNoteDate='';
                            $scope.student.fast.teacherCompliancyNoteQualifier='';
                            $scope.student.fast.teacherCompliancyNoteDate='';

                        }
                    }

                    $scope.resetMessagedData = function() {
                        if (!$scope.student.isMessagedChecked) {
                            
                        	
                            $scope.student.isMessagedAcademicsChecked = false;
                            $scope.student.isMessagedAttendanceChecked = false;
                            $scope.student.isMessagedComplianceChecked = false;
                            $scope.student.isMessagedEngagementChecked = false;
                            $scope.student.isMessagedSpeProgramChecked = false;
                            $scope.student.isMessagedStStartChecked = false;
                            $scope.student.isMessagedTestChecked = false;
                            $scope.resetMessagedAcademicsData();
                            $scope.resetMessagedAttendanceData();
                            $scope.resetMessagedComplianceData();
                            $scope.resetMessagedEngagementData();
                            $scope.resetMessagedSpeProgramData();
                            $scope.resetMessagedStStartData();
                            $scope.resetMessagedTestData();
                        }
                    }
                    $scope.resetMessagedAcademicsData = function() {
                        if (!$scope.student.isMessagedAcademicsChecked) {
                            $scope.student.messaged.admicIntConQualifier = '';
                            $scope.student.messaged.admicIntCon = '';
                            $scope.student.messaged.gradTrackQualifier = '';
                            $scope.student.messaged.gradTrack = '';
                            $scope.student.messaged.lowProgrQualifier = '';
                            $scope.student.messaged.lowProgr = '';
                            $scope.student.messaged.retentConQualifier = '';
                            $scope.student.messaged.retentCon ='';

                        }
                    }
                    $scope.resetMessagedAttendanceData = function() {
                        if (!$scope.student.isMessagedAttendanceChecked) {
                            $scope.student.messaged.daysAbs10plusQualifier='';
                            $scope.student.messaged.daysAbs10plus='';
                            for(var i=1; i<=20; i++){
                               $scope.student.messaged['daysAbs'+ i + 'Qualifier'] = '';
                               $scope.student.messaged['daysAbs' + i] = '';
                            }
                            $scope.student.messaged.actNoAttQualifier='';
                            $scope.student.messaged.actNoAtt='';  
                            $scope.student.messaged.behindHrsQualifier='';
                            $scope.student.messaged.behindHrs='';         
                            $scope.student.messaged.excAbbNotQualifier='';
                            $scope.student.messaged.excAbbNot='';  
                            $scope.student.messaged.goodAttQualifier='';
                            $scope.student.messaged.goodAtt='';  
                            $scope.student.messaged.missMoreAttNotQualifier='';
                            $scope.student.messaged.missMoreAttNot='';
                            $scope.student.messaged.nonEmailContQualifier='';
                            $scope.student.messaged.nonEmailCont='';  
                            }
                    }

                    $scope.resetMessagedComplianceData = function() {
                        if (!$scope.student.isMessagedComplianceChecked) {
                            $scope.student.messaged.compDocNeedQualifier = '';
                            $scope.student.messaged.compDocNeed = '';
                            $scope.student.messaged.compuAppQualifier = '';
                            $scope.student.messaged.compuApp = '';
                            $scope.student.messaged.famIncFormQualifier = '';
                            $scope.student.messaged.famIncForm = '';
                            $scope.student.messaged.phoneNumUpdateQualifier = '';
                            $scope.student.messaged.phoneNumUpdate ='';

                        }
                    }

                    $scope.resetMessagedEngagementData = function() {
                        if (!$scope.student.isMessagedEngagementChecked) {
                            $scope.student.messaged.behaviorConQualifier = '';
                            $scope.student.messaged.behaviorCon = '';
                            $scope.student.messaged.couLockCommuQualifier = '';
                            $scope.student.messaged.couLockCommu = '';
                            $scope.student.messaged.limitedActQualifier = '';
                            $scope.student.messaged.limitedAct = '';
                            $scope.student.messaged.lowCCAttQualifier = '';
                            $scope.student.messaged.lowCCAtt ='';
                            $scope.student.messaged.noLoginQualifier = '';
                            $scope.student.messaged.noLogin ='';
                            $scope.student.messaged.winbackCallQualifier = '';
                            $scope.student.messaged.winbackCall ='';
                            $scope.student.messaged.engPlanCallQualifier = '';
                            $scope.student.messaged.engPlanCall ='';
                        }
                    }
                    $scope.resetMessagedSpeProgramData = function() {
                        if (!$scope.student.isMessagedSpeProgramChecked) {
                            $scope.student.messaged.meeting504Qualifier = '';
                            $scope.student.messaged.meeting504 = '';
                            $scope.student.messaged.iEPMeetingQualifier = '';
                            $scope.student.messaged.iEPMeeting = '';
                            $scope.student.messaged.iripQualifier = '';
                            $scope.student.messaged.irip = '';
                            $scope.student.messaged.tieredInstQualifier = '';
                            $scope.student.messaged.tieredInst ='';
                        }
                    }                    
                    $scope.resetMessagedStStartData = function(){
                        if (!$scope.student.isMessagedStStartChecked) {
                            $scope.student.messaged.missStuConnQualifier = '';
                            $scope.student.messaged.missStuConn = '';
                            $scope.student.messaged.orientationQualifier = '';
                            $scope.student.messaged.orientation = '';
                            $scope.student.messaged.onboardingQualifier = '';
                            $scope.student.messaged.onboarding = '';
                        }                        
                    }
                    $scope.resetMessagedTestData = function(){
                        if (!$scope.student.isMessagedTestChecked) {
                            $scope.student.messaged.stateTestAssignQualifier = '';
                            $scope.student.messaged.stateTestAssign = '';
                        }                        
                    }

                    $scope.closeSuccessMsg = function() {
                        $rootScope.closeSuccessClick = true;
                    }

                    $scope.closeActionSuccessMsg = function() {
                        $rootScope.actionCompletedSuccessfully = false;
                    }

                    $scope.closeWarningMsg = function() {
                        $rootScope.invalidFieldsWarning = false;
                    }

                    $scope.deleteSearch = false;
                    $rootScope.removeSearch = false;
                    $scope.removeSavedSearch = function(item, index){
                        var openDeleteModal = $uibModal.open({
                            animation: $scope.animationsEnabled,
                            templateUrl: 'sharedDialog.html',
                            keyboard: false,
                            backdrop: 'static',
                            scope: $scope,
                            controller: ['$scope', '$uibModalInstance',
                            function ($scope, $uibModalInstance){
                                $scope.cancel = function(){
                                    $uibModalInstance.close("cancel");
                                };
                                $scope.dialogMsg = "You are about to delete one of the saved searches that you own. If the search has been shared with other users, they will no longer be able to access it. Do you want to continue?";
                                $scope.ok = function(){
                                    $uibModalInstance.close("ok");
                                };
                            }],
                        }); 

                        var searches = [];
                        openDeleteModal.result.then(function (option) {
                            if($rootScope.actionCompletedSuccessfully){
                                $rootScope.actionCompletedSuccessfully = false;
                            }
                            $rootScope.saveSearchSuccess = false;
                              if(option=="cancel"){
                                console.log("no: keep search")
                              } else if(option=="ok"){
                                console.log("yes: delete search")
                                $scope.deleteSearch = true;
                                $scope.deletedItemId = item.id;
                                $rootScope.removeSearch = true;
                                console.log("item id", $scope.deletedItemId)

                                //invoke delete service
                                 manageStudentDataSvc.deleteSavedSearchbyPerson(authentication.getCurrentUser().keycode, item)
                                    .then(function(data, status, headers, config) {
                                        $scope.savedSearchbyPersonList = data.savedSearchOwnList;
                                        console.log("response", data)  
                                    },
                                        function(data, status, headers, config) {
                                            console.error("ERROR OCCURRED");
                                    });

                                //splice deleted objects from $scope.savedSearchObj
                                searches = $scope.savedSearchObj;
                                console.log("before delete: $scope.savedSearchObj", $scope.savedSearchObj);

                                searches.splice(_.findIndex(searches, function(item) {
                                    return item.id === $scope.deletedItemId;
                                }), 1);
                                console.log("after delete: $scope.savedSearchObj", $scope.savedSearchObj);
                                $scope.savedSearchbyPersonList = getSavedSearchbyPerson();
                                $scope.newSearchSaveSelect = -1;

                            }          
                        });
                    }

                    var sessionSaveListUnique = [];
                    var savedSearchObject = [];
                    $scope.getSavedSearchLists = function(){
                        $scope.saveOrUpdateModal = false;
                        $rootScope.removeSearch = false;
                         if($scope.savedSearchObj){
                            //build sessionSaveList from savedSearchObj
                            savedSearchObject = $scope.savedSearchObj;
                            sessionSaveListUnique = _.uniq($scope.savedSearchObj, function(x){
                                return x.id;
                            });

                            //fetch and reload list on deleting search
                            if($scope.deleteSearch){
                                $scope.savedSearchbyPersonList = getSavedSearchbyPerson();
                                $scope.deleteSearch = false;
                            }

                            //build uniqueSearchList from sessionSaveList
                            var arr = (sessionSaveListUnique).concat($scope.savedSearchbyPersonList);
                            var uniqueSearchList = _.uniq(arr, function(x){
                                return x.id;
                            });

                            //stores array of objects for multiple saves
                            var lastSavedListObj = [];
                            lastSavedListObj.push(_.first($scope.savedSearchObj));

                            //sort resulting uniqueSearchList and display as $scope.items
                            var res = $scope.items = _.sortBy(uniqueSearchList, function(o) { return o.name.toLowerCase(); });
                            var savedSearchId = (_.pluck((lastSavedListObj), 'id')).toString();

                            if($rootScope.searchDeleted){
                                $scope.newSearchSaveSelect = -1;
                            }

                            if($rootScope.saveSearchSuccess){
                                $scope.newSearchSaveSelect = _.indexOf(_.pluck(res, 'id'), savedSearchId);
                            } 
                         }
                    }

                    $scope.populateSearch = function(item){
                         $scope.displayGrid = false;
                         $scope.searchErrorOccurred = false;
                         $scope.savedSearchClicked = true;
                         $scope.saveClicked = false;
                         $scope.ownedSharedSelected = false;

                         $scope.selectedSearchItem = item;
                         $scope.selectedSearchItemCopy = angular.copy($scope.selectedSearchItem);
                         $scope.newSearchSelect = _.indexOf(_.pluck($scope.items, 'id'), item.id);
                         console.log("item populateSearch", item);

                        if(item.ownerId == $scope.personId){
                            console.log("Owned Search");
                            $scope.newSearchSelect = _.indexOf(_.pluck($scope.items, 'id'), item.id);
                            $scope.newSearchSharedSelect = -1;
                            $scope.ownedSharedSelected = true;
                        }

                        if(item.shareSave && !$scope.ownedSharedSelected){
                            $scope.sharedSearchSelected = true;
                            $scope.newSearchSharedSelect = _.indexOf(_.pluck($scope.sharedItems, 'id'), item.id);
                        }

                         var schoolArr = _.pluck($scope.schoollist, 'schoolId');
                         var itemSchoolArr = item.content.schoolIds ? (item.content.schoolIds).split(',').map(Number) : '';
                         var schoolIntersection = _.intersection(schoolArr, itemSchoolArr);

                         var cohortArr = $scope.cohortYearsList;
                         var itemCohortArr = item.content.gradPlanCohortYears ? (item.content.gradPlanCohortYears).split(',').map(Number) : '';
                         var cohortIntersection = _.intersection(cohortArr, itemCohortArr);
                        
                         var itemSchoolCohortArr = item.content.gradPlanSchoolCohortYears ? (item.content.gradPlanSchoolCohortYears).split(',').map(Number) : '';
                         var cohortSchoolIntersection = _.intersection(cohortArr, itemSchoolCohortArr);
                       
                         $scope.student = studentSaveSearch.getSavedStudentObj(item, $scope.dataFieldListbySchools, $scope.hasAttendanceSchoolAccess);
                         //update student obj with school, gp years lists
                         $scope.student.school = (schoolIntersection.length > 0) ? (schoolIntersection.toString().split(",")) : [];
                         $scope.student.gradPlan.cohortYear = (cohortIntersection.length > 0) ? cohortIntersection : [];
                         $scope.student.gradPlan.schoolCohortYear = (cohortSchoolIntersection.length > 0) ? cohortSchoolIntersection : [];

                         $scope.callStudentSearchService();
                         // console.log("$scope.student after savedsearch", $scope.student);
                    };

                    $scope.studentSearchCall = function() {
                        console.log("Student Search invoked");
                        $scope.saveOrUpdateModal = false;
                    }

                    $scope.saveStudentSearchService = function() {
                        $scope.isSaveSearchBusy = true;
                        $scope.saveClicked = true;
                        $scope.isSearchBusy = false;
                        $rootScope.invalidFieldsWarning = false;
                        $rootScope.invalidFieldsWarningMessage = '';
                        $scope.updateSearchFlag = false;

                        //One of owned saved searches is clicked
                        if($scope.savedSearchClicked && $scope.ownedSharedSelected){
                            var openSearchSavedModal = $uibModal.open({
                                animation: $scope.animationsEnabled,
                                templateUrl: 'saveSearchDialog.html',
                                keyboard: false,
                                backdrop: 'static',
                                scope: $scope,
                                controller: ['$scope', '$uibModalInstance',
                                function ($scope, $uibModalInstance){
                                    $scope.saveOrUpdateModal = true;
                                    $scope.updateSearch = function(){
                                        $scope.callStudentSearchService();
                                        $uibModalInstance.close("update");
                                    };
                                    $scope.dialogMsg = "Do you want to save a new search or update your existing search?";
                                    $scope.newSearch = function(){
                                        $scope.callStudentSearchService();
                                        $uibModalInstance.close("new");
                                    };
                                }],
                            }); 

                            openSearchSavedModal.result.then(function (option) {
                                  $scope.newSearchSelect = -1;
                                  $scope.newSearchSharedSelect = -1;
                                  $scope.saveOrUpdateModal = true;
                                  if(option=="update"){
                                    $scope.updateSearchFlag = true;
                                    $scope.selectedSearchItem = $scope.selectedSearchItem;
                                  } else if(option=="new"){
                                    console.log("Save new search");
                                    $scope.updateSearchFlag = false;
                                    $scope.selectedSearchItem = {};
                                  }
                                  $scope.selectedSearchItem = !$scope.updateSearchFlag ? {} : $scope.selectedSearchItemCopy;
                                  $scope.isSearchBusy = false;
                                  $scope.isSearchDisabled = false;
                                  $scope.isSaveSearchBusy  = $scope.searchErrorOccurred ? false : true;
                                  $scope.isSaveSearchDisabled = $scope.isSaveSearchBusy ? true : false;
                            });

                        } else if($scope.sharedSearchSelected && !$scope.ownedSharedSelected){
                            //One of shared searches is clicked
                            console.log("Shared Search");
                            var openSharedModal = $uibModal.open({
                                animation: $scope.animationsEnabled,
                                templateUrl: 'sharedDialog.html',
                                keyboard: false,
                                backdrop: 'static',
                                scope: $scope,
                                controller: ['$scope', '$uibModalInstance',
                                function ($scope, $uibModalInstance){
                                    $scope.cancel = function(){
                                        $uibModalInstance.close("cancel");
                                    };
                                    $scope.dialogMsg = "This search is owned by " + $scope.selectedSearchItemCopy.ownerName+ " and cannot be edited. Do you want to save a new search?";
                                    $scope.ok = function(){
                                        $scope.callStudentSearchService();
                                        $uibModalInstance.close("ok");
                                    };
                                }],
                            }); 

                            openSharedModal.result.then(function (option) {
                                  $scope.newSearchSelect = -1;
                                  $scope.newSearchSharedSelect = -1;
                                  if(option=="cancel"){
                                    $scope.isSaveSearchBusy = false;

                                  } else if(option=="ok"){
                                    $scope.isSaveSearchBusy  = $scope.searchErrorOccurred ? false : true;
                                  }
                                  $scope.selectedSearchItem = {};
                                  $scope.isSearchBusy = false;
                                  $scope.isSearchDisabled = false;
                                  $scope.isSaveSearchDisabled = $scope.isSaveSearchBusy ? true : false;
                            });

                        } else {
                            //No search, direct save is clicked
                            console.log("save - no search clicked");
                            $scope.callStudentSearchService();
                        }

                         console.log("$scope.selectedSearchItem", $scope.selectedSearchItem);
                         console.log("$scope.savedSearchClicked", $scope.savedSearchClicked);
                         $scope.isSearchBusy = false;
                         $scope.isSearchDisabled = false;
                         $scope.isSaveSearchBusy  = $scope.searchErrorOccurred ? false : true;
                         $scope.isSaveSearchDisabled = $scope.isSaveSearchBusy ? true : false;
                    }

                    //On clicking Search button, following call gets executed				
                    $scope.callStudentSearchService = function(grid, row) {
                        // console.log("Ideal", $scope.student);
                        // Show/hide columns based on the categories selected
                        $scope.selectedRowsCount = 0;
                        $scope.gridColumnVisibility();

                        // Initialize no-show directive variables
                        resetErrorFlags();

                        $scope.displayGrid = false;
                        $scope.invalidStudentIdExists = false;
        
                        if ($scope.isSearchValid()) {
                            console.info("Calling student search service");
                            var gradeLevels = ($scope.student.grade == null) ? $scope.student.grade :
                                $scope.student.grade.toString();
                            var specialPrograms = ($scope.student.demoData.spPrograms == null) ? $scope.student.demoData.spPrograms :
                                $scope.student.demoData.spPrograms.toString();
                            var personalGroups = ($scope.student.demoData.personalGroups == null) ? $scope.student.demoData.personalGroups :
                                $scope.student.demoData.personalGroups.toString();
                            var schoolIds = ($scope.student.school == null) ? $scope.student.school :
                                $scope.student.school.toString();
                            var categories = ($scope.getStudentCategories() == null) ? $scope.getStudentCategories() :
                                $scope.getStudentCategories().toString();
                            var requirementCategories = ($scope.student.gradPlan.requirementCategory == null) ? $scope.student.gradPlan.requirementCategory :
                               $scope.student.gradPlan.requirementCategory.toString();
                            var gradPlanCohortYears = ($scope.student.gradPlan.cohortYear == null) ? $scope.student.gradPlan.cohortYear :
                                $scope.student.gradPlan.cohortYear
                                .toString();
                            var gradPlanSchoolCohortYears = ($scope.student.gradPlan.schoolCohortYear == null) ? $scope.student.gradPlan.schoolCohortYear :
                                $scope.student.gradPlan.schoolCohortYear
                                .toString();
                            var gradPlanRequirementNames = ($scope.student.gradPlan.requirementName == null) ? $scope.student.gradPlan.requirementName :
                                $scope.student.gradPlan.requirementName
                                .toString();
                            var participantProgram = ($scope.student.demoData.participantProgram == null) ? $scope.student.demoData.participantProgram :
                                $scope.student.demoData.participantProgram.toString();
                            var currentCteProgram = ($scope.student.demoData.currentCteProgram == null) ? $scope.student.demoData.currentCteProgram :
                                $scope.student.demoData.currentCteProgram.toString();
                            var futureCteProgram = ($scope.student.demoData.futureCteProgram == null) ? $scope.student.demoData.futureCteProgram :
                                $scope.student.demoData.futureCteProgram.toString();    
                            // regexp to test fte number value
                            var re = /^\d*(\.\d*)+/;
                            var fteValue = function(value) {
                                // decimal number must work with . and , as well
                                if (value) {
                                    var str_number = value.replace(',', '.');
                                    value = re.test(str_number) ? parseFloat(str_number) : value;
                                }
                                return value;
                            };
                            // Spins cog. Indicates search is in
                            // progress
                            $scope.isSearchBusy = true;
                            // Disabling search button prevents
                            // multiple requests
                            $scope.isSaveSearchBusy = $scope.saveClicked && !$scope.isSearchBusy ? true : false;
                            $scope.isSearchDisabled = $scope.isSearchBusy ? true : false;
                            

                            if($scope.student.mtsslvls &&  
                              ($scope.student.mtsslvls.ELALevel || $scope.student.mtsslvls.MathLevel || $scope.student.mtsslvls.ScienceLevel ||
                               $scope.student.mtsslvls.HistoryLevel))
                            {
                            	getMTSSLevels();
                            }	
                            
                            $scope.searchRequestPayload = {
                                        "firstName": $scope.student.firstName,
                                        "lastName": $scope.student.lastName,
                                        "studentIds": $scope.student.studentId,
                                        "status": $scope.student.status,
                                        "identityId": $scope.student.demoData.identityId,
                                        "familyId": $scope.student.demoData.familyId,
                                        "gradeLevels": gradeLevels,
                                        "specialPrograms": specialPrograms,
                                        "schoolIds": schoolIds,
                                        "type": $scope.student.demoData.studentType,
                                        //"excludeStFromAtt": ($scope.student.isAttendanceChecked && $scope.hasAttendanceAdjusterRole) ? $scope.student.attendance.excludeStFromAtt : null,
                                        //Change below for the defect SIS-694: excludeStFromAtt should be available irrespective of the role
                                        "excludeStFromAtt": ($scope.student.isAttendanceChecked) ? $scope.student.attendance.excludeStFromAtt : null,
                                                        
                                        "attendance1stDay": $filter('date')($scope.student.attendance.attendance1stDay, 'MM/dd/yyyy'),
                                        "attendance1stDayQualifier": $scope.student.attendance.attendance1stDayQualifier,
                                        "attendanceLastDay": $filter('date')($scope.student.attendance.attendanceLastDay, 'MM/dd/yyyy'),
                                        "attendanceLastDayQualifier": $scope.student.attendance.attendanceLastDayQualifier,
                                        "consecutiveDaysAbsent": $scope.student.attendance.consecutiveDaysAbsent,
                                        "consecutiveDaysAbsentQualifier": $scope.student.attendance.consecutiveDaysAbsentQualifier,
                                        "truancyDate": $filter('date')($scope.student.attendance.truancyDate, 'MM/dd/yyyy'),
                                        "truancyDateQualifier": $scope.student.attendance.truancyDateQualifier,
                                        "percentAttended": $scope.student.attendance.percentAttended,
                                        "percentAttendedQualifier": $scope.student.attendance.percentAttendedQualifier,
                                        "totalDaysEnrolled": $scope.student.attendance.totalDaysEnrolled,
                                        "totalDaysEnrolledQualifier": $scope.student.attendance.totalDaysEnrolledQualifier,
                                        "daysPresent": $scope.student.attendance.daysPresent,
                                        "daysPresentQualifier": $scope.student.attendance.daysPresentQualifier,
                                        "daysAbsent": $scope.student.attendance.daysAbsent,
                                        "daysAbsentQualifier": $scope.student.attendance.daysAbsentQualifier,
                                        "totalHrs": $scope.student.attendance.totalHrs,
                                        "totalHrsQualifier": $scope.student.attendance.totalHrsQualifier,
                                        "lastAttemptedLesson": $filter('date')($scope.student.attendance.lastLesson, 'MM/dd/yyyy'),
                                        "lastAttemptedLessonQualifier": $scope.student.attendance.lastLessonQualifier,
                                        "missingHrs": $scope.student.attendance.missingHrs,
                                        "missingHrsQualifier": $scope.student.attendance.missingHrsQualifier,
                                        "attHrs4Week": $scope.student.attendance.attHrs4Week,
                                        "attHrs4WeekQualifier": $scope.student.attendance.attHrs4WeekQualifier,
                                        "attHrsMissing4Week": $scope.student.attendance.attHrsMissing4Week,
                                        "attHrsMissing4WeekQualifier": $scope.student.attendance.attHrsMissing4WeekQualifier,
                                        "attLast7Days": $scope.student.attendance.attLast7Days,
                                        "attLast7DaysQualifier": $scope.student.attendance.attLast7DaysQualifier,
                                        "attMissingLast7Days": $scope.student.attendance.attMissingLast7Days,
                                        "attMissingLast7DaysQualifier": $scope.student.attendance.attMissingLast7DaysQualifier,
                                        "att4Week": $scope.student.attendance.att4Week,
                                        "att4WeekQualifier": $scope.student.attendance.att4WeekQualifier,
                                        "attMissing4Week": $scope.student.attendance.attMissing4Week,
                                        "attMissing4WeekQualifier": $scope.student.attendance.attMissing4WeekQualifier,
                                        "totalOnlineTime": $scope.student.attendance.totalOnlineTime,
                                        "totalOnlineTimeQualifier": $scope.student.attendance.totalOnlineTimeQualifier,
                                        "totalOfflinetime": $scope.student.attendance.totalOfflinetime,
                                        "totalOfflinetimeQualifier": $scope.student.attendance.totalOfflinetimeQualifier,
                                        "missingOverHrs": $scope.student.attendance.missingOverHrs,
                                        "missingOverHrsQualifier": $scope.student.attendance.missingOverHrsQualifier,
                                        "absentSchoolDays": $scope.student.attendance.absentSchoolDays,
                                        "makeupDays": $scope.student.attendance.makeupDays,
                                        "excusedAbsences": $scope.student.attendance.excusedAbsences,
                                        "att4Sem": $scope.student.attendance.att4Sem,
                                        "att4SemQualifier": $scope.student.attendance.att4SemQualifier,
                                        "missing4Sem": $scope.student.attendance.missing4Sem,
                                        "missing4SemQualifier": $scope.student.attendance.missing4SemQualifier,
                                        "firstDayAttModified": $filter('date')($scope.student.attendance.firstDayAttModified, 'MM/dd/yyyy'),
                                        "firstDayAttModifiedQualifier": $scope.student.attendance.firstDayAttModifiedQualifier,
                                        "enrollmentDate": $filter('date')($scope.student.demoData.enrollmentDate, 'MM/dd/yyyy'),
                                        "enrollmentDateQualifier": $scope.student.demoData.enrollmentDateQualifier,
                                        "schoolWithdrawalDate": $filter('date')($scope.student.demoData.schoolWithdrawalDate, 'MM/dd/yyyy'),
                                        "schoolWithdrawalDateQualifier": $scope.student.demoData.schoolWithdrawalDateQualifier,
                                        "enrollmentReceivedDate": $filter('date')($scope.student.demoData.enrollmentReceivedDate, 'MM/dd/yyyy'),
                                        "enrollmentReceivedDateQualifier": $scope.student.demoData.enrollmentReceivedDateQualifier,
                                        "enrollmentApprovedDate": $filter('date')($scope.student.demoData.enrollmentApprovedDate, 'MM/dd/yyyy'),
                                        "enrollmentApprovedDateQualifier": $scope.student.demoData.enrollmentApprovedDateQualifier,
                                        "fullTime": $scope.student.demoData.fullTime ? $scope.student.demoData.fullTime : null,
                                        "fundingModel": $scope.student.demoData.fundingModel,
                                        "fte": fteValue($scope.student.demoData.fte),
                                        "familyLanguage": $scope.student.demoData.familyLanguage,
                                        "studentLanguage": $scope.student.demoData.studentLanguage,
                                        "counselor": $scope.student.demoData.counselor,
                                        "personalGroups": personalGroups,
                                        "participantProgram": participantProgram,
                                        "currentCteProgram": currentCteProgram,
                                        "futureCteProgram": futureCteProgram,
                                        "categories": categories,
                                        "elaInstrLvl": $scope.student.instrLevels.ELALevel,
                                        "writingInstrLvl": $scope.student.instrLevels.WritingLevel,
                                        "mathInstrLvl": $scope.student.instrLevels.MathLevel,
                                        "scienceInstrLvl": $scope.student.instrLevels.ScienceLevel,
                                        "ssHistoryInstrLvl": $scope.student.instrLevels.HistoryLevel,
                                        
                                        "elaMtssLvlId": $scope.student.mtsslvls.ELALevel,
                                        "mathMtssLvlId": $scope.student.mtsslvls.MathLevel,
                                        "scienceMtssLvlId": $scope.student.mtsslvls.ScienceLevel,
                                        "ssHistoryMtssLvlId": $scope.student.mtsslvls.HistoryLevel,
                                        
                                        "diplomaAssigned": $scope.student.gradPlan.diplomaAssigned,
                                        "diplomaAssignedName": $scope.student.gradPlan.diplomaAssignedName,
                                        "creditsEarnedQualifier": $scope.student.gradPlan.creditsEarnedQualifier,
                                        "stCreditsEarned": $scope.student.gradPlan.stCreditsEarned,
                                        "creditsNeededGradQualifier": $scope.student.gradPlan.creditsNeededGradQualifier,
                                        "stCreditsNeededGrad": $scope.student.gradPlan.stCreditsNeededGrad,
                                        "creditsInProgressQualifier": $scope.student.gradPlan.creditsInProgressQualifier,
                                        "stCreditsInProgress": $scope.student.gradPlan.stCreditsInProgress,
                                        "creditsNeededQualifier": $scope.student.gradPlan.creditsNeededQualifier,
                                        "stCreditsNeeded": $scope.student.gradPlan.stCreditsNeeded,
                                        "gradPlanCohortYears": gradPlanCohortYears,
                                        "gradPlanSchoolCohortYears": gradPlanSchoolCohortYears,
                                        "planLastModifiedDate": $filter('date')($scope.student.gradPlan.planLastModifiedDate, 'MM/dd/yyyy'),
                                        "planLastModifiedDateQualifier": $scope.student.gradPlan.planLastModifiedDateQualifier,
                                        "gradPlanRequirementName": gradPlanRequirementNames,
                                        "readyStuView": $scope.student.isGradPlanChecked ? $scope.student.gradPlan.readyStuView : null,
                                        "firstAccDateQualifier": $scope.student.gradPlan.firstAccDateQualifier,
                                        "firstAccDate": $filter('date')($scope.student.gradPlan.firstAccDate, 'MM/dd/yyyy'),
                                        "lastAccDateQualifier": $scope.student.gradPlan.lastAccDateQualifier,
                                        "lastAccDate": $filter('date')($scope.student.gradPlan.lastAccDate, 'MM/dd/yyyy'),
                                        "timesViewedQualifier": $scope.student.gradPlan.timesViewedQualifier,
                                        "timesViewed": $scope.student.gradPlan.timesViewed,

                                        "dsp": $scope.student.strongStart.DSPLevel,
                                        "followupActionQualifier": $scope.student.actionNeeded.followUpActionQualifier,
                                        "followupActionDate": $filter('date')($scope.student.actionNeeded.followUpActionDate, 'MM/dd/yyyy'),
                                        "followupItem": $scope.student.actionNeeded.followUpItem,
                                        "followupKeyword": $scope.student.actionNeeded.followUpItemKeyword,

                                        "enduringConnectnCallQualifier": $scope.student.fast.enduringConnectnCallQualifier,
                                        "enduringConnectnCall": $filter('date')($scope.student.fast.enduringConnectnCall, 'MM/dd/yyyy'),
                                        
                                        "fastRunningNoteQualifier": $scope.student.fast.fastRunningNoteQualifier,
                                        "fastRunningNoteDate": $filter('date')($scope.student.fast.fastRunningNoteDate, 'MM/dd/yyyy'),
                                        "teacherCompliancyNoteQualifier": $scope.student.fast.teacherCompliancyNoteQualifier,
                                        "teacherCompliancyNoteDate": $filter('date')($scope.student.fast.teacherCompliancyNoteDate, 'MM/dd/yyyy'),
                                        "pulseCheckQualifier": !$scope.student.pulseCheck ? $scope.student.pulseCheck : $scope.student.pulseCheck.qualifier,
                                        "pulseCheckDate": !$scope.student.pulseCheck ? $scope.student.pulseCheck : $filter('date')($scope.student.pulseCheck.mostRecentPulseCheckDate, 'MM/dd/yyyy'),
                                        "plsCheckReReLikeQualifier": $scope.student.pulseCheck.plsCheckReReLikeQualifier,
                                        "plsCheckReReLike": $scope.student.pulseCheck.plsCheckReReLike,
                                        "plsCheckSatisQualifier": $scope.student.pulseCheck.plsCheckSatisQualifier,
                                        "plsCheckSatis": $scope.student.pulseCheck.plsCheckSatis,
                                        "plsCheckPrepQualifier": $scope.student.pulseCheck.plsCheckPrepQualifier,
                                        "plsCheckPrep": $scope.student.pulseCheck.plsCheckPrep,
                                        "plsCheckStuSucRatQualifier": $scope.student.pulseCheck.plsCheckStuSucRatQualifier,
                                        "plsCheckStuSucRat": $scope.student.pulseCheck.plsCheckStuSucRat,
                                        "stActivityInLast7DaysQualifier": $scope.student.engagement.activityInLast7DaysQualifier,
                                        "stActivityInLast7Days": $scope.student.engagement.stActivityInLast7Days,
                                        "lastStLoginQualifier": $scope.student.engagement.lastStudentLoginQualifier,
                                        "lastStLoginDate": $filter('date')($scope.student.engagement.lastStudentLoginDate, 'MM/dd/yyyy'),
                                        "lastLCLoginQualifier": $scope.student.engagement.lastLCLoginQualifier,
                                        "lastLCLoginDate": $filter('date')($scope.student.engagement.lastLCLoginDate, 'MM/dd/yyyy'),
                                        "lastContactQualifier": $scope.student.engagement.lastContactQualifier,
                                        "lastContactDate": $filter('date')($scope.student.engagement.lastContactDate, 'MM/dd/yyyy'),
                                        "requirementCategory": requirementCategories,
                                        "requirementType": $scope.student.gradPlan.requirementType,
                                        "requirementStatus": $scope.student.gradPlan.requirementStatus,
                                        "reReStatus": ($scope.student.reReData.reReStatus == null) ? $scope.student.reReData.reReStatus : $scope.student.reReData.reReStatus.toString(),
                                        "reRegLastModDateQualifier":  $scope.student.reReData.reRegLastModDateQualifier,
                                        "reRegLastModDate":$filter('date')($scope.student.reReData.reRegLastModDate, 'MM/dd/yyyy'),
                                        "reRegApprLastModDateQualifier":  $scope.student.reReData.reRegApprLastModDateQualifier,
                                        "reRegApprLastModDate":  $filter('date')($scope.student.reReData.reRegApprLastModDate, 'MM/dd/yyyy'),
                                        "reRegAprovalStatus": $scope.student.reReData.reRegAprovalStatus,
                                        "reRegInfoSession": $scope.student.isReRegistrationChecked ? $scope.student.reReData.reRegInfoSession : null,
                                        "reRegIOLCC": $scope.student.isReRegistrationChecked ? $scope.student.reReData.reRegIOLCC : null,
                                        "reRegLastMailTemplate":  $scope.student.reReData.reRegLastMailTemplate,
                                        "reRegLastNoteTemplate":  $scope.student.reReData.reRegLastNoteTemplate,
                                        "nonConfirmedAbsences": $scope.student.attendance.nonConfirmedAbsences? $scope.student.attendance.nonConfirmedAbsences: null,
                                        "lcOnlyDays": $scope.student.attendance.lcOnlyDays? $scope.student.attendance.lcOnlyDays:null,
                                        "unexcusedAbsenceDays": $scope.student.attendance.unexcusedAbsenceDays? $scope.student.attendance.unexcusedAbsenceDays:null,
                                        "unexcusedAbsencesQualifier": $scope.student.attendance.unexcusedAbsencesQualifier,
                                        "unexcusedAbsences": $scope.student.attendance.unexcusedAbsences ? $scope.student.attendance.unexcusedAbsences : null,
                                        "excusedHrsQualifier": $scope.student.attendance.excusedHrsQualifier,
                                        "excusedHrs": $scope.student.attendance.excusedHrs ? $scope.student.attendance.excusedHrs : null,
                                        
                                        "numberOfExcusedAbsences":$scope.student.attendance.numberOfExcusedAbsences ? $scope.student.attendance.numberOfExcusedAbsences : null,
                                        "numberOfExcusedAbsencesQualifier":$scope.student.attendance.numberOfExcusedAbsencesQualifier ? $scope.student.attendance.numberOfExcusedAbsencesQualifier : null,
                                                    	
                                        "attLast14Days":$scope.student.attendance.attLast14Days ? $scope.student.attendance.attLast14Days : null, 
                                        "attLast14DaysQualifier":$scope.student.attendance.attLast14DaysQualifier ? $scope.student.attendance.attLast14DaysQualifier : null, 
                                                 
                                        "attForTerm":$scope.student.attendance.attForTerm ? $scope.student.attendance.attForTerm : null, 
                                        "attForTermQualifier":$scope.student.attendance.attForTermQualifier ? $scope.student.attendance.attForTermQualifier : null, 
                                                         
                                        "missingHoursLastMonth":$scope.student.attendance.missingHoursLastMonth ? $scope.student.attendance.missingHoursLastMonth : null,
                                    	"missingHoursCurrentMonth":$scope.student.attendance.missingHoursCurrentMonth ? $scope.student.attendance.missingHoursCurrentMonth : null,	
                                    	"missingHoursLastMonthQualifier":$scope.student.attendance.missingHoursLastMonthQualifier ? $scope.student.attendance.missingHoursLastMonthQualifier : null,
                                        "missingHoursCurrentMonthQualifier":$scope.student.attendance.missingHoursCurrentMonthQualifier ? $scope.student.attendance.missingHoursCurrentMonthQualifier : null,	
                                                        
                                                     			
                                        "unexcusedHrsQualifier": $scope.student.attendance.unexcusedHrsQualifier,
                                        "unexcusedHrs": $scope.student.attendance.unexcusedHrs ? $scope.student.attendance.unexcusedHrs : null,
                                        "admicIntConQualifier":  $scope.student.messaged.admicIntConQualifier,
                                        "admicIntCon":   $filter('date')($scope.student.messaged.admicIntCon,'MM/dd/yyyy'), 
                                        "gradTrackQualifier":  $scope.student.messaged.gradTrackQualifier,
                                        "gradTrack":  $filter('date')( $scope.student.messaged.gradTrack,'MM/dd/yyyy'), 
                                        "lowProgrQualifier":  $scope.student.messaged.lowProgrQualifier,
                                        "lowProgr":   $filter('date')($scope.student.messaged.lowProgr,'MM/dd/yyyy'), 
                                        "retentConQualifier":  $scope.student.messaged.retentConQualifier,
                                        "retentCon":   $filter('date')($scope.student.messaged.retentCon,'MM/dd/yyyy'), 
                                        "daysAbs10plusQualifier":  $scope.student.messaged.daysAbs10plusQualifier,
                                        "daysAbs10plus":   $filter('date')($scope.student.messaged.daysAbs10plus,'MM/dd/yyyy'), 
                                        "daysAbs1Qualifier":  $scope.student.messaged.daysAbs1Qualifier,
                                        "daysAbs1":  $filter('date')( $scope.student.messaged.daysAbs1,'MM/dd/yyyy'), 
                                        "daysAbs2Qualifier":  $scope.student.messaged.daysAbs2Qualifier,
                                        "daysAbs2":  $filter('date')( $scope.student.messaged.daysAbs2,'MM/dd/yyyy'), 
                                        "daysAbs3Qualifier":  $scope.student.messaged.daysAbs3Qualifier,
                                        "daysAbs3":   $filter('date')($scope.student.messaged.daysAbs3,'MM/dd/yyyy'), 
                                        "daysAbs4Qualifier":  $scope.student.messaged.daysAbs4Qualifier,
                                        "daysAbs4":  $filter('date')( $scope.student.messaged.daysAbs4,'MM/dd/yyyy'), 
                                        "daysAbs5Qualifier":  $scope.student.messaged.daysAbs5Qualifier,
                                        "daysAbs5":  $filter('date')( $scope.student.messaged.daysAbs5,'MM/dd/yyyy'), 
                                        "daysAbs6Qualifier":  $scope.student.messaged.daysAbs6Qualifier,
                                        "daysAbs6": $filter('date')(  $scope.student.messaged.daysAbs6,'MM/dd/yyyy'), 
                                        "daysAbs7Qualifier":  $scope.student.messaged.daysAbs7Qualifier,
                                        "daysAbs7":  $filter('date')( $scope.student.messaged.daysAbs7,'MM/dd/yyyy'), 
                                        "daysAbs8Qualifier":  $scope.student.messaged.daysAbs8Qualifier,
                                        "daysAbs8":  $filter('date')( $scope.student.messaged.daysAbs8,'MM/dd/yyyy'), 
                                        "daysAbs9Qualifier":  $scope.student.messaged.daysAbs9Qualifier,
                                        "daysAbs9":   $filter('date')($scope.student.messaged.daysAbs9,'MM/dd/yyyy'), 
                                        "daysAbs10Qualifier":  $scope.student.messaged.daysAbs10Qualifier,
                                        "daysAbs10":  $filter('date')( $scope.student.messaged.daysAbs10,'MM/dd/yyyy'), 
                                        "daysAbs11Qualifier":  $scope.student.messaged.daysAbs11Qualifier,
                                        "daysAbs11":  $filter('date')( $scope.student.messaged.daysAbs11,'MM/dd/yyyy'), 
                                        "daysAbs12Qualifier":  $scope.student.messaged.daysAbs12Qualifier,
                                        "daysAbs12":  $filter('date')( $scope.student.messaged.daysAbs12,'MM/dd/yyyy'), 
                                        "daysAbs13Qualifier":  $scope.student.messaged.daysAbs13Qualifier,
                                        "daysAbs13":  $filter('date')( $scope.student.messaged.daysAbs13,'MM/dd/yyyy'), 
                                        "daysAbs14Qualifier":  $scope.student.messaged.daysAbs14Qualifier,
                                        "daysAbs14":  $filter('date')( $scope.student.messaged.daysAbs14,'MM/dd/yyyy'), 
                                        "daysAbs15Qualifier":  $scope.student.messaged.daysAbs15Qualifier,
                                        "daysAbs15":  $filter('date')( $scope.student.messaged.daysAbs15,'MM/dd/yyyy'), 
                                        "daysAbs16Qualifier":  $scope.student.messaged.daysAbs16Qualifier,
                                        "daysAbs16":  $filter('date')( $scope.student.messaged.daysAbs16,'MM/dd/yyyy'), 
                                        "daysAbs17Qualifier":  $scope.student.messaged.daysAbs17Qualifier,
                                        "daysAbs17":  $filter('date')( $scope.student.messaged.daysAbs17,'MM/dd/yyyy'), 
                                        "daysAbs18Qualifier":  $scope.student.messaged.daysAbs18Qualifier,
                                        "daysAbs18": $filter('date')(  $scope.student.messaged.daysAbs18,'MM/dd/yyyy'), 
                                        "daysAbs19Qualifier":  $scope.student.messaged.daysAbs19Qualifier,
                                        "daysAbs19":  $filter('date')( $scope.student.messaged.daysAbs19,'MM/dd/yyyy'), 
                                        "daysAbs20Qualifier":  $scope.student.messaged.daysAbs20Qualifier,
                                        "daysAbs20":   $filter('date')($scope.student.messaged.daysAbs20,'MM/dd/yyyy'), 
                                        "actNoAttQualifier":  $scope.student.messaged.actNoAttQualifier,
                                        "actNoAtt":   $filter('date')($scope.student.messaged.actNoAtt,'MM/dd/yyyy'), 
                                        "behindHrsQualifier":  $scope.student.messaged.behindHrsQualifier,
                                        "behindHrs":   $filter('date')($scope.student.messaged.behindHrs,'MM/dd/yyyy'), 
                                        "excAbbNotQualifier":  $scope.student.messaged.excAbbNotQualifier,
                                        "excAbbNot":   $filter('date')($scope.student.messaged.excAbbNot,'MM/dd/yyyy'), 
                                        "goodAttQualifier":  $scope.student.messaged.goodAttQualifier,
                                        "goodAtt":  $filter('date')( $scope.student.messaged.goodAtt,'MM/dd/yyyy'), 
                                        "missMoreAttNotQualifier":  $scope.student.messaged.missMoreAttNotQualifier, 
                                        "missMoreAttNot":  $filter('date')( $scope.student.messaged.missMoreAttNot,'MM/dd/yyyy'), 
                                        "nonEmailContQualifier":  $scope.student.messaged.nonEmailContQualifier,
                                        "nonEmailCont":  $filter('date')( $scope.student.messaged.nonEmailCont,'MM/dd/yyyy'), 
                                        "compDocNeedQualifier":  $scope.student.messaged.compDocNeedQualifier,
                                        "compDocNeed":   $filter('date')($scope.student.messaged.compDocNeed,'MM/dd/yyyy'), 
                                        "compuAppQualifier":  $scope.student.messaged.compuAppQualifier,
                                        "compuApp":  $filter('date')( $scope.student.messaged.compuApp,'MM/dd/yyyy'), 
                                        "famIncFormQualifier":  $scope.student.messaged.famIncFormQualifier,
                                        "famIncForm":  $filter('date')( $scope.student.messaged.famIncForm,                        'MM/dd/yyyy'),                
                                        "phoneNumUpdateQualifier":  $scope.student.messaged.phoneNumUpdateQualifier, 
                                        "phoneNumUpdate":   $filter('date')($scope.student.messaged.phoneNumUpdate, 'MM/dd/yyyy'), 
                                        "behaviorConQualifier":  $scope.student.messaged.behaviorConQualifier, 
                                        "behaviorCon":   $filter('date')($scope.student.messaged.behaviorCon, 'MM/dd/yyyy'), 
                                        "couLockCommuQualifier":  $scope.student.messaged.couLockCommuQualifier, 
                                        "couLockCommu":  $filter('date')( $scope.student.messaged.couLockCommu, 'MM/dd/yyyy'), 
                                        "limitedActQualifier":  $scope.student.messaged.limitedActQualifier, 
                                        "limitedAct":  $filter('date')( $scope.student.messaged.limitedAct, 'MM/dd/yyyy'), 
                                        "lowCCAttQualifier": $scope.student.messaged.lowCCAttQualifier, 
                                        "lowCCAtt": $filter('date')( $scope.student.messaged.lowCCAtt, 'MM/dd/yyyy'), 
                                        "noLoginQualifier": $scope.student.messaged.noLoginQualifier, 
                                        "noLogin":  $filter('date')($scope.student.messaged.noLogin, 'MM/dd/yyyy'), 
                                        "winbackCallQualifier": $scope.student.messaged.winbackCallQualifier, 
                                        "winbackCall":  $filter('date')($scope.student.messaged.winbackCall, 'MM/dd/yyyy'), 
                                        "engPlanCallQualifier": $scope.student.messaged.engPlanCallQualifier, 
                                        "engPlanCall": $filter('date')( $scope.student.messaged.engPlanCall, 'MM/dd/yyyy'), 
                                        "meeting504Qualifier": $scope.student.messaged.meeting504Qualifier, 
                                        "meeting504": $filter('date')( $scope.student.messaged.meeting504, 'MM/dd/yyyy'), 
                                        "iEPMeetingQualifier": $scope.student.messaged.iEPMeetingQualifier, 
                                        "iEPMeeting":  $filter('date')($scope.student.messaged.iEPMeeting, 'MM/dd/yyyy'), 
                                        "iripQualifier": $scope.student.messaged.iripQualifier, 
                                        "irip":  $filter('date')($scope.student.messaged.irip, 'MM/dd/yyyy'), 
                                        "tieredInstQualifier": $scope.student.messaged.tieredInstQualifier, 
                                        "tieredInst":  $filter('date')($scope.student.messaged.tieredInst, 'MM/dd/yyyy'), 
                                        "missStuConnQualifier": $scope.student.messaged.missStuConnQualifier, 
                                        "missStuConn":  $filter('date')($scope.student.messaged.missStuConn, 'MM/dd/yyyy'), 
                                        "orientationQualifier": $scope.student.messaged.orientationQualifier, 
                                        "orientation":  $filter('date')($scope.student.messaged.orientation,'MM/dd/yyyy'),  
                                        "onboardingQualifier": $scope.student.messaged.onboardingQualifier, 
                                        "onboarding":  $filter('date')($scope.student.messaged.onboarding, 'MM/dd/yyyy'), 
                                        "stateTestAssignQualifier": $scope.student.messaged.stateTestAssignQualifier, 
                                        "stateTestAssign": $filter('date')($scope.student.messaged.stateTestAssign, 'MM/dd/yyyy') 
                                        //DEVS - add all new fields for remaining categories above
                                    }

                            $http({
                                    method: "POST",
                                    url: schoolwork12.app.student.endpoints.studentSearch,
                                    data: $scope.searchRequestPayload,
                                    headers: {
                                        'X-API-TOKEN': authentication
                                            .getCurrentUser().keycode,
                                    }
                                })
                                .then(
                                    function(response) {
                                        if (response.data.length > 0) {
                                            $scope.checkStudentIdList(response.data);
                                            $scope.displayGrid = true;
                                            $scope.gridOptions.data = response.data;
                                            // console.log("search response", $scope.gridOptions.data);
                                        } else {
                                            $scope.searchErrorOccurred = true;
                                            $scope.searchErrorMesg = schoolwork12.app.errorMessages.noResultsFound;
                                        }
                                        //prompt studentSaveSearch modal
                                        if($scope.isSaveSearchBusy || $scope.saveOrUpdateModal){
                                            studentSaveSearch.service($scope.searchRequestPayload, $scope.selectedSearchItem, $scope.updateSearchFlag, $scope.isAdmin); 
                                        }
                                    },
                                    function(error) {
                                        $scope.searchErrorMesg = "";
                                        $scope.searchErrorOccurred = true;
                                        if (error.status == 400) {
                                            for (var j = 0; j < error.data._errors.length; j++) {
                                                $scope.searchErrorMesg = $scope.searchErrorMesg + error.data._errors[j] + "\n";

                                                var checkErrorMsg = $scope.searchErrorMesg;
                                                $scope.maxSearchError = (~checkErrorMsg.indexOf("exceed 2000 students")) ? true : false; 
                                                
                                                if(($scope.isSaveSearchBusy && $scope.maxSearchError)){
                                                    studentSaveSearch.service($scope.searchRequestPayload, $scope.selectedSearchItem, $scope.updateSearchFlag, $scope.isAdmin);
                                                }
                                            }
                                        } else if (error.status == 401 || error.status == 403) {
                                            $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                        } else {
                                            $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                                        }
                                    })['finally']
                                (function() {
                                    // Stop spinning cog.
                                    // Indicates search is
                                    // complete.

                                    // Enable search button
                                    $scope.isSearchBusy = false;
                                    $scope.isSearchDisabled = false;

                                    // Enable save button
                                    $scope.isSaveSearchBusy = false;
                                    $scope.isSaveSearchDisabled = false;
                                });

                        }

                    };

                    $scope.isSearchValid = function() {
                        return $scope.isStudentIdValid() &&
                            $scope.isValidEnrollmentDateAndQualifier() &&
                            $scope.isValidSchoolWithdrawalDateAndQualifier() &&
                            $scope.isValidEnrollmentReceivedDateAndQualifier() &&
                            $scope.isValidEnrollmentApprovedDateAndQualifier() &&
                            // start - attendance field validations
                            $scope.isValidAttendance1stDayDateAndQualifier() &&
                            $scope.isValidAttendanceLastDayDateAndQualifier() &&
                            $scope.isValidConsDaysAbsentValAndQualifier() &&
                            $scope.isValidAttendanceTruancyDateAndQualifier() &&
                            $scope.isValidPercentAttendedValAndQualifier() &&
                            $scope.isValidTotalDaysEnrolValAndQualifier() &&
                            $scope.isValidDaysPresentValAndQualifier() &&
                            $scope.isValidDaysAbsentValAndQualifier() &&
                            $scope.isValidTotalHrsValAndQualifier() &&
                            $scope.isValidLastLessonValAndQualifier() &&
                            $scope.isValidMissingHrsValAndQualifier() &&
                            $scope.isValidAttHrsWeekValAndQualifier() &&
                            $scope.isValidAttHrsMissingWeekValAndQualifier() &&
                            $scope.isValidAttLast7DaysValAndQualifier() && 
                            $scope.isValidAttMissingLast7DaysValAndQualifier() &&
                            $scope.isValidAtt4WeekValAndQualifier() &&
                            $scope.isValidAttMissing4WeekValAndQualifier() &&
                            $scope.isValidTotalOnlineTimeValAndQualifier() &&
                            $scope.isValidTotalOfflineTimeValAndQualifier() &&
                            $scope.isValidMissingOverHrsValAndQualifier() &&
                            $scope.isValidAtt4SemValAndQualifier() &&
                            $scope.isValidMissing4SemValAndQualifier() &&
                            $scope.isValidAttendance1stDayAttModifiedDateAndQualifier() &&  
                            $scope.isValidUnexcusedAbsencesValAndQualifier() && 
                            $scope.isValidExcusedHrsValAndQualifier() &&  
                            $scope.isValidUnExcusedHrsValAndQualifier() &&       
                            // end - attendance field validations
                            $scope.isValidRoleForGradPlanCategory() &&
                            $scope.isValidSchoolAccessForGradPlanCategory() &&
	                        $scope.isValidStatusForGradPlanCategory() &&
	                        $scope.isValidDiplomaAssignedName() &&
	                        $scope.isValidCreditsEarnedValAndQualifier() &&
                            $scope.isValidCreditsNeededGradValAndQualifier() &&
	                        $scope.isValidCreditsInProgressValAndQualifier() &&
	                        $scope.isValidCreditsNeededValAndQualifier() &&
	                        $scope.isValidPlanLastModifiedDateAndQualifier() &&
	                        $scope.isValidEngagementSTActivityInLast7DaysValAndQualifier() &&
                            $scope.isValidEngagementLastSTLoginDateAndQualifier() &&
                            $scope.isValidEngagementLastLCLoginDateAndQualifier() &&
                            $scope.isValidEngagementLastContactDateAndQualifier() &&
                            $scope.isValidEnduringConnectnCallDateAndQualifier() &&
                            $scope.isValidFastRunningNoteDateAndQualifier() &&
                            $scope.isValidTeacherCompliancyNoteDateAndQualifier() &&
                            $scope.isValidPulseCheckDateAndQualifier() &&
                            $scope.isValidFollowUpActionDateAndQualifier() &&
                            $scope.isValidReRegLastModDateAndQualifier() &&
                            $scope.isValidReRegApprLastModDateAndQualifier() &&
                            isValidReRegWithdrawnAndAprrovalStatus() &&
                            isValidRegistrationServiceActive() &&
                            isValidPulseCheckRating() &&
                            isValidFirstAccDateAndQualifier() &&
                            isValidLastAccDateAndQualifier() &&
                            isValidGradPlanTimesViewedAndQualifier() &&
                            isValidMessageDateAndQualifiers();
                            // TODO: Move all validations to a separate service file and inject
                    }

                    $scope.isStudentIdValid = function() {
                        /*
                         * TODO: Verify if angular has any check for
                         * default form
                         */
                        /*console
                        		.info("Validating student search fields");
                        var studentSearchPanel = document
                        		.getElementById("studentSearchPanel");
									
                        for ( var i = 0; i < studentSearchPanel.length
                        		&& i < (studentSearchPanel.length - 2); i++) {
                        	if (studentSearchPanel.elements[i].value != "") {
                        		validSearchPanel = true;
                        		break;
                        	}
                        }
                        if (!validSearchPanel) {
                        	$scope.searchErrorOccurred = true;
                        	$scope.searchErrorMesg = schoolwork12.app.student.errorMessages.searchRequired;
                        }*/
                        console.info("Validating student id field");
                        var validSearchPanel = true;
                        // verify student id field for length and
                        // numeric type
                        if ($scope.student.studentId != null &&
                            $scope.student.studentId != "") {
                            var data = $scope.student.studentId
                                .split(",");
                            if (data.length < 500) {
                                // console.info(data);
                                validSearchPanel = true;
                                for (var j = 0; j < data.length; j++) {
                                    // check if any of the input
                                    // data has
                                    // alphabets
                                    var numberMatcher = /^[0-9]+$/;
                                    if (data[j] != "") {
                                        if (!data[j]
                                            .match(numberMatcher)) {
                                            validSearchPanel = false;
                                            $scope.searchErrorOccurred = true;
                                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.studentIdNumeric;
                                            break;
                                        }
                                    }
                                }
                            } else {
                                validSearchPanel = false;
                                $scope.searchErrorOccurred = true;
                                $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.studentIds500;
                            }
                        }
                        console.info("Validating Action Needed Follow Up Item field");
                        if (($scope.student.actionNeeded.followUpItem != null && $scope.student.actionNeeded.followUpItem == 'keyword') &&
                            ($scope.student.actionNeeded.followUpItemKeyword == null || $scope.student.actionNeeded.followUpItemKeyword.length == 0)) {
                            validSearchPanel = false;
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = 'A keyword must be entered to search Follow Up Item by keyword.';

                        }

                        return validSearchPanel;
                    }

                    $scope.isValidRoleForGradPlanCategory = function () {
                        console.info("Validating Role for Graduation Plan Category");  
                        if ($scope.student.isGradPlanChecked && !$scope.hasStudentGradPlanAccess) {  
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidRoleForGradPlan;
                            // TODO: Auto focus student status

                            return false;
                        } 
                        return true;
                    }

                    $scope.isValidSchoolAccessForGradPlanCategory = function () {
                        console.info("Validating School Access for Graduation Plan Category");  
                        if ($scope.student.isGradPlanChecked && !$scope.hasGradPlanSchoolAccess) {  
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidSchoolAccessForGradPlan;
                            // TODO: Auto focus student status

                            return false;
                        } 
                        return true;
                    }

                    $scope.isValidStatusForGradPlanCategory = function () {
                        console.info("Validating Status for Graduation Plan Category");  
                        if ($scope.student.isGradPlanChecked && $scope.student.status == '0') {  
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidStatusForGradPlan;
                            // TODO: Auto focus student status

                            return false;
                        } 
                        return true;
                    }

                    $scope.isValidDiplomaAssignedName = function(){
                        console.info("Validating Diploma Assigned Name");  
                        if (($scope.student.gradPlan.diplomaAssigned != null && $scope.student.gradPlan.diplomaAssigned == 'name') &&
                            ($scope.student.gradPlan.diplomaAssignedName == null || $scope.student.gradPlan.diplomaAssignedName.length == 0)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidDiplomaForGradPlan;
                            // TODO: Auto focus diploma assigned name

                            return false;
                        }
                        return true;
                    }

                    $scope.isValidConsDaysAbsentValAndQualifier = function () {
                        console.info("Validating Consecutive Days Absent");
                        if ($scope.student.attendance.consecutiveDaysAbsent && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.consecutiveDaysAbsent)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidConsecutiveDaysAbsent;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.consecutiveDaysAbsent != null && 
                            $scope.student.attendance.consecutiveDaysAbsent != '' && 
                            !$scope.student.attendance.consecutiveDaysAbsentQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectConsecutiveDaysAbsentQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.consecutiveDaysAbsent == null || 
                            $scope.student.attendance.consecutiveDaysAbsent == '') && 
                            $scope.student.attendance.consecutiveDaysAbsentQualifier != null && 
                            $scope.student.attendance.consecutiveDaysAbsentQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidconsecutiveDaysAbsentQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidTotalHrsValAndQualifier = function () {
                        console.info("Validating Total Hours");
                        if ($scope.student.attendance.totalHrs && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.totalHrs)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidTotalHrs;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.totalHrs != null && 
                            $scope.student.attendance.totalHrs != '' && 
                            !$scope.student.attendance.totalHrsQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectTotalHrsQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.totalHrs == null || 
                            $scope.student.attendance.totalHrs == '') && 
                            $scope.student.attendance.totalHrsQualifier != null && 
                            $scope.student.attendance.totalHrsQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidTotalHrsQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidExcusedHrsValAndQualifier = function () {
                        console.info("Validating Excused Hours");
                        if ($scope.student.attendance.excusedHrs && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.excusedHrs)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidExcusedHrs;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.excusedHrs != null && 
                            $scope.student.attendance.excusedHrs != '' && 
                            !$scope.student.attendance.excusedHrsQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectExcusedHrsQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.excusedHrs == null || 
                            $scope.student.attendance.excusedHrs == '') && 
                            $scope.student.attendance.excusedHrsQualifier != null && 
                            $scope.student.attendance.excusedHrsQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidExcusedHrsQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidUnExcusedHrsValAndQualifier = function () {
                        console.info("Validating Unexcused Hours");
                        if ($scope.student.attendance.unexcusedHrs && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.unexcusedHrs)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidUnExcusedHrs;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.unexcusedHrs != null && 
                            $scope.student.attendance.unexcusedHrs != '' && 
                            !$scope.student.attendance.unexcusedHrsQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectUnExcusedHrsQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.unexcusedHrs == null || 
                            $scope.student.attendance.unexcusedHrs == '') && 
                            $scope.student.attendance.unexcusedHrsQualifier != null && 
                            $scope.student.attendance.unexcusedHrsQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidUnExcusedHrsQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidLastLessonValAndQualifier = function () {
                        console.info("Validating Last Attempted Lesson Date");
                        if ($scope.studentSearchForm.lastLesson && !$scope.studentSearchForm.lastLesson.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidLastLesson;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.lastLesson != null && 
                            !$scope.student.attendance.lastLessonQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectLastLesson;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.lastLesson == null  && 
                            $scope.student.attendance.lastLessonQualifier != null && 
                            $scope.student.attendance.lastLessonQualifier != '' &&
                            $scope.student.attendance.lastLessonQualifier != 'no last attempted lesson') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidLastLessonQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidTotalOnlineTimeValAndQualifier = function () {
                        console.info("Validating Total Online Time");
                        if ($scope.student.attendance.totalOnlineTime && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.totalOnlineTime)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidTotalOnlineTime;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.totalOnlineTime != null && 
                            $scope.student.attendance.totalOnlineTime != '' && 
                            !$scope.student.attendance.totalOnlineTimeQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectTotalOnlineTimeQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.totalOnlineTime == null || 
                            $scope.student.attendance.totalOnlineTime == '') && 
                            $scope.student.attendance.totalOnlineTimeQualifier != null && 
                            $scope.student.attendance.totalOnlineTimeQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidTotalOnlineTimeQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidTotalOfflineTimeValAndQualifier = function () {
                        console.info("Validating Total Offline Time");
                        if ($scope.student.attendance.totalOfflinetime && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.totalOfflinetime)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidTotalOfflineTime;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.totalOfflinetime != null && 
                            $scope.student.attendance.totalOfflinetime != '' && 
                            !$scope.student.attendance.totalOfflinetimeQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectTotalOfflineTimeQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.totalOfflinetime == null || 
                            $scope.student.attendance.totalOfflinetime == '') && 
                            $scope.student.attendance.totalOfflinetimeQualifier != null && 
                            $scope.student.attendance.totalOfflinetimeQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidTotalOfflineTimeQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidMissingHrsValAndQualifier = function () {
                        console.info("Validating Missing Hours");
                        if ($scope.student.attendance.missingHrs && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.missingHrs)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidMissingHrs;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.missingHrs != null && 
                            $scope.student.attendance.missingHrs != '' && 
                            !$scope.student.attendance.missingHrsQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectMissingHrsQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.missingHrs == null || 
                            $scope.student.attendance.missingHrs == '') && 
                            $scope.student.attendance.missingHrsQualifier != null && 
                            $scope.student.attendance.missingHrsQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidMissingHrsQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidMissingOverHrsValAndQualifier = function () {
                        console.info("Validating Missing/Over Hours");
                        if ($scope.student.attendance.missingOverHrs && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.missingOverHrs)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidMissingOverHrs;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.missingOverHrs != null && 
                            $scope.student.attendance.missingOverHrs != '' && 
                            !$scope.student.attendance.missingOverHrsQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectMissingOverHrsQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.missingOverHrs == null || 
                            $scope.student.attendance.missingOverHrs == '') && 
                            $scope.student.attendance.missingOverHrsQualifier != null && 
                            $scope.student.attendance.missingOverHrsQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidMissingOverHrsQualifier;
                            return false;
                         } 
                        return true;
                    }


                    $scope.isValidAttHrsWeekValAndQualifier = function () {
                        console.info("Validating Att Hrs for Week");
                        if ($scope.student.attendance.attHrs4Week && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.attHrs4Week)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidAttHrs4Week;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.attHrs4Week != null && 
                            $scope.student.attendance.attHrs4Week != '' && 
                            !$scope.student.attendance.attHrs4WeekQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectAttHrs4WeekQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.attHrs4Week == null || 
                            $scope.student.attendance.attHrs4Week == '') && 
                            $scope.student.attendance.attHrs4WeekQualifier != null && 
                            $scope.student.attendance.attHrs4WeekQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidAttHrs4WeekQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidAttHrsMissingWeekValAndQualifier = function () {
                        console.info("Validating Att Hrs Missing for Week");
                        if ($scope.student.attendance.attHrsMissing4Week && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.attHrsMissing4Week)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidAttHrsMissing4Week;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.attHrsMissing4Week != null && 
                            $scope.student.attendance.attHrsMissing4Week != '' && 
                            !$scope.student.attendance.attHrsMissing4WeekQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectAttHrsMissing4WeekQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.attHrsMissing4Week == null || 
                            $scope.student.attendance.attHrsMissing4Week == '') && 
                            $scope.student.attendance.attHrsMissing4WeekQualifier != null && 
                            $scope.student.attendance.attHrsMissing4WeekQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidAttHrsMissing4WeekQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidAttLast7DaysValAndQualifier = function () {
                        console.info("Validating Att Last 7 Days ");
                        if ($scope.student.attendance.attLast7Days && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.attLast7Days)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidAttLast7Days;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.attLast7Days != null && 
                            $scope.student.attendance.attLast7Days != '' && 
                            !$scope.student.attendance.attLast7DaysQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectAttLast7DaysQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.attLast7Days == null || 
                            $scope.student.attendance.attLast7Days == '') && 
                            $scope.student.attendance.attLast7DaysQualifier != null && 
                            $scope.student.attendance.attLast7DaysQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidAttLast7DaysQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidAttMissingLast7DaysValAndQualifier = function () {
                        console.info("Validating Att Missing Last 7 Days ");
                        if ($scope.student.attendance.attMissingLast7Days && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.attMissingLast7Days)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidAttMissingLast7Days;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.attMissingLast7Days != null && 
                            $scope.student.attendance.attMissingLast7Days != '' && 
                            !$scope.student.attendance.attMissingLast7DaysQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectAttMissingLast7DaysQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.attMissingLast7Days == null || 
                            $scope.student.attendance.attMissingLast7Days == '') && 
                            $scope.student.attendance.attMissingLast7DaysQualifier != null && 
                            $scope.student.attendance.attMissingLast7DaysQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidAttMissingLast7DaysQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidAtt4WeekValAndQualifier = function () {
                        console.info("Validating Att for Week");
                        if ($scope.student.attendance.att4Week && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.att4Week)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidAtt4Week;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.att4Week != null && 
                            $scope.student.attendance.att4Week != '' && 
                            !$scope.student.attendance.att4WeekQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectAtt4WeekQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.att4Week == null || 
                            $scope.student.attendance.att4Week == '') && 
                            $scope.student.attendance.att4WeekQualifier != null && 
                            $scope.student.attendance.att4WeekQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidAtt4WeekQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidAtt4SemValAndQualifier = function () {
                        console.info("Validating Att for Sem");
                        if ($scope.student.attendance.att4Sem && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.att4Sem)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidAtt4Sem;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.att4Sem != null && 
                            $scope.student.attendance.att4Sem != '' && 
                            !$scope.student.attendance.att4SemQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectAtt4SemQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.att4Sem == null || 
                            $scope.student.attendance.att4Sem == '') && 
                            $scope.student.attendance.att4SemQualifier != null && 
                            $scope.student.attendance.att4SemQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidAtt4SemQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidMissing4SemValAndQualifier = function () {
                        console.info("Validating Missing for Sem");
                        if ($scope.student.attendance.missing4Sem && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.missing4Sem)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidMissing4Sem;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.missing4Sem != null && 
                            $scope.student.attendance.missing4Sem != '' && 
                            !$scope.student.attendance.missing4SemQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectMissing4SemQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.missing4Sem == null || 
                            $scope.student.attendance.missing4Sem == '') && 
                            $scope.student.attendance.missing4SemQualifier != null && 
                            $scope.student.attendance.missing4SemQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidMissing4SemQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidPercentAttendedValAndQualifier = function () {
                        console.info("Validating Percent Attended");
                        if ($scope.student.attendance.percentAttended && !/^(\d{0,3}(\.\d{0,9})?)$/.test($scope.student.attendance.percentAttended)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidPercentAttended;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.percentAttended != null && 
                            $scope.student.attendance.percentAttended != '' && 
                            !$scope.student.attendance.percentAttendedQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectPercentAttendedQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.percentAttended == null || 
                            $scope.student.attendance.percentAttended == '') && 
                            $scope.student.attendance.percentAttendedQualifier != null && 
                            $scope.student.attendance.percentAttendedQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidPercentAttendedQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidAttMissing4WeekValAndQualifier = function () {
                        console.info("Validating Att Missing for Week");
                        if ($scope.student.attendance.attMissing4Week && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.attMissing4Week)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidAttMissing4Week;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.attMissing4Week != null && 
                            $scope.student.attendance.attMissing4Week != '' && 
                            !$scope.student.attendance.attMissing4WeekQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectAttMissing4WeekQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.attMissing4Week == null || 
                            $scope.student.attendance.attMissing4Week == '') && 
                            $scope.student.attendance.attMissing4WeekQualifier != null && 
                            $scope.student.attendance.attMissing4WeekQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidAttMissing4WeekQualifier;
                            return false;
                         } 
                        return true;
                    }


                    $scope.isValidTotalDaysEnrolValAndQualifier = function () {
                        console.info("Validating Total Days Enrolled");
                        if ($scope.student.attendance.totalDaysEnrolled && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.totalDaysEnrolled)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidTotalDaysEnrolled;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.totalDaysEnrolled != null && 
                            $scope.student.attendance.totalDaysEnrolled != '' && 
                            !$scope.student.attendance.totalDaysEnrolledQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectTotalDaysEnrolledQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.totalDaysEnrolled == null || 
                            $scope.student.attendance.totalDaysEnrolled == '') && 
                            $scope.student.attendance.totalDaysEnrolledQualifier != null && 
                            $scope.student.attendance.totalDaysEnrolledQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidTotalDaysEnrolledQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidDaysPresentValAndQualifier = function () {
                        console.info("Validating Days Present");
                        if ($scope.student.attendance.daysPresent && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.daysPresent)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidDaysPresent;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.daysPresent != null && 
                            $scope.student.attendance.daysPresent != '' && 
                            !$scope.student.attendance.daysPresentQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectDaysPresentQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.daysPresent == null || 
                            $scope.student.attendance.daysPresent == '') && 
                            $scope.student.attendance.daysPresentQualifier != null && 
                            $scope.student.attendance.daysPresentQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidDaysPresentQualifier;
                            return false;
                         } 
                        return true;
                    }

                     $scope.isValidDaysAbsentValAndQualifier = function () {
                        console.info("Validating Days Absent");
                        if ($scope.student.attendance.daysAbsent && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.daysAbsent)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidDaysAbsent;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.daysAbsent != null && 
                            $scope.student.attendance.daysAbsent != '' && 
                            !$scope.student.attendance.daysAbsentQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectDaysAbsentQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.daysAbsent == null || 
                            $scope.student.attendance.daysAbsent == '') && 
                            $scope.student.attendance.daysAbsentQualifier != null && 
                            $scope.student.attendance.daysAbsentQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidDaysAbsentQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidUnexcusedAbsencesValAndQualifier = function () {
                        console.info("Validating Unexcused Absences");
                        if ($scope.student.attendance.unexcusedAbsences && !/^(\d{0,4}(\.\d{0,9})?)$/.test($scope.student.attendance.unexcusedAbsences)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidUnexcusedAbsences;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.unexcusedAbsences != null && 
                            $scope.student.attendance.unexcusedAbsences != '' && 
                            !$scope.student.attendance.unexcusedAbsencesQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectUnexcusedAbsencesQualifier;
                            return false;
                        } 
                        else if ($scope.student.attendance && ($scope.student.attendance.unexcusedAbsences == null || 
                            $scope.student.attendance.unexcusedAbsences == '') && 
                            $scope.student.attendance.unexcusedAbsencesQualifier != null && 
                            $scope.student.attendance.unexcusedAbsencesQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidUnexcusedAbsencesQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidCreditsEarnedValAndQualifier = function () {   
                        console.info("Validating Credits Earned");
                        var isNumericValue = /^(\d{0,3}(\.\d{0,9})?)$/.test($scope.student.gradPlan.stCreditsEarned);
                        if ( $scope.student.gradPlan.stCreditsEarned && 
                             (!isNumericValue 
                              || (isNumericValue && parseFloat($scope.student.gradPlan.stCreditsEarned) == 0)
                                  && $scope.student.gradPlan.creditsEarnedQualifier
                                  && $scope.student.gradPlan.creditsEarnedQualifier == 'prior') ) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidCreditsEarned;
                            // TODO: Auto focus credits earned
                            return false;
                        } 
                        else if ($scope.student.gradPlan && $scope.student.gradPlan.stCreditsEarned != null && 
                            $scope.student.gradPlan.stCreditsEarned != '' && 
                            !$scope.student.gradPlan.creditsEarnedQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectCreditsEarnedQualifier;
                            // TODO: Auto focus credits earned qualifier
                            return false;
                        } 
                        else if ($scope.student.gradPlan && ($scope.student.gradPlan.stCreditsEarned == null || 
                            $scope.student.gradPlan.stCreditsEarned == '') && 
                            $scope.student.gradPlan.creditsEarnedQualifier != null && 
                            $scope.student.gradPlan.creditsEarnedQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidCreditsEarnedQualifier;
                            // TODO: Auto focus credits earned qualifier
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidCreditsNeededGradValAndQualifier = function () {   
                        console.info("Validating Credits Needed To Graduate");
                        var isNumericValue = /^(\d{0,3}(\.\d{0,9})?)$/.test($scope.student.gradPlan.stCreditsNeededGrad);
                        if ( $scope.student.gradPlan.stCreditsNeededGrad && 
                             (!isNumericValue 
                              || (isNumericValue && parseFloat($scope.student.gradPlan.stCreditsNeededGrad) == 0)
                                  && $scope.student.gradPlan.creditsNeededGradQualifier
                                  && $scope.student.gradPlan.creditsNeededGradQualifier == 'prior') ) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidCreditsNeededGrad;
                            return false;
                        } 
                        else if ($scope.student.gradPlan && $scope.student.gradPlan.stCreditsNeededGrad != null && 
                            $scope.student.gradPlan.stCreditsNeededGrad != '' && 
                            !$scope.student.gradPlan.creditsNeededGradQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectCreditsNeededGradQualifier;
                            return false;
                        } 
                        else if ($scope.student.gradPlan && ($scope.student.gradPlan.stCreditsNeededGrad == null || 
                            $scope.student.gradPlan.stCreditsNeededGrad == '') && 
                            $scope.student.gradPlan.creditsNeededGradQualifier != null && 
                            $scope.student.gradPlan.creditsNeededGradQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidCreditsNeededGradQualifier;
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidCreditsInProgressValAndQualifier = function () {
                        console.info("Validating Credits In Progress");
                        var isNumericValue = /^(\d{0,3}(\.\d{0,9})?)$/.test($scope.student.gradPlan.stCreditsInProgress);
                        if ( $scope.student.gradPlan.stCreditsInProgress && 
                             (!isNumericValue 
                              || (isNumericValue && parseFloat($scope.student.gradPlan.stCreditsInProgress) == 0)
                                  && $scope.student.gradPlan.creditsInProgressQualifier
                                  && $scope.student.gradPlan.creditsInProgressQualifier == 'prior') ) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidCreditsInProgress;
                            // TODO: Auto focus credits in progress
                            return false;
                        }
                        else if ($scope.student.gradPlan && $scope.student.gradPlan.stCreditsInProgress != null && 
                            $scope.student.gradPlan.stCreditsInProgress != '' && 
                            !$scope.student.gradPlan.creditsInProgressQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectCreditsInProgressQualifier;
                            // TODO: Auto focus credits in progress qualifier
                            return false;
                        }
                        else if ($scope.student.gradPlan && ($scope.student.gradPlan.stCreditsInProgress == null ||  
                            $scope.student.gradPlan.stCreditsInProgress == '') && 
                            $scope.student.gradPlan.creditsInProgressQualifier != null && 
                            $scope.student.gradPlan.creditsInProgressQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidCreditsInProgressQualifier;
                            // TODO: Auto focus credits in progress qualifier
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidCreditsNeededValAndQualifier = function () {
                        console.info("Validating Credits Needed");
                        var isNumericValue = /^(\d{0,3}(\.\d{0,9})?)$/.test($scope.student.gradPlan.stCreditsNeeded);
                        if ( $scope.student.gradPlan.stCreditsNeeded && 
                             (!isNumericValue 
                              || (isNumericValue && parseFloat($scope.student.gradPlan.stCreditsNeeded) == 0)
                                  && $scope.student.gradPlan.creditsNeededQualifier
                                  && $scope.student.gradPlan.creditsNeededQualifier == 'prior') ) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidCreditsNeeded;
                            // TODO: Auto focus credits needed
                            return false;
                        }
                        else if ($scope.student.gradPlan && $scope.student.gradPlan.stCreditsNeeded != null && 
                            $scope.student.gradPlan.stCreditsNeeded != '' && 
                            !$scope.student.gradPlan.creditsNeededQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectCreditsNeededQualifier;
                            // TODO: Auto focus credits needed qualifier
                            return false;
                        }
                        else if ($scope.student.gradPlan && ($scope.student.gradPlan.stCreditsNeeded == null || 
                            $scope.student.gradPlan.stCreditsNeeded == '') && 
                            $scope.student.gradPlan.creditsNeededQualifier != null && 
                            $scope.student.gradPlan.creditsNeededQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidCreditsNeededQualifier;
                            // TODO: Auto focus credits needed qualifier
                            return false;
                         } 
                        return true;
                    }

                    $scope.isValidPlanLastModifiedDateAndQualifier = function () {
                        console.info("Validating Plan Last Modified Date");
                        if ($scope.studentSearchForm.planLastModifiedDate && !$scope.studentSearchForm.planLastModifiedDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidPlanLastModifiedDate;
                            // TODO: Auto focus plan last modified date
                            return false;
                        } 
                        else if ($scope.student.gradPlan && $scope.student.gradPlan.planLastModifiedDate != null && 
                            !$scope.student.gradPlan.planLastModifiedDateQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectPlanLastModifiedDate;
                            // TODO: Auto focus plan last modified date qualifier
                            return false;
                        }
                        else if ($scope.student.gradPlan && $scope.student.gradPlan.planLastModifiedDate == null && 
                            $scope.student.gradPlan.planLastModifiedDateQualifier != null &&
                            $scope.student.gradPlan.planLastModifiedDateQualifier != '' &&
                            $scope.student.gradPlan.planLastModifiedDateQualifier != 'never modified') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidPlanLastModifiedDateQualifier;
                            // TODO: Auto focus plan last modified date qualifier
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidAttendance1stDayDateAndQualifier = function () {
                        console.info("Validating Attendance 1st Day Date");
                        if ($scope.studentSearchForm.attendance1stDay && !$scope.studentSearchForm.attendance1stDay.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalid1stDayDate;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.attendance1stDay != null && 
                            !$scope.student.attendance.attendance1stDayQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.select1stDayDate;
                            return false;
                        }
                        else if ($scope.student.attendance && $scope.student.attendance.attendance1stDay == null && 
                            $scope.student.attendance.attendance1stDayQualifier != null &&
                            $scope.student.attendance.attendance1stDayQualifier != '' &&
                            $scope.student.attendance.attendance1stDayQualifier != 'no 1st day') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalid1stDayDateQualifier;
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidAttendanceLastDayDateAndQualifier = function () {
                        console.info("Validating Attendance Last Day Date");
                        if ($scope.studentSearchForm.attendanceLastDay && !$scope.studentSearchForm.attendanceLastDay.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidLastDayDate;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.attendanceLastDay != null && 
                            !$scope.student.attendance.attendanceLastDayQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectLastDayDate;
                            return false;
                        }
                        else if ($scope.student.attendance && $scope.student.attendance.attendanceLastDay == null && 
                            $scope.student.attendance.attendanceLastDayQualifier != null &&
                            $scope.student.attendance.attendanceLastDayQualifier != '' && 
                            $scope.student.attendance.attendanceLastDayQualifier != 'no last day of att') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidLastDayDateQualifier;
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidAttendanceTruancyDateAndQualifier = function () {
                        console.info("Validating Attendance Truancy Withdraw Date");
                        if ($scope.studentSearchForm.truancyDate && !$scope.studentSearchForm.truancyDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidTruancyDate;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.truancyDate != null && 
                            !$scope.student.attendance.truancyDateQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectTruancyDate;
                            return false;
                        }
                        else if ($scope.student.attendance && $scope.student.attendance.truancyDate == null && 
                            $scope.student.attendance.truancyDateQualifier != null &&
                            $scope.student.attendance.truancyDateQualifier != '' &&
                            $scope.student.attendance.truancyDateQualifier != 'no truancy date') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidTruancyDateQualifier;
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidAttendance1stDayAttModifiedDateAndQualifier = function () {
                        console.info("Validating 1st Day of Attendance Modified Date");
                        if ($scope.studentSearchForm.firstDayAttModified && !$scope.studentSearchForm.firstDayAttModified.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalid1stDayModDate;
                            return false;
                        } 
                        else if ($scope.student.attendance && $scope.student.attendance.firstDayAttModified != null && 
                            !$scope.student.attendance.firstDayAttModifiedQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.select1stDayModDate;
                            return false;
                        }
                        else if ($scope.student.attendance && $scope.student.attendance.firstDayAttModified == null && 
                            $scope.student.attendance.firstDayAttModifiedQualifier != null &&
                            $scope.student.attendance.firstDayAttModifiedQualifier != '' &&
                            $scope.student.attendance.firstDayAttModifiedQualifier != 'no 1st day of att modified') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalid1stDayModDateQualifier;
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidEnrollmentDateAndQualifier = function() {
                        console
                            .info("Validating Enrollment Date and Qualifier");
                        if (!$scope.studentSearchForm.enrollmentDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidEnrollmentDt;
                            return false;
                        } else if ($scope.student.demoData && $scope.student.demoData.enrollmentDate != null 
                        		&& !$scope.student.demoData.enrollmentDateQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectEnrollmentDt;
                            return false;
                        }else if ($scope.student.demoData && $scope.student.demoData.enrollmentDate == null && 
                            $scope.student.demoData.enrollmentDateQualifier != null &&
                            $scope.student.demoData.enrollmentDateQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidEnrollmentDtQualifier;
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidSchoolWithdrawalDateAndQualifier = function() {
                        console
                            .info("Validating School Withdrawal Date and Qualifier");
                        if (!$scope.studentSearchForm.schoolWithdrawalDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidWithdrawalDt;
                            return false;
                        } else if ($scope.student.demoData && $scope.student.demoData.schoolWithdrawalDate != null &&
                            !$scope.student.demoData.schoolWithdrawalDateQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectdWithdrawalDt;
                            return false;
                        }else if ($scope.student.demoData && $scope.student.demoData.schoolWithdrawalDate == null && 
                            $scope.student.demoData.schoolWithdrawalDateQualifier != null &&
                            $scope.student.demoData.schoolWithdrawalDateQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidWithdrawalDtQualifier;
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidEnrollmentReceivedDateAndQualifier = function() {
                        console
                            .info("Validating Enrollment Received Date and Qualifier");
                        if (!$scope.studentSearchForm.enrollmentReceivedDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidEnrollmentReceivedDt;
                            return false;
                        } else if ($scope.student.demoData.enrollmentReceivedDate != null &&
                            !$scope.student.demoData.enrollmentReceivedDateQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectEnrollmentReceivedDt;
                            return false;
                        }else if ($scope.student.demoData && $scope.student.demoData.enrollmentReceivedDate == null && 
                            $scope.student.demoData.enrollmentReceivedDateQualifier != null &&
                            $scope.student.demoData.enrollmentReceivedDateQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidEnrollmentReceivedDtQualifier;
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidEnrollmentApprovedDateAndQualifier = function() {
                        console
                            .info("Validating Enrollment Approved Date and Qualifier");
                        if (!$scope.studentSearchForm.enrollmentApprovedDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidEnrollmentApprovedDt;
                            // TODO: Auto focus enrollment date

                            return false;
                        } else if ($scope.student.demoData.enrollmentApprovedDate != null &&
                            !$scope.student.demoData.enrollmentApprovedDateQualifier) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectEnrollmentApprovedDt;
                            // TODO: Auto focus enrollment date
                            // qualifier
                            return false;
                        }else if ($scope.student.demoData && $scope.student.demoData.enrollmentApprovedDate == null && 
                            $scope.student.demoData.enrollmentApprovedDateQualifier != null &&
                            $scope.student.demoData.enrollmentApprovedDateQualifier != '') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidEnrollmentApprovedDtQualifier;
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidFollowUpActionDateAndQualifier = function() {
                        console.info("Validating Follow Up Action Date and Qualifier");
                        if (!$scope.studentSearchForm.followUpActionDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidFollowUpActionDate;
                            // TODO: Auto focus Follow Up Action date

                            return false;
                        } else if ($scope.student.actionNeeded.followUpActionDate != null &&
                            $scope.student.actionNeeded.followUpActionQualifier == null) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectFollowUpActionDate;
                            // TODO: Auto focus Follow Up Qualifier
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidPulseCheckDateAndQualifier = function() {
                        console
                            .info("Validating Pulse Check Date and Qualifier");
                        if (!$scope.studentSearchForm.mostRecentPulseCheckDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidPulseCheckDt;
                            // TODO: Auto focus enrollment date

                            return false;
                        } else if ($scope.student.pulseCheck && $scope.student.pulseCheck.mostRecentPulseCheckDate != null &&
                            $scope.student.pulseCheck.qualifier == null) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectPulseCheckDtQualifier;
                            // TODO: Auto focus pulse check date
                            // qualifier
                            return false;
                        }
                        return true;
                    }
                    $scope.isValidEnduringConnectnCallDateAndQualifier = function() {
                        console.info("Validating Enduring Connectoin Call and Qualifier");
                        if (!$scope.studentSearchForm.enduringConnectnCall.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidEnduringConnectnCall;
                            return false;
                        } else if ($scope.student.fast.enduringConnectnCall != null && $scope.student.fast.enduringConnectnCall !='' && 
                            $scope.student.fast.enduringConnectnCallQualifier == null ) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectEnduringConnectnCall;
                            return false;
                        }
                        return true;
                    }
                    
                    
                    $scope.isValidFastRunningNoteDateAndQualifier = function() {
                        console.info("Validating Fast Running Note Date and Qualifier");
                        if (!$scope.studentSearchForm.fastRunningNoteDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidFastRunningNoteDate;
                            // TODO: Auto focus Follow Up Action date

                            return false;
                        } else if ($scope.student.fast.fastRunningNoteDate != null && $scope.student.fast.fastRunningNoteDate != '' &&
                            $scope.student.fast.fastRunningNoteQualifier == null) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectFastRunningNoteDate;
                            // TODO: Auto focus Follow Up Qualifier
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidTeacherCompliancyNoteDateAndQualifier = function() {
                        console.info("Validating Teacher Compliancy Note Date and Qualifier");
                        if (!$scope.studentSearchForm.teacherCompliancyNoteDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidTeacherCompliancyNoteDate;
                            // TODO: Auto focus Follow Up Action date

                            return false;
                        } else if ($scope.student.fast.teacherCompliancyNoteDate != null && $scope.student.fast.teacherCompliancyNoteDate != '' &&
                            $scope.student.fast.teacherCompliancyNoteQualifier == null) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectTeacherCompliancyNoteDate;
                            // TODO: Auto focus Follow Up Qualifier
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidEngagementSTActivityInLast7DaysValAndQualifier = function() {
                        console.info("Validating Engagement ST Activity in the Last 7 days and Qualifier");
                        if ($scope.student.engagement.stActivityInLast7Days && !/^((\d{1,10}(\.\d{0,2})?)|(\.\d{1,2}))$/.test($scope.student.engagement.stActivityInLast7Days)) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidSTActivityInLast7Days;
                            return false;
                        } else if ($scope.student.engagement && $scope.student.engagement.stActivityInLast7Days != null &&
                            $scope.student.engagement.activityInLast7DaysQualifier == null) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectActivityInLast7DaysQualifier;
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidEngagementLastSTLoginDateAndQualifier = function() {
                        console.info("Validating Engagement Last ST Login Date and Qualifier");
                        if (!$scope.studentSearchForm.lastStudentLoginDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidLastSTLoginDate;
                            return false;
                        } else if ($scope.student.engagement && $scope.student.engagement.lastStudentLoginDate != null &&
                            $scope.student.engagement.lastStudentLoginQualifier == null) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectLastSTLoginQualifier;
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidEngagementLastLCLoginDateAndQualifier = function() {
                        console.info("Validating Engagement Last LC Login Date and Qualifier");
                        if (!$scope.studentSearchForm.lastLCLoginDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidLastLCLoginDate;
                            return false;
                        } else if ($scope.student.engagement && $scope.student.engagement.lastLCLoginDate != null &&
                            $scope.student.engagement.lastLCLoginQualifier == null) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectLastLCLoginQualifier;
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidEngagementLastContactDateAndQualifier = function() {
                        console.info("Validating Engagement Last Contact Date and Qualifier");
                        if (!$scope.studentSearchForm.lastContactDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.invalidLastContactDate;
                            return false;
                        } else if ($scope.student.engagement && $scope.student.engagement.lastContactDate != null &&
                            $scope.student.engagement.lastContactQualifier == null) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectLastContactQualifier;
                            return false;
                        }
                        return true;
                    }

                    $scope.isValidReRegLastModDateAndQualifier = function() {
                        console
                            .info("Validating Re-Registration Last Modified Date and Qualifier");
                        if ($scope.studentSearchForm.reRegLastModDate && !$scope.studentSearchForm.reRegLastModDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.reRegLastModDate;
                            // TODO: Auto focus enrollment date

                            return false;
                        } else if ($scope.student.reReData && $scope.student.reReData.reRegLastModDate != null &&
                            $scope.student.reReData.reRegLastModDateQualifier == null) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectReRegLastModDateQualifier;
                            return false;
                        }
                        return true;
                    }

                     $scope.isValidReRegApprLastModDateAndQualifier = function() {
                        console
                            .info("Validating Re-Registration Approval Last Modified Date and Qualifier");
                        if ($scope.studentSearchForm.reRegApprLastModDate && !$scope.studentSearchForm.reRegApprLastModDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.reRegApprLastModDate;
                            // TODO: Auto focus enrollment date

                            return false;
                        } else if ($scope.student.reReData && $scope.student.reReData.reRegApprLastModDate != null &&
                            $scope.student.reReData.reRegApprLastModDateQualifier == null) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectReRegApprLastModDateQualifier;
                            return false;
                        }
                        return true;
                    }

                    var isValidReRegWithdrawnAndAprrovalStatus = function(){
                        console
                            .info("Validating  Student Status and Re-Registration Approval Status");
                            if( $scope.student.status == 0 && ($scope.student.reReData.reRegAprovalStatus == 1 || $scope.student.reReData.reRegAprovalStatus == 0)){
                                $scope.searchErrorOccurred = true;
                                $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.reRegWithdrawnAndAprrovalStatus;
                                return false;
                            }
                            else return true;

                    }

                    var isValidRegistrationServiceActive = function(){
                        console
                            .info("Validating School's Registration Services status");

                           if( $scope.student.reReData.reRegAprovalStatus && ($scope.student.reReData.reRegAprovalStatus == 1 || $scope.student.reReData.reRegAprovalStatus == 0)){
                                 if($scope.student.school && $scope.student.school != null ){
                                    for(var i =0;i < $scope.schoollist.length;i++){
                                        for (var j=0;j <$scope.student.school.length ;j++){
                                                if($scope.schoollist[i].isRegistrationOn == false && $scope.schoollist[i].schoolId == $scope.student.school[j] ) {
                                                    $scope.searchErrorOccurred = true;
                                                    $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.reRegRegistrationServiceOn;       
                                                     return false;
                                                }                                           
                                        }


                                    }
                               }else if($scope.schoollist && $scope.schoollist !=null && $scope.schoollist.length > 0 ){
                                    for(var i =0;i < $scope.schoollist.length;i++){
                                        if($scope.schoollist[i].isRegistrationOn == false) {
                                            $scope.searchErrorOccurred = true;
                                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.reRegRegistrationServiceOn;       
                                             return false;
                                        }
                                    }
                               }                          
                           }

                           return true;

                    }

                    var isValidPulseCheckRating = function(){
                        console
                            .info("Validating Pulse Check Ratings");
                            if( $scope.student.pulseCheck.plsCheckReReLike != undefined && ($scope.student.pulseCheck.plsCheckReReLike < 0 || $scope.student.pulseCheck.plsCheckReReLike > 999)){
                                $scope.searchErrorOccurred = true;
                                $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.plsCheckReReLike;
                                return false;
                            }
                            if ( $scope.student.pulseCheck.plsCheckSatis != undefined && ($scope.student.pulseCheck.plsCheckSatis < 0 || $scope.student.pulseCheck.plsCheckSatis > 999)){
                                $scope.searchErrorOccurred = true;
                                $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.plsCheckSatis;
                                return false;
                            }
                            if ( $scope.student.pulseCheck.plsCheckPrep != undefined && ($scope.student.pulseCheck.plsCheckPrep < 0 || $scope.student.pulseCheck.plsCheckPrep > 999)){
                                $scope.searchErrorOccurred = true;
                                $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.plsCheckPrep;
                                return false;
                            }

                            if ( $scope.student.pulseCheck.plsCheckStuSucRat != undefined && ($scope.student.pulseCheck.plsCheckStuSucRat < 0 || $scope.student.pulseCheck.plsCheckStuSucRat > 999)){
                                $scope.searchErrorOccurred = true;
                                $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.plsCheckStuSucRat;
                                return false;
                            }
                            return true;

                    }

                     var isValidFirstAccDateAndQualifier = function() {
                        console
                            .info("Validating Graduation Plan First Acc Date Date and Qualifier");
                        if ($scope.studentSearchForm.firstAccDate && !$scope.studentSearchForm.firstAccDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.firstAccDate;
                            // TODO: Auto focus enrollment date
                            return false;
                        } else if($scope.student.gradPlan && $scope.student.gradPlan.firstAccDate != null &&  !$scope.student.gradPlan.firstAccDateQualifier){
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectPlanFirstAccDate;
                            // TODO: Auto focus plan last modified date qualifier
                            return false;
                        }  else if ($scope.student.gradPlan && $scope.student.gradPlan.firstAccDate == null &&
                            $scope.student.gradPlan.firstAccDateQualifier != null && $scope.student.gradPlan.firstAccDateQualifier != ''
                            && $scope.student.gradPlan.firstAccDateQualifier != 'no first accessed date') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.firstAccDateQualifier;
                            return false;
                        }
                        return true;
                    }

                     var isValidLastAccDateAndQualifier = function() {
                        console
                            .info("Validating Graduation Plan Last Acc Date Date and Qualifier");
                        if ($scope.studentSearchForm.lastAccDate && !$scope.studentSearchForm.lastAccDate.$valid) {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.lastAccDate;
                            // TODO: Auto focus enrollment date
                            return false;
                        } else if($scope.student.gradPlan && $scope.student.gradPlan.lastAccDate != null &&  !$scope.student.gradPlan.lastAccDateQualifier){
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.selectPlanLastAccDate;
                            // TODO: Auto focus plan last modified date qualifier
                            return false;
                        }  else if ($scope.student.gradPlan && $scope.student.gradPlan.lastAccDate == null &&
                            $scope.student.gradPlan.lastAccDateQualifier != null && $scope.student.gradPlan.lastAccDateQualifier != ''
                            && $scope.student.gradPlan.lastAccDateQualifier != 'no last accessed date') {
                            $scope.searchErrorOccurred = true;
                            $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.lastAccDateQualifier;
                            return false;
                        }
                        return true;
                    }

                    var isValidGradPlanTimesViewedAndQualifier = function(){
                        console
                            .info("Validating Grad Plan Times Viewed");
                            if( $scope.student.gradPlan.timesViewed != undefined && ($scope.student.gradPlan.timesViewed < 0 || $scope.student.gradPlan.timesViewed> 999)){
                                $scope.searchErrorOccurred = true;
                                $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.timesViewed;
                                return false;
                            }
                            if($scope.student.gradPlan && $scope.student.gradPlan.timesViewed != null &&  !$scope.student.gradPlan.timesViewedQualifier){
                                $scope.searchErrorOccurred = true;
                                $scope.searchErrorMesg = schoolwork12.app.student.errorMessages.timesViewedQualifier;
                                return false;
                            }
                            return true;

                    }

                    var isValidMessageDateAndQualifiers = function(){
                        console.info("Validating Messaged fields");
                        var validate= true;
                        if($scope.student.isMessagedChecked ){
                            if (!$scope.student.isMessagedAcademicsChecked && !$scope.student.isMessagedAttendanceChecked
                                && !$scope.student.isMessagedComplianceChecked && !$scope.student.isMessagedEngagementChecked && !$scope.student.isMessagedStStartChecked 
                                && !$scope.student.isMessagedSpeProgramChecked && !$scope.student.isMessagedTestChecked)  {
                                 $scope.searchErrorOccurred = true;
                                 $scope.searchErrorMesg =  schoolwork12.app.student.errorMessages.messagedSubcategories;
                                 validate = false;
                                 return validate;
                            }else {                              
                                angular.forEach($scope.student.messaged, function(value, key){

                                        var index =  key.indexOf("Qualifier"); 
                                        if(index && index>0){//if it is a Qualifier field
                                            var uivarname=key;
                                            var name = key.substring(0,index);//substract field name whithout Qualifier substring
                                            var noDateValue="no "+name;
                                           var datafield = $filter('filter')($scope.dataFieldListbySchools, {'uivarname':name},  true);

                                            if($scope.student.messaged[name]  || $scope.student.messaged[uivarname] || $scope.studentSearchForm[name]) {
                                                if ($scope.studentSearchForm[name]  && !$scope.studentSearchForm[name].$valid) {
                                                    $scope.searchErrorOccurred = true;
                                                    $scope.searchErrorMesg =  " A valid date (MM/DD/YYYY) must be entered to search the "+datafield[0].name+ " field by date.";
                                                    validate = false;
                                                    return validate;
                                                } else if($scope.student.messaged && $scope.student.messaged[name] != null &&  !$scope.student.messaged[uivarname] && $scope.student.messaged[name] != ''){
                                                    $scope.searchErrorOccurred = true;
                                                    $scope.searchErrorMesg =" Select "+ datafield[0].name +" qualifier";
                                                    validate = false;
                                                    return validate;
                                                }  else if ($scope.student.messaged && ($scope.student.messaged[name] == null || $scope.student.messaged[name] == '') &&
                                                    $scope.student.messaged[uivarname] != null && $scope.student.messaged[uivarname] != ''
                                                    && $scope.student.messaged[uivarname] != noDateValue) {
                                                    $scope.searchErrorOccurred = true;
                                                    $scope.searchErrorMesg =" Specified a "+ datafield[0].name+" Qualifier but the "+ datafield[0].name+ " value is empty.";
                                                    validate = false;
                                                    return validate;
                                                }
                                            }
                                        }                                                                                                 
                                                
                                } );      
                            }
                        }
                        return validate;
                    }
                    

                    $scope.isEnableFollowUpActionDate = function() {
                        if (!$scope.student.actionNeeded.followUpActionQualifier || $scope.student.actionNeeded.followUpActionQualifier == 'no action') {
                            $scope.student.actionNeeded.followUpActionDate = undefined;
                            return true;
                        }
                        return false;
                    }

                    $scope.isDisabledFASTFields = function(qualifier, path) {
                        if (qualifier && (qualifier === 'prior' || qualifier === 'is' || qualifier === 'after')) {
                            return false;
                        }
                        if (qualifier || qualifier==='') {
                            $scope.student.fast[path]= '';
                        }
                        return true;
                    }


                    
                    $scope.isEnableFastRunningNoteDate = function() {
                        if (!$scope.student.fast.fastRunningNoteQualifier || $scope.student.fast.fastRunningNoteQualifier == 'no note') {
                            $scope.student.fast.fastRunningNoteDate = undefined;
                            return true;
                        }
                        return false;
                    }
                    
                    $scope.isEnableTeacherCompliancyNoteDate = function() {
                        if (!$scope.student.fast.teacherCompliancyNoteQualifier || $scope.student.fast.teacherCompliancyNoteQualifier == 'no note') {
                            $scope.student.fast.teacherCompliancyNoteDate = undefined;
                            return true;
                        }
                        return false;
                    }

                    $scope.isEnableReRegLastModDate = function() {  
                        if (!$scope.student.reReData || !$scope.student.reReData.reRegLastModDateQualifier || $scope.student.reReData.reRegLastModDateQualifier == 'no re-reg last mod date') {
                           if($scope.student.reReData && $scope.student.reReData.reRegLastModDate)
                                 $scope.student.reReData.reRegLastModDate = undefined;
                            return true;
                        }
                        return false;
                    }

                    $scope.isEnableReRegApprLastModDate = function() {
                        if (!$scope.student.reReData || !$scope.student.reReData.reRegApprLastModDateQualifier || $scope.student.reReData.reRegApprLastModDateQualifier == 'no re-reg approval last mod date') {
                           if($scope.student.reReData && $scope.student.reReData.reRegApprLastModDate )
                                 $scope.student.reReData.reRegApprLastModDate = undefined;
                            return true;
                        }
                        return false;
                    }

                    $scope.isShowFollowUpItemKeyword = function() {
                        if (!$scope.student.actionNeeded.followUpItem || $scope.student.actionNeeded.followUpItem != 'keyword') {
                            $scope.student.actionNeeded.followUpItemKeyword = undefined;
                            return false;
                        }
                        return true;
                    }

                    $scope.isEnablePulseCheckDate = function() {
                        if (!$scope.student.pulseCheck || !$scope.student.pulseCheck.qualifier || $scope.student.pulseCheck.qualifier === 'no pulse check') {
                            //Reset Pulse check date value
                            if ($scope.student.pulseCheck && $scope.student.pulseCheck.mostRecentPulseCheckDate) {
                                $scope.student.pulseCheck.mostRecentPulseCheckDate = undefined;
                            }
                            return true;
                        }
                        return false;
                    }

                    $scope.isDisableEngagementFields = function(qualifier, path) {
                        if (qualifier && (qualifier === 'prior' || qualifier === 'is' || qualifier === 'after')) {
                            return false;
                        }
                        if (qualifier) {
                            $scope.student.engagement[path] = undefined;
                        }
                        return true;
                    }

                    $scope.isDisableAttendanceFields = function(qualifier, path) {
                        if (qualifier && (qualifier === 'prior' || qualifier === 'is' || qualifier === 'after')) {
                            return false;
                        }
                        if (qualifier) {
                            $scope.student.attendance[path] = undefined;
                        }
                        return true;
                    }                    

                    $scope.isDisableGradPlanFields = function(qualifier, path) {
                        if (qualifier && (qualifier === 'prior' || qualifier === 'is' || qualifier === 'after')) {
                            return false;
                        }
                        if (qualifier) {
                            $scope.student.gradPlan[path] = undefined;
                        }
                        return true;
                    }

                    $scope.isShowDiplomaAssignedName = function() {
                        if (!$scope.student.gradPlan.diplomaAssigned || $scope.student.gradPlan.diplomaAssigned != 'name') {
                            $scope.student.gradPlan.diplomaAssignedName = undefined;
                            return false;
                        }
                        return true;
                    }

                    $scope.isDisablePulseCheckFields = function(qualifier, path) {
                        if (qualifier && (qualifier === 'prior' || qualifier === 'is' || qualifier === 'after')) {
                            return false;
                        }
                       
                        $scope.student.pulseCheck[path] = undefined;
                        return true;
                    }

                   
                    $scope.isDisableMessagedFields = function(qualifier, path) {
                        if (qualifier && (qualifier === 'prior' || qualifier === 'is' || qualifier === 'after')) {
                            return false;
                        }
                        if (qualifier || qualifier==='') {
                            $scope.student.messaged[path] = '';
                        }
                        return true;
                    }
                    /*$scope.isEnableDatePicker = function(qualifier, path){
                        if(qualifier && (qualifier === 'prior' || qualifier === 'is' || qualifier === 'after')){
                            return false;
                        }
                        //Avoid traversing JSON when qualifier is UNDEFINED
                        if(qualifier){
                            var student = {engagement : {
                                                        lastStudentLoginQualifier: 'is', 
                                                        lastStudentLoginDate :'date'
                                                        }
                                          }
                            //Ideally add this functionality to onchange event. Whenever the 
                            //form is changed the method in ng-disabled gets called and it unnecessarily 
                            //sets the object value to undefined.
                            var a = $scope.traverseJSONObject(student, path) 
                            if(a){
                              //a = !a || undefined;
                              a = undefined;  
                            } 
                        }
                        return true;
                    }
                            
                    //TODO: Test the function for strings
                    $scope.traverseJSONObject = function (json, path) {
                                path = path || '';
                                json = json || {};
                                var parts = path.split('.');
                                    if (parts.length > 1 && typeof json[parts[0]] === 'object') {
                                        return traverseJSONObject(json[parts[0]], parts.splice(1).join('.'));
                                    } else if (json[parts[0]] === undefined){
                                        return undefined;
                                    } else {
                                        return json['engagement'];
                                    }
                                } */

                    $scope.resetForm = function() {
                        console.info("Resetting student search form..");
                        $scope.student = angular.copy(studentCopy);
                        resetCategoriesFlags();
                        $scope.resetFastData();
                             $scope.resetMessagedAcademicsData();
                            $scope.resetMessagedAttendanceData();
                            $scope.resetMessagedComplianceData();
                            $scope.resetMessagedEngagementData();
                            $scope.resetMessagedSpeProgramData();
                            $scope.resetMessagedStStartData();
                            $scope.resetMessagedTestData();
                        $scope.saveOrUpdateModal = false;
                        $scope.selectedSearchItem = {};
                        $scope.studentSearchForm.$setPristine();
                        getMTSSLevels();
                    }

                    $scope.modifyInputToCSV = function() {
                        // Remove white spaces and new line
                        // characters
                        // convert input to comma separated string.
                        var input = $scope.student.studentId;
                        input = input.replace(/\n/g, " ").replace(
                            / +/g, " ").replace(/[ ,]+/g, ",");
                        $scope.student.studentId = input;
                    };

                    $scope.checkStudentIdList = function(
                        responseData) {
                        // create response studentId Array
                        if ($scope.student.studentId != null &&
                            $scope.student.studentId != "") {
                            var studentInputArray = [];
                            var studentMisMatchArray = [];
                            var studentMisMatchUniqueArray = [];
                            studentInputArray = $scope.student.studentId
                                .split(",");
                            if (studentInputArray[0] != "" ||
                                studentInputArray[1] != "") {
                                studentMisMatchArray = studentInputArray
                                    .sort();
                                // Remove Duplicates and empty from
                                // input
                                // console.info(studentMisMatchArray);
                                for (var j = 0; j < studentMisMatchArray.length; j++) {
                                    if (studentMisMatchUniqueArray
                                        .indexOf(studentMisMatchArray[j]) == -1 &&
                                        studentMisMatchArray[j] != "" &&
                                        studentMisMatchArray[j] != null) {
                                        studentMisMatchUniqueArray
                                            .push(studentMisMatchArray[j]);
                                    }
                                }
                                // console.info(studentMisMatchUniqueArray);
                                var index;
                                for (var i = 0; i < responseData.length; i++) {
                                    index = studentMisMatchUniqueArray
                                        .indexOf(responseData[i].studentId
                                            .toString());
                                    if (index > -1) {
                                        studentMisMatchUniqueArray
                                            .splice(index, 1);
                                    }
                                }
                                if (studentMisMatchUniqueArray.length > 0) {
                                    for (var k = 0; k < studentMisMatchUniqueArray.length; k++) {
                                        if (studentMisMatchUniqueArray[k] != null &&
                                            studentMisMatchUniqueArray[k] != "") {
                                            $scope.invalidStudentIdExists = true;
                                            $scope.invalidStudentIdArray = studentMisMatchUniqueArray;
                                            break;
                                        }
                                    }
                                }
                                // console.log(studentMisMatchArray);
                            }

                        }

                    };

                    $scope.gridColumnVisibility = function() {
                        var key, obj, val, categoryFlag;
                        var suppressedColumns = [];
                        for (key in $scope.gridOptions.columnDefs) {
                            obj = $scope.gridOptions.columnDefs[key];

                            //match against id's for dynamic att fields
                            val = obj['id'] ? obj['id'] : obj['field'];
                            
                            switch (val) {
                                case 1:  //consecutiveDaysAbsent
                                case 2:  //absentSchoolDays
                                case 3:  //excusedAbsences
                                case 4:  //daysAbsent
                                case 5:  //missing4Sem
                                case 6:  //attMissing4Week
                                case 7:  //attMissingLast7Days
                                case 8:  //missingHrs
                                case 9:  //attHrsMissing4Week
                                case 10: //firstDayAttModified
                                case 11: //attendance1stDay
                                case 12: //attendanceLastDay
                                case 13: //percentAttended
                                case 14: //att4Sem
                                case 15: //att4Week
                                case 16: //daysPresent
                                case 17: //totalHrs
                                case 18: //attHrs4Week
                                case 19: //attLast7Days
                                case 20: //totalDaysEnrolled
                                case 21: //makeupDays
                                case 22: //missingOverHrs
                                case 23: //totalOfflinetime
                                case 24: //totalOnlineTime
                                case 25: //truancyDate
                                case 26: //lastLesson
                                case 39: //nonConfirmedAbsences
                                case 40: //lcOnlyDays
                                case 41: //unexcusedAbsenceDays
                                case 42: //unexcusedAbsences
                                case 43: //excusedHrs
                                case 44: //unexcusedHrs
                                case 95: //unexcusedHrs
                                case 96: //unexcusedHrs
                                case 97: //unexcusedHrs
                                case 98: //unexcusedHrs
                                case 99: //unexcusedHrs
                   
                               var isColumnShown = _.contains(dataFieldIdList, val);

	                                obj.visible = obj.enableHiding = isColumnShown && $scope.student.isAttendanceChecked && $scope.hasAttendanceSchoolAccess;
                                    if (!$scope.hasAttendanceSchoolAccess || !isColumnShown) {
                                        suppressedColumns.push(obj['field']);
                                    }
                                    break;
                                case 'elaInstrLvl':
                                case 'mathInstrLvl':
                                case 'scienceInstrLvl':
                                case 'ssHistoryInstrLvl':
                                case 'writingInstrLvl':
                                    obj.visible = obj.enableHiding = $scope.student.isInstrLevelsChecked;
                                    break;
                                
                                case 'elaMtssLvlId':
                                case 'mathMtssLvlId':
                                case 'scienceMtssLvlId':
                                case 'ssHistoryMtssLvlId':
                                case 'elaMtssLvlModifyDate':
                                case 'mathMtssLvlModifyDate':
                                case 'scienceMtssLvlModifyDate':
                                case 'ssHistoryMtssLvlModifyDate':
                                obj.visible = obj.enableHiding = $scope.student.isMTSSLevelsChecked;
                                    break;    
                                    
                                //Bing display of Grad Plan fields to checkbox isGradPlanChecked
                                case 'diplomaName':
                                case 'gradPlanCohortYear':
                                case 'cohortYear':
                                case 'creditsRequired':
                                case 'creditsEarned':
                                case 'creditsNeededGrad':
                                case 'creditsInProgress':
                                case 'creditsNeeded':
                                case 'planLastModifiedDate':  
                                case 'readyStuView' : 
                                case 'firstAccDate':
                                case 'lastAccDate': 
                                case 'timesViewed':                         
                                	obj.visible = obj.enableHiding = $scope.student.isGradPlanChecked;
                                    break;
                                    //Bind display of Strong Start fields to checkbox isStrongStartChecked        
                                case 'dsp': //fallthrough
                                case 'walkToClassAttempt': //fallthrough
                                case 'walkToClassResult': //fallthrough
                                case 'walkToClassFlwUp': //fallthrough
                                case 'welcomeNote': //fallthrough
                                case 'fastConnectionCall':
                                case 'orientatnSesnAtndnce': //fallthrough
                                case 'ollCmplt': //fallthrough
                                case 'fstNbrdngClsrmTchr':
                                    obj.visible = obj.enableHiding = $scope.student.isStrongStartChecked;
                                    break;
                                case 'hrTeacher':                                    
                                case 'familyId':                                    
                                case 'enrollReceivedDate':                                    
                                case 'enrollApprovedDate':                                    
                                case 'schoolEnrollDate':                                    
                                case 'schoolWithdrawDate':                                    
                                case 'fullTime':                                    
                                case 'fundingModel':                                    
                                case 'fte':                                    
                                case 'specialPrograms':
                                case 'homePhone':
                                case 'participantPrograms':
                                case 'ctePathway':
                                case 'futureCtePathway':
                                case 'futureStartDate':
                                    obj.visible = obj.enableHiding = $scope.student.isDemoDataChecked;
                                    break;
                                case 'familyLanguage':
                                    obj.visible = obj.enableHiding = $scope.student.isDemoDataChecked;
                                    break;
                                case 'studentLanguage':
                                    obj.visible = obj.enableHiding = $scope.student.isDemoDataChecked;
                                    break;
                                case 'counselor':
                                    obj.visible = obj.enableHiding = $scope.student.isDemoDataChecked;
                                    break;
                                case 'stdntLastLogin': //fallthrough
                                case 'LCLastLogin': //fallthrough
                                case 'stdntLst7DaysActvty': //fallthrough
                                case 'CCSesnsAtndLast30Days': //fallthrough
                                case 'CCAtndnceThisYr': //fallthrough
                                case 'BOTCCAtndnceThisYr': //fallthrough
                                case 'BOTCCSesnsAttndedYr': //fallthrough
                                case 'lastContact':
                                    obj.visible = obj.enableHiding = $scope.student.isEngagementChecked;
                                    break;
                                case 'fastRunningNoteLstMdfdDt':
                                case 'fastReferralClassroomTeacher':
                                case 'enduringConnectnCall':	
                                case 'tchrCompliancyNoteMdfdDt':
                                    obj.visible = obj.enableHiding = $scope.student.isFASTChecked;
                                    break;
                                case 'mostRecentPulseChk': //fallthrough
                                case 'surveyNumber': //fallthrough
                                case 'pulseChkStsfctnRtng': //fallthrough
                                case 'pulseChkPrprtnRtng': //fallthrough
                                case 'pulseChkKeepUp': //fallthrough
                                case 'plsCheckStuSucRat': //fallthrough
                                case 'pulseChkReRegRtng': //fallthrough
                                case 'pulseChkReasonReReg':
                                case 'rqstedContact': //fallthrough
                                case 'areasOfIssue': //fallthrough
                                case 'openEndComments': //fallthrough
                                case 'pulseChkFlwUpNeeded': //fallthrough
                                case 'pulseChkFlwUp':
                                    obj.visible = obj.enableHiding = $scope.student.isPulseCheckChecked;
                                    break;
                                case 27: //'reReStatus':
                                case 28: //'reRegLastModDate':
                                case 29: //'reRegAprovalStatus':                                
                                case 30: //'reRegApprLastModDate':
                                case 33: //'reRegLastMailTemplate':
                                case 34: //'reRegLastNoteTemplate':
                                case 32: //'reRegInfoSession':
                                case 31: //'reRegIOLCC':
                                    var isColumnShown = _.contains(dataFieldIdList, val);
                                    obj.visible = obj.enableHiding = isColumnShown && $scope.student.isReRegistrationChecked ;
                                    if ( !isColumnShown) {
                                        suppressedColumns.push(obj['field']);
                                    }                                        
                                    break;
                                case 'followupItem':
                                case 'followupAction':
                                case 'followupAssigned':
                                    obj.visible = obj.enableHiding = $scope.student.isActionNeededChecked;
                                    break;
                                case 45://admicIntCon
                                case 46://gradTrack
                                case 47://lowProgr
                                case 48://retentCon
                                    var isColumnShown = _.contains(dataFieldIdList, val);
                                    obj.visible = obj.enableHiding = isColumnShown && $scope.student.isMessagedAcademicsChecked;
                                    if ( !isColumnShown) {
                                        suppressedColumns.push(obj['field']);
                                    }                                        
                                    break;   
                                case 49://DaysAbs10plus
                                case 50://daysAbs1
                                case 51://daysAbs2
                                case 52://daysAbs3
                                case 53://daysAbs4
                                case 54://daysAbs5
                                case 55://daysAbs6
                                case 56://daysAbs7
                                case 57://daysAbs8
                                case 58://daysAbs9
                                case 59://daysAbs10
                                case 60://daysAbs11
                                case 61://daysAbs12
                                case 62://daysAbs13
                                case 63://daysAbs14
                                case 64://daysAbs15
                                case 65://daysAbs16
                                case 66://daysAbs17
                                case 67://daysAbs18
                                case 68://daysAbs19
                                case 69://daysAbs20
                                case 70://actNoAtt
                                case 71://behindHrs
                                case 72://excAbbNot
                                case 73://goodAtt
                                case 74://missMoreAttNot
                                case 75://nonEmailCont
                                    var isColumnShown = _.contains(dataFieldIdList, val);
                                    obj.visible = obj.enableHiding = isColumnShown && $scope.student.isMessagedAttendanceChecked;
                                    if ( !isColumnShown) {
                                        suppressedColumns.push(obj['field']);
                                    }                                        
                                    break; 
                                case 76://compDocNeed
                                case 77://compuApp
                                case 78://famIncForm
                                case 79://phoneNumUpdate
                                    var isColumnShown = _.contains(dataFieldIdList, val);
                                    obj.visible = obj.enableHiding = isColumnShown && $scope.student.isMessagedComplianceChecked;
                                    if ( !isColumnShown) {
                                        suppressedColumns.push(obj['field']);
                                    }                                        
                                    break;                                
                                case 80://behaviorCon
                                case 81://couLockCommu
                                case 82://limitedAct
                                case 83://lowCCAtt
                                case 84://noLogin
                                case 85://winbackCall
                                case 86://engPlanCall
                                    var isColumnShown = _.contains(dataFieldIdList, val);
                                    obj.visible = obj.enableHiding = isColumnShown && $scope.student.isMessagedEngagementChecked;
                                    if ( !isColumnShown) {
                                        suppressedColumns.push(obj['field']);
                                    }                                        
                                    break; 
                                case 87://meeting504
                                case 88://iEPMeeting
                                case 89://irip
                                case 90://tieredInst
                                    var isColumnShown = _.contains(dataFieldIdList, val);
                                    obj.visible = obj.enableHiding = isColumnShown && $scope.student.isMessagedSpeProgramChecked;
                                    if ( !isColumnShown) {
                                        suppressedColumns.push(obj['field']);
                                    }                                        
                                    break;                                
                                case 91://missStuConn
                                case 92://orientation
                                case 93://onboarding
                                    var isColumnShown = _.contains(dataFieldIdList, val);
                                    obj.visible = obj.enableHiding = isColumnShown && $scope.student.isMessagedStStartChecked;
                                    if ( !isColumnShown) {
                                        suppressedColumns.push(obj['field']);
                                    }                                        
                                    break;
                                case 94://stateTestAssign
                                    var isColumnShown = _.contains(dataFieldIdList, val);
                                    obj.visible = obj.enableHiding = isColumnShown && $scope.student.isMessagedTestChecked;
                                    if ( !isColumnShown) {
                                        suppressedColumns.push(obj['field']);
                                    }                                                                       
                                    break;
                            }                                                        
                        }
                        $scope.gridOptions.exporterSuppressColumns = suppressedColumns;
                    }

                    $scope.getStudentCategories = function() {
                        var categories = [];
                        $scope.student.isInstrLevelsChecked ? categories.push("instrlevels") : '';
                        $scope.student.isMTSSLevelsChecked?categories.push("mtsslevels") : '';
                        $scope.student.isStrongStartChecked ? categories.push("strongstart") : '';
                        $scope.student.isEngagementChecked ? categories.push("engagement") : '';
                        $scope.student.isDemoDataChecked ? categories.push("demographic") : '';
                        $scope.student.isActionNeededChecked ? categories.push("actionneeded") : '';
                        $scope.student.isPulseCheckChecked ? categories.push("pulse") : '';
                        $scope.student.isFASTChecked ? categories.push("fast") : '';
                        $scope.student.isGradPlanChecked ? categories.push("gradplan") : '';
                        $scope.student.isAttendanceChecked ? categories.push("attendance") : '';
                        $scope.student.isReRegistrationChecked ?  categories.push("reregistration") : '';
                        $scope.student.isMessagedChecked ?  categories.push("messaged") : '';
                        $scope.student.isMessagedAcademicsChecked ?  categories.push("messagedAcademics") : '';
                        $scope.student.isMessagedAttendanceChecked ?  categories.push("messagedAttendance") : '';
                        $scope.student.isMessagedComplianceChecked ?  categories.push("messagedCompliance") : '';
                        $scope.student.isMessagedEngagementChecked ?  categories.push("messagedEngagement") : '';
                        $scope.student.isMessagedSpeProgramChecked ?  categories.push("messagedSpeProgram") : '';
                        $scope.student.isMessagedStStartChecked ?  categories.push("messagedStStart") : '';
                        $scope.student.isMessagedTestChecked ?  categories.push("messagedTest") : '';

                        return categories;
                    }

                    var resetErrorFlags = function() {
                        // Control Error messages above the grid
                        $scope.searchErrorMesg = "";
                        $scope.searchErrorOccurred = false;
                        // Control Growl Error messages
                        $scope.actionErrorMesg = "";
                        $scope.actionErrorOccurred = false;
                        $scope.actionErrorObjects = "";
                        //Control Growl Success messages
                        $rootScope.assignedDiplomaSuccessfully = false;
                        $rootScope.closeSuccessClick = false;
                        // Control the success messages of every bulk action
                        $rootScope.actionCompletedSuccessfully = false;
                        $rootScope.actionCompletedSuccessfullyMessage = '';
                    }
                   var diplomaSearch = function(selectedStds)
                   {
                    $http({
                        method: "POST",
                        url: schoolwork12.app.student.endpoints.diplomaSearch,
                        data: {
                            "studentSchoolList": selectedStds
                        },
                        headers: {
                            'X-API-TOKEN': authentication.getCurrentUser().keycode,
                        }
                    })
                    .then(
                        function(response) {
                            //invoke studentAssignGradPlan service
                            $scope.isActionSpinnerActive = false;
                            studentAssignGradPlan.service(response, selectedStds);
                            console.info("Retrieved: " + response.data.length + " diplomas");
                        },
                        function(error) {
                            $scope.isActionSpinnerActive = false;
                            console.log('assignedDiplomaSuccessfully', error)
                            if (error.status == 400) {
                                $scope.actionErrorOccurred = true;
                                for (var j = 0; j < error.data._errors.length; j++) {
                                    $scope.actionErrorMesg = $scope.actionErrorMesg + error.data._errors[j] + "\n";
                                }
                                if (angular.isDefined(error.data.errObjects) && error.data.errObjects != null) {
                                    var errObjs = "";
                                    for (var k = 0; k < error.data.errObjects.length; k++) {
                                        if (errObjs.length != 0) {
                                            errObjs = errObjs + ", ";
                                        }
                                        errObjs = errObjs + error.data.errObjects[k];
                                    }
                                    $scope.actionErrorObjects = errObjs;
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.searchErrorOccurred = true;
                                $scope.searchErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.searchErrorOccurred = true;
                                $scope.searchErrorMesg = schoolwork12.app.errorMessages.internalError;
                            }
                        });
                }

                }
            ]).filter('percentage', function() {
                return function(input) {
                    if (isNaN(input))
                        return input;
                    else {
                        return input + "%";
                    }
                };
            });
    /*.filter('fteFilter', function () {
        var re = /^\d*(\.\d*)+/;
        return function (value, scope) {
            if(!(typeof value == 'number')){
                var str_number = value.replace(',', '.');
                value = re.test(str_number) ? parseFloat(str_number) : value;
                scope.row.entity.fte = value;
            }
            return value;
        };
    })*/

    //Do not add animation to ui-grid-menu class. This fixes ui-grid menus sticking to the browser.
    angApp.config([
        '$animateProvider',
        function($animateProvider) {
            $animateProvider.classNameFilter(/^((?!(ui-grid-menu)).)*$/);
        }
    ]);

}(angular, schoolwork12));